export default {
  "de-DE": {
    "101001": "Marth",
    "101002": "Shiida",
    "101003": "Jagen",
    "101004": "Kain",
    "101005": "Abel",
    "101006": "Edrag",
    "101007": "Gordin",
    "101008": "Wrys",
    "101009": "Ogma",
    "101010": "Barst",
    "101011": "Bord",
    "101012": "Cord",
    "101013": "Castor",
    "101014": "Darros",
    "101015": "Julian",
    "101016": "Lena",
    "101017": "Nabarl",
    "101018": "Merric",
    "101019": "Matthis",
    "101020": "Hardin",
    "101021": "Wolf",
    "101022": "Sedgar",
    "101023": "Roshea",
    "101024": "Vyland",
    "101025": "Wendell",
    "101026": "Rickard",
    "101027": "Bantu",
    "101028": "Caesar",
    "101029": "Radd",
    "101030": "Roger",
    "101031": "Jeorge",
    "101032": "Maria",
    "101033": "Minerva",
    "101034": "Linde",
    "101035": "Jake",
    "101036": "Midia",
    "101037": "Dolph",
    "101038": "Macellan",
    "101039": "Tomas",
    "101040": "Boran",
    "101041": "Beck",
    "101042": "Astram",
    "101043": "Palla",
    "101044": "Catria",
    "101045": "Arran",
    "101046": "Samson",
    "101047": "Xane",
    "101048": "Est",
    "101049": "Tiki",
    "101050": "Lorenz",
    "101051": "Elice",
    "101052": "Gotoh",
    "101053": "Frey",
    "101054": "Norne",
    "101055": "Athena",
    "101056": "Horace",
    "101057": "Etzel",
    "101058": "Ymir",
    "101059": "Nagi",
    "101060": "Malledus",
    "101061": "Nyna",
    "101062": "Gharnef",
    "101063": "Camus",
    "101064": "Michalis",
    "101065": "Medeus",
    "101066": "Anna",
    "102001": "Alm",
    "102002": "Lukas",
    "102003": "Gray",
    "102004": "Tobin",
    "102005": "Kliff",
    "102006": "Silque",
    "102007": "Clair",
    "102008": "Clive",
    "102009": "Forsyth",
    "102010": "Python",
    "102011": "Celica",
    "102012": "Mae",
    "102013": "Boey",
    "102014": "Genny",
    "102015": "Saber",
    "102016": "Valbar",
    "102017": "Kamui",
    "102018": "Leon",
    "102019": "Luthier",
    "102020": "Mathilda",
    "102021": "Delthea",
    "102022": "Palla",
    "102023": "Catria",
    "102024": "Atlas",
    "102025": "Jesse",
    "102026": "Deen",
    "102027": "Sonya",
    "102028": "Est",
    "102029": "Nomah",
    "102030": "Tatiana",
    "102031": "Zeke",
    "102032": "Mycen",
    "102033": "Desaix",
    "102034": "Grieth",
    "102035": "Rudolf",
    "102036": "Faye",
    "102037": "Clive",
    "102038": "Conrad",
    "102039": "Berkut",
    "102040": "Rinea",
    "102041": "Fernand",
    "102042": "Jedah",
    "102043": "Slayde",
    "102044": "Massena",
    "102045": "Lawson",
    "102046": "Jerome",
    "102047": "Tatarrah",
    "102048": "Dolth",
    "102049": "Nuibaba",
    "102050": "Hestia",
    "102051": "Marla",
    "102052": "Barth",
    "102053": "Garth",
    "102054": "Blake",
    "102055": "Mila",
    "102056": "Duma",
    "102057": "Banditenanführer",
    "102058": "Halcyon",
    "102059": "Irma",
    "103001": "Marth",
    "103002": "Kris (männlich)",
    "103003": "Kris (weiblich)",
    "103004": "Abel",
    "103005": "Arran",
    "103006": "Astram",
    "103007": "Bantu",
    "103008": "Barst",
    "103009": "Beck",
    "103010": "Vyland",
    "103011": "Boran",
    "103012": "Xane",
    "103013": "Darros",
    "103014": "Edrag",
    "103015": "Elice",
    "103016": "Est",
    "103017": "Gotoh",
    "103018": "Gordin",
    "103020": "Jagen",
    "103021": "Jake",
    "103022": "Jeorge",
    "103023": "Julian",
    "103024": "Kain",
    "103025": "Castor",
    "103026": "Catria",
    "103027": "Cord",
    "103028": "Maria",
    "103029": "Merric",
    "103030": "Matthis",
    "103031": "Midia",
    "103032": "Minerva",
    "103033": "Macellan",
    "103034": "Nabarl",
    "103035": "Ogma",
    "103036": "Palla",
    "103037": "Radd",
    "103038": "Lena",
    "103039": "Rickard",
    "103040": "Wrys",
    "103041": "Linde",
    "103042": "Roger",
    "103043": "Lorenz",
    "103044": "Roshea",
    "103045": "Bord",
    "103046": "Samson",
    "103047": "Caesar",
    "103048": "Shiida",
    "103049": "Tomas",
    "103050": "Tiki",
    "103051": "Dolph",
    "103052": "Wendell",
    "103053": "Wolf",
    "103054": "Sedgar",
    "103055": "Frey",
    "103056": "Norne",
    "103057": "Athena",
    "103058": "Horace",
    "103059": "Etzel",
    "103060": "Ymir",
    "103061": "Nagi",
    "103062": "Nyna",
    "103063": "Katarina",
    "103064": "Roderick",
    "103065": "Cecil",
    "103066": "Yuliya",
    "103067": "Jubelo",
    "103068": "Lang",
    "103069": "Hardin",
    "103070": "Luke",
    "103071": "Marisha",
    "103072": "Ryan",
    "103073": "Sirius",
    "103074": "Samuel",
    "103075": "Warren",
    "103076": "Sheena",
    "103077": "Phina",
    "103078": "Arlen",
    "103079": "Frost",
    "103080": "Malice",
    "103081": "Dice",
    "103082": "Reiden",
    "103083": "Belf",
    "103084": "Roberto",
    "103085": "Gharnef",
    "103086": "Camus",
    "103087": "Michalis",
    "103088": "Legion",
    "103089": "Clarisse",
    "103090": "Eremiya",
    "103091": "Medeus",
    "103092": "Anna",
    "104001": "Sigurd",
    "104002": "Naoise",
    "104003": "Alec",
    "104004": "Arden",
    "104005": "Midir",
    "104006": "Edain",
    "104007": "Brigid",
    "104008": "Azelle",
    "104009": "Claud",
    "104010": "Tailtiu",
    "104011": "Lex",
    "104012": "Quan",
    "104013": "Ethlyn",
    "104014": "Finn",
    "104015": "Ayra",
    "104016": "Jamke",
    "104017": "Lewyn",
    "104018": "Erinys",
    "104019": "Lachesis",
    "104020": "Seliph",
    "104021": "Oifey",
    "104022": "Shannan",
    "104023": "Ulster",
    "104024": "Larcei",
    "104025": "Lana",
    "104026": "Diarmuid",
    "104027": "Lester",
    "104028": "Leif",
    "104029": "Finn",
    "104030": "Nanna",
    "104031": "Tine",
    "104032": "Patty",
    "104033": "Febail",
    "104034": "Arthur",
    "104035": "Fee",
    "104036": "Ced",
    "104037": "Altena",
    "104038": "Hannibal",
    "104039": "Coirpre",
    "104040": "Julia",
    "104041": "Ares",
    "104042": "Lene",
    "104043": "Dalvin",
    "104044": "Creidne",
    "104045": "Muirne",
    "104046": "Tristan",
    "104047": "Deimne",
    "104048": "Jeanne",
    "104049": "Linda",
    "104050": "Daisy",
    "104051": "Asaello",
    "104052": "Amid",
    "104053": "Hermina",
    "104054": "Hawk",
    "104055": "Charlot",
    "104056": "Laylea",
    "104057": "Eldigan",
    "104058": "Cimbaeth",
    "104059": "Munnir",
    "104060": "Sandima",
    "104062": "Chagall",
    "104063": "Annand",
    "104064": "Byron",
    "104065": "Andrey",
    "104066": "Lombard",
    "104067": "Reptor",
    "104068": "Aida",
    "104069": "Arvis",
    "104070": "Danann",
    "104071": "Kutuzov",
    "104072": "Ishtore",
    "104073": "Bloom",
    "104074": "Travant",
    "104075": "Brian",
    "104076": "Scipio",
    "104077": "Hilda",
    "104078": "Ishtar",
    "104079": "Arion",
    "104080": "Manfroy",
    "104081": "Julius",
    "104082": "Dew",
    "104083": "Deirdre",
    "104084": "Chulainn",
    "104085": "Silvia",
    "104086": "Beowolf",
    "104087": "Iuchar",
    "104088": "Iucharba",
    "105001": "Leif",
    "105002": "Finn",
    "105003": "Eyvel",
    "105004": "Halvan",
    "105005": "Osian",
    "105006": "Dagdar",
    "105007": "Tanya",
    "105008": "Marty",
    "105009": "Ronan",
    "105010": "Lifis",
    "105011": "Safy",
    "105012": "Brighton",
    "105013": "Machyua",
    "105014": "Lara",
    "105015": "Fergus",
    "105016": "Karin",
    "105017": "Dalsin",
    "105018": "Asbel",
    "105019": "Nanna",
    "105020": "Hicks",
    "105021": "Shiva",
    "105022": "Carrion",
    "105023": "Selphina",
    "105024": "Kain",
    "105025": "Alva",
    "105026": "Robert",
    "105027": "Fred",
    "105028": "Olwen",
    "105029": "Mareeta",
    "105030": "Salem",
    "105031": "Perne",
    "105032": "Tina",
    "105033": "Troude",
    "105034": "Glade",
    "105035": "Deen",
    "105036": "Eda",
    "105037": "Homer",
    "105038": "Linoan",
    "105039": "Ralf",
    "105040": "Ilios",
    "105041": "Sleuf",
    "105042": "Sara",
    "105043": "Miranda",
    "105044": "Shannam",
    "105045": "Misha",
    "105046": "Xavier",
    "105047": "Amalda",
    "105048": "Conomor",
    "105049": "Diarmuid",
    "105050": "Saias",
    "105051": "Ced",
    "105052": "Galzus",
    "105053": "Kempf",
    "105054": "Reinhardt",
    "105055": "Raydrik",
    "105056": "Veld",
    "106001": "Roy",
    "106002": "Marcus",
    "106003": "Alen",
    "106004": "Lance",
    "106005": "Wolt",
    "106006": "Bors",
    "106007": "Merlinus",
    "106008": "Elen",
    "106009": "Dieck",
    "106010": "Lot",
    "106011": "Shanna",
    "106012": "Chad",
    "106013": "Lugh",
    "106014": "Clarine",
    "106015": "Rutger",
    "106016": "Saul",
    "106017": "Dorothy",
    "106018": "Sue",
    "106019": "Zelot",
    "106020": "Trec",
    "106021": "Noah",
    "106022": "Astolfo",
    "106023": "Lilina",
    "106024": "Barthe",
    "106025": "Ogier",
    "106026": "Gwendolyn",
    "106027": "Fir",
    "106028": "Sin",
    "106029": "Geese",
    "106030": "Gonzalez",
    "106031": "Klein",
    "106032": "Thea",
    "106033": "Larum",
    "106034": "Elffin",
    "106035": "Echidna",
    "106036": "Bartre",
    "106037": "Raigh",
    "106038": "Cath",
    "106039": "Melady",
    "106040": "Perceval",
    "106041": "Cecilia",
    "106042": "Sophia",
    "106043": "Igrene",
    "106044": "Garret",
    "106045": "Fae",
    "106046": "Hugh",
    "106047": "Zeiss",
    "106048": "Douglas",
    "106049": "Niime",
    "106050": "Juno",
    "106051": "Dayan",
    "106052": "Yoder",
    "106053": "Karel",
    "106054": "Narcian",
    "106055": "Galle",
    "106056": "Hector",
    "106057": "Brunnya",
    "106058": "Murdock",
    "106059": "Eliwood",
    "106060": "Zephiel",
    "106061": "Guinivere",
    "106062": "Jahn",
    "106063": "Idunn",
    "106064": "Wade",
    "107001": "Lyn",
    "107002": "Sain",
    "107003": "Kent",
    "107004": "Florina",
    "107005": "Wil",
    "107006": "Dorcas",
    "107007": "Serra",
    "107008": "Erk",
    "107009": "Rath",
    "107010": "Matthew",
    "107011": "Nils",
    "107012": "Lucius",
    "107013": "Wallace",
    "107014": "Eliwood",
    "107015": "Marcus",
    "107016": "Lowen",
    "107017": "Rebecca",
    "107018": "Bartre",
    "107019": "Hector",
    "107020": "Oswin",
    "107021": "Guy",
    "107022": "Merlinus",
    "107023": "Priscilla",
    "107024": "Raven",
    "107025": "Canas",
    "107026": "Dart",
    "107027": "Fiora",
    "107028": "Legault",
    "107029": "Ninian",
    "107030": "Isadora",
    "107031": "Heath",
    "107032": "Hawkeye",
    "107033": "Geitz",
    "107034": "Pent",
    "107035": "Louise",
    "107036": "Karel",
    "107037": "Harken",
    "107038": "Nino",
    "107039": "Jaffar",
    "107040": "Vaida",
    "107041": "Renaud",
    "107042": "Athos",
    "107043": "Farina",
    "107044": "Karla",
    "107045": "Leila",
    "107046": "Guinivere",
    "107047": "Zephiel",
    "107048": "Lloyd",
    "107049": "Linus",
    "107050": "Ursula",
    "107051": "Ephidel",
    "107052": "Sonia",
    "107053": "Limstella",
    "107054": "Nergal",
    "108001": "Eirika",
    "108002": "Seth",
    "108003": "Gilliam",
    "108004": "Franz",
    "108005": "Moulder",
    "108006": "Vanessa",
    "108007": "Ross",
    "108008": "Garcia",
    "108009": "Neimi",
    "108010": "Colm",
    "108011": "Artur",
    "108012": "Lute",
    "108013": "Natasha",
    "108014": "Joshua",
    "108015": "Ephraim",
    "108016": "Forde",
    "108017": "Kyle",
    "108018": "Orson",
    "108019": "Tana",
    "108020": "Amelia",
    "108021": "Innes",
    "108022": "Gerik",
    "108023": "Tethys",
    "108024": "Marisa",
    "108025": "L'Arachel",
    "108026": "Dozla",
    "108027": "Saleh",
    "108028": "Ewan",
    "108029": "Cormag",
    "108030": "Rennac",
    "108031": "Duenell",
    "108032": "Knoll",
    "108033": "Myrrh",
    "108034": "Syrene",
    "108035": "Caellach",
    "108036": "Riev",
    "108037": "Ismaire",
    "108038": "Selena",
    "108039": "Glen",
    "108040": "Hayden",
    "108041": "Valter",
    "108042": "Fado",
    "108043": "Lyon",
    "109001": "Ike",
    "109002": "Titania",
    "109003": "Oscar",
    "109004": "Boyd",
    "109005": "Rhys",
    "109006": "Shinon",
    "109007": "Gatrie",
    "109008": "Soren",
    "109009": "Alja",
    "109010": "Rolf",
    "109011": "Greil",
    "109012": "Mia",
    "109013": "Kevin",
    "109014": "Brom",
    "109015": "Nephenee",
    "109016": "Lucia",
    "109017": "Juri",
    "109018": "Geoffrey",
    "109019": "Elincia",
    "109020": "Renning",
    "109021": "Lethe",
    "109022": "Mordecai",
    "109023": "Muarim",
    "109024": "Ranulf",
    "109025": "Giffca",
    "109026": "Caineghis",
    "109027": "Ena",
    "109028": "Nasir",
    "109029": "Gareth",
    "109030": "Kurthnaga",
    "109031": "Deghinsea",
    "109032": "Ajuga",
    "109033": "Janaff",
    "109034": "Tibarn",
    "109035": "Reyson",
    "109036": "Leanne",
    "109037": "Naesala",
    "109038": "Nealuchi",
    "109039": "Marcia",
    "109040": "Stella",
    "109041": "Makalov",
    "109042": "Tormod",
    "109043": "Tanith",
    "109044": "Zelgius",
    "109045": "Sigrun",
    "109046": "Sephiran",
    "109047": "Sanaki",
    "109048": "Jill",
    "109049": "Tauroneo",
    "109050": "Darahan",
    "109051": "Petrine",
    "109052": "Bertram",
    "109053": "Schwarzer Ritter",
    "109054": "Ashnard",
    "109055": "Ilyana",
    "109056": "Volker",
    "109057": "Zihark",
    "109058": "Sothe",
    "109059": "Stefan",
    "109060": "Devdan",
    "109061": "Calill",
    "109062": "Largo",
    "109063": "Elena",
    "110001": "Nolan",
    "110002": "Laura",
    "110003": "Sothe",
    "110004": "Edward",
    "110005": "Micaiah",
    "110006": "Ike",
    "110007": "Izuka",
    "110008": "Ena",
    "110009": "Ilyana",
    "110010": "Danved",
    "110011": "Ajuga",
    "110012": "Elincia",
    "110013": "Oscar",
    "110014": "Oliver",
    "110015": "Volug",
    "110016": "Caineghis",
    "110017": "Gatrie",
    "110018": "Calill",
    "110019": "Kysha",
    "110020": "Rhys",
    "110021": "Kurthnaga",
    "110022": "Kevin",
    "110023": "Gareth",
    "110024": "Sanaki",
    "110025": "Sigrun",
    "110026": "Schwarzer Ritter",
    "110027": "Shinon",
    "110028": "Giffca",
    "110029": "Geoffrey",
    "110030": "Jill",
    "110031": "Skrimir",
    "110032": "Stella",
    "110033": "Soren",
    "110034": "Sephiran",
    "110035": "Zelgius",
    "110036": "Stefan",
    "110037": "Tauroneo",
    "110038": "Tanith",
    "110039": "Brom",
    "110040": "Zihark",
    "110041": "Titania",
    "110042": "Tibarn",
    "110043": "Deghinsea",
    "110044": "Tormod",
    "110045": "Nasir",
    "110046": "Nealuchi",
    "110047": "Nailah",
    "110048": "Naesala",
    "110049": "Nephenee",
    "110050": "Darahan",
    "110051": "Vika",
    "110052": "Volker",
    "110053": "Aran",
    "110054": "Fiona",
    "110055": "Heather",
    "110056": "Hetzel",
    "110057": "Pelleas",
    "110058": "Boyd",
    "110059": "Marcia",
    "110060": "Makalov",
    "110061": "Alja",
    "110062": "Muarim",
    "110063": "Meg",
    "110064": "Mordecai",
    "110065": "Janaff",
    "110066": "Juri",
    "110067": "Rolf",
    "110068": "Ranulf",
    "110069": "Rafiel",
    "110070": "Leanne",
    "110071": "Lyre",
    "110072": "Reyson",
    "110073": "Lucia",
    "110074": "Leonard",
    "110075": "Lethe",
    "110076": "Renning",
    "110077": "Mia",
    "110078": "Anna",
    "110079": "Muston",
    "110080": "Aimee",
    "110081": "Jorge",
    "110082": "Daniel",
    "110083": "Jarod",
    "110084": "Valtome",
    "110085": "Ashunera",
    "110086": "Ashera",
    "110087": "Yune",
    "110089": "Largo",
    "110090": "Amy",
    "110091": "Almedha",
    "111001": "Daraen (männlich)",
    "111002": "Daraen (weiblich)",
    "111003": "Chrom",
    "111004": "Frederick",
    "111005": "Kellam",
    "111006": "Ricken",
    "111007": "Vaike",
    "111008": "Lon'zu",
    "111009": "Virion",
    "111010": "Basilio",
    "111011": "Sumia",
    "111012": "Lissa",
    "111013": "Zelcher",
    "111014": "Miriel",
    "111015": "Maskierter Marth",
    "111016": "Lucina",
    "111017": "Walhart",
    "111018": "Emmeryn",
    "111019": "Validar",
    "111020": "Sully",
    "111021": "Stahl",
    "111022": "Maribelle",
    "111023": "Palne",
    "111024": "Gaius",
    "111025": "Cordelia",
    "111026": "Gregor",
    "111027": "Nowi",
    "111028": "Libra",
    "111029": "Tharja",
    "111030": "Olivia",
    "111031": "Henry",
    "111032": "Say'ri",
    "111033": "Flavia",
    "111034": "Donnel",
    "111035": "Owain",
    "111036": "Íñigo",
    "111037": "Brady",
    "111038": "Kjelle",
    "111039": "Cynthia",
    "111040": "Severa",
    "111041": "Gerome",
    "111042": "Linfan (männlich)",
    "111043": "Linfan (weiblich)",
    "111044": "Yarne",
    "111045": "Laurent",
    "111046": "Noire",
    "111047": "Nah",
    "111048": "Tiki",
    "111049": "Anna",
    "111050": "Aversa",
    "111051": "Priam",
    "111052": "Gangrel",
    "111053": "Yen'fay",
    "111054": "Mustafa",
    "111055": "Cervantes",
    "111056": "Excellus",
    "111057": "Naga",
    "111058": "Grima",
    "112001": "Corrin (männlich)",
    "112002": "Corrin (weiblich)",
    "112003": "Jakob",
    "112004": "Silas",
    "112005": "Kaze",
    "112006": "Ryoma",
    "112007": "Takumi",
    "112008": "Saizo",
    "112009": "Kaden",
    "112010": "Hinata",
    "112011": "Azama",
    "112012": "Subaki",
    "112013": "Hayato",
    "112014": "Xander",
    "112015": "Leo",
    "112016": "Benny",
    "112017": "Keaton",
    "112018": "Arthur",
    "112019": "Odin",
    "112020": "Laslow",
    "112021": "Niles",
    "112022": "Felicia",
    "112023": "Azura",
    "112024": "Mozu",
    "112025": "Hinoka",
    "112026": "Sakura",
    "112027": "Orochi",
    "112028": "Kagero",
    "112029": "Hana",
    "112030": "Setsuna",
    "112031": "Reina",
    "112032": "Oboro",
    "112033": "Camilla",
    "112034": "Elise",
    "112035": "Charlotte",
    "112036": "Effie",
    "112037": "Peri",
    "112038": "Beruka",
    "112039": "Selena",
    "112040": "Nyx",
    "112041": "Kana (weiblich)",
    "112042": "Kana (männlich)",
    "112043": "Shigure",
    "112044": "Dwyer",
    "112045": "Sophie",
    "112046": "Midori",
    "112047": "Shiro",
    "112048": "Kiragi",
    "112049": "Asugi",
    "112050": "Selkie",
    "112051": "Hisame",
    "112052": "Mitama",
    "112053": "Caeldori",
    "112054": "Rhajat",
    "112055": "Siegbert",
    "112056": "Ignatius",
    "112057": "Forrest",
    "112058": "Velouria",
    "112059": "Percy",
    "112060": "Ophelia",
    "112061": "Soleil",
    "112062": "Nina",
    "112063": "Shura",
    "112064": "Fuga",
    "112065": "Yukimura",
    "112066": "Izana",
    "112067": "Gunter",
    "112068": "Nichol",
    "112069": "Rinkah",
    "112070": "Anna",
    "112071": "Scarlet",
    "112072": "Candace",
    "112073": "Flora",
    "112074": "Lilith",
    "112075": "Arete",
    "112076": "Garon",
    "112077": "Sumeragi",
    "112078": "Mikoto",
    "112079": "Iago",
    "112080": "Zola",
    "112081": "Hans",
    "112082": "Layla",
    "112083": "Regenbogenweiser",
    "112084": "Anankos",
    "113001": "Alfonse",
    "113002": "Sharena",
    "113003": "Anna",
    "113004": "Veronica",
    "113005": "Bruno",
    "113006": "Fjorm",
    "113007": "Gunnthrá",
    "113008": "Surtr",
    "113009": "Laevatein",
    "113010": "Loki",
    "113011": "Helbindi",
    "113012": "Laegjarn",
    "113013": "Ylgr",
    "113014": "Hríd",
    "113015": "Eir",
    "113016": "Líf",
    "113017": "Thrasir",
    "113018": "Hel",
    "113019": "Triandra",
    "113020": "Peony",
    "113021": "Plumeria",
    "113022": "Freyr",
    "114001": "Itsuki & Chrom",
    "114002": "Tsubasa & Shiida",
    "114003": "Touma & Kain",
    "114004": "Kiria & Tharja",
    "114005": "Yashiro & Nabarl",
    "114006": "Eleonora & Virion",
    "114007": "Mamori & Edrag",
    "114008": "Maiko",
    "114009": "Tiki",
    "114010": "Barry",
    "114011": "Ayaha & Aversa",
    "114012": "Chikaomi & Lon'zu",
    "114013": "Teru & Garrick",
    "114014": "Nobu & Gangrel",
    "114015": "Kuen & Excellus",
    "114016": "Yatsufusa & Gharnef",
    "114017": "Chouten & Pheros",
    "114018": "Riku & Abel",
    "115001": "Byleth (männlich)",
    "115002": "Byleth (männlich, erleuchtet)",
    "115003": "Byleth (weiblich)",
    "115004": "Byleth (weiblich, erleuchtet)",
    "115005": "Edelgard",
    "115006": "Dimitri",
    "115007": "Claude",
    "115008": "Hubert",
    "115009": "Ferdinand",
    "115010": "Linhardt",
    "115011": "Caspar",
    "115012": "Bernadetta",
    "115013": "Dorothea",
    "115014": "Petra",
    "115015": "Dedue",
    "115016": "Felix",
    "115017": "Ashe",
    "115018": "Sylvain",
    "115019": "Mercedes",
    "115020": "Annette",
    "115021": "Ingrid",
    "115022": "Lorenz",
    "115023": "Raphael",
    "115024": "Ignatz",
    "115025": "Lysithea",
    "115026": "Marianne",
    "115027": "Hilda",
    "115028": "Leonie",
    "115029": "Seteth",
    "115030": "Flayn",
    "115031": "Hanneman",
    "115032": "Manuela",
    "115033": "Gilbert",
    "115034": "Alois",
    "115035": "Catherine",
    "115036": "Shamir",
    "115037": "Cyril",
    "115038": "Jeralt",
    "115039": "Rhea",
    "115040": "Sothis",
    "115041": "Kronya",
    "115042": "Solon",
    "115043": "Ritter des Todes",
    "115044": "Kostas",
    "115045": "Lonato",
    "115046": "Miklan",
    "115047": "Flammenkaiser",
    "115048": "Anna",
    "115049": "Jeritza",
    "115050": "Rodrigue",
    "115051": "Judith",
    "115052": "Monica",
    "115053": "Herzog Arundel",
    "115054": "Tomas",
    "115055": "Kaiser Ionius IX.",
    "115056": "Metodey",
    "115057": "Ladislava",
    "115058": "Acheron",
    "116001": "Edelgard",
    "116002": "Dimitri",
    "116003": "Claude",
    "116004": "Hubert",
    "116005": "Ferdinand",
    "116006": "Linhardt",
    "116007": "Caspar",
    "116008": "Bernadetta",
    "116009": "Dorothea",
    "116010": "Petra",
    "116011": "Dedue",
    "116012": "Felix",
    "116013": "Ashe",
    "116014": "Sylvain",
    "116015": "Mercedes",
    "116016": "Annette",
    "116017": "Ingrid",
    "116018": "Lorenz",
    "116019": "Raphael",
    "116020": "Ignatz",
    "116021": "Lysithea",
    "116022": "Marianne",
    "116023": "Hilda",
    "116024": "Leonie",
    "116025": "Cyril",
    "116026": "Thales",
    "116027": "Cornelia",
    "116028": "Randolph",
    "116029": "Nader",
    "116030": "Nemesis",
    "116031": "Seiros",
    "116032": "Herzog Aegir",
    "116033": "Lambert",
    "116034": "Gwendal",
    "116035": "Pallardó"
  },
  "en-GB": {
    "101001": "Marth",
    "101002": "Caeda",
    "101003": "Jagen",
    "101004": "Cain",
    "101005": "Abel",
    "101006": "Draug",
    "101007": "Gordin",
    "101008": "Wrys",
    "101009": "Ogma",
    "101010": "Barst",
    "101011": "Bord",
    "101012": "Cord",
    "101013": "Castor",
    "101014": "Darros",
    "101015": "Julian",
    "101016": "Lena",
    "101017": "Navarre",
    "101018": "Merric",
    "101019": "Matthis",
    "101020": "Hardin",
    "101021": "Wolf",
    "101022": "Sedgar",
    "101023": "Roshea",
    "101024": "Vyland",
    "101025": "Wendell",
    "101026": "Rickard",
    "101027": "Bantu",
    "101028": "Caesar",
    "101029": "Radd",
    "101030": "Roger",
    "101031": "Jeorge",
    "101032": "Maria",
    "101033": "Minerva",
    "101034": "Linde",
    "101035": "Jake",
    "101036": "Midia",
    "101037": "Dolph",
    "101038": "Macellan",
    "101039": "Tomas",
    "101040": "Boah",
    "101041": "Beck",
    "101042": "Astram",
    "101043": "Palla",
    "101044": "Catria",
    "101045": "Arran",
    "101046": "Samson",
    "101047": "Xane",
    "101048": "Est",
    "101049": "Tiki",
    "101050": "Lorenz",
    "101051": "Elice",
    "101052": "Gotoh",
    "101053": "Frey",
    "101054": "Norne",
    "101055": "Athena",
    "101056": "Horace",
    "101057": "Etzel",
    "101058": "Ymir",
    "101059": "Nagi",
    "101060": "Malledus",
    "101061": "Nyna",
    "101062": "Gharnef",
    "101063": "Camus",
    "101064": "Michalis",
    "101065": "Medeus",
    "101066": "Anna",
    "102001": "Alm",
    "102002": "Lukas",
    "102003": "Gray",
    "102004": "Tobin",
    "102005": "Kliff",
    "102006": "Silque",
    "102007": "Clair",
    "102008": "Clive",
    "102009": "Forsyth",
    "102010": "Python",
    "102011": "Celica",
    "102012": "Mae",
    "102013": "Boey",
    "102014": "Genny",
    "102015": "Saber",
    "102016": "Valbar",
    "102017": "Kamui",
    "102018": "Leon",
    "102019": "Luthier",
    "102020": "Mathilda",
    "102021": "Delthea",
    "102022": "Palla",
    "102023": "Catria",
    "102024": "Atlas",
    "102025": "Jesse",
    "102026": "Deen",
    "102027": "Sonya",
    "102028": "Est",
    "102029": "Nomah",
    "102030": "Tatiana",
    "102031": "Zeke",
    "102032": "Mycen",
    "102033": "Desaix",
    "102034": "Grieth",
    "102035": "Rudolf",
    "102036": "Faye",
    "102037": "Clive",
    "102038": "Conrad",
    "102039": "Berkut",
    "102040": "Rinea",
    "102041": "Fernand",
    "102042": "Jedah",
    "102043": "Slayde",
    "102044": "Massena",
    "102045": "Lawson",
    "102046": "Jerome",
    "102047": "Tatarrah",
    "102048": "Dolth",
    "102049": "Nuibaba",
    "102050": "Hestia",
    "102051": "Marla",
    "102052": "Barth",
    "102053": "Garth",
    "102054": "Blake",
    "102055": "Mila",
    "102056": "Duma",
    "102057": "Brigand Boss",
    "102058": "Halcyon",
    "102059": "Irma",
    "103001": "Marth",
    "103002": "Kris (male)",
    "103003": "Kris (female)",
    "103004": "Abel",
    "103005": "Arran",
    "103006": "Astram",
    "103007": "Bantu",
    "103008": "Barst",
    "103009": "Beck",
    "103010": "Vyland",
    "103011": "Boah",
    "103012": "Xane",
    "103013": "Darros",
    "103014": "Draug",
    "103015": "Elice",
    "103016": "Est",
    "103017": "Gotoh",
    "103018": "Gordin",
    "103020": "Jagen",
    "103021": "Jake",
    "103022": "Jeorge",
    "103023": "Julian",
    "103024": "Cain",
    "103025": "Castor",
    "103026": "Catria",
    "103027": "Cord",
    "103028": "Maria",
    "103029": "Merric",
    "103030": "Matthis",
    "103031": "Midia",
    "103032": "Minerva",
    "103033": "Macellan",
    "103034": "Navarre",
    "103035": "Ogma",
    "103036": "Palla",
    "103037": "Radd",
    "103038": "Lena",
    "103039": "Rickard",
    "103040": "Wrys",
    "103041": "Linde",
    "103042": "Roger",
    "103043": "Lorenz",
    "103044": "Roshea",
    "103045": "Bord",
    "103046": "Samson",
    "103047": "Caesar",
    "103048": "Caeda",
    "103049": "Tomas",
    "103050": "Tiki",
    "103051": "Dolph",
    "103052": "Wendell",
    "103053": "Wolf",
    "103054": "Sedgar",
    "103055": "Frey",
    "103056": "Norne",
    "103057": "Athena",
    "103058": "Horace",
    "103059": "Etzel",
    "103060": "Ymir",
    "103061": "Nagi",
    "103062": "Nyna",
    "103063": "Katarina",
    "103064": "Roderick",
    "103065": "Cecil",
    "103066": "Yuliya",
    "103067": "Jubelo",
    "103068": "Lang",
    "103069": "Hardin",
    "103070": "Luke",
    "103071": "Marisha",
    "103072": "Ryan",
    "103073": "Sirius",
    "103074": "Samuel",
    "103075": "Warren",
    "103076": "Sheena",
    "103077": "Phina",
    "103078": "Arlen",
    "103079": "Frost",
    "103080": "Malice",
    "103081": "Dice",
    "103082": "Reiden",
    "103083": "Belf",
    "103084": "Roberto",
    "103085": "Gharnef",
    "103086": "Camus",
    "103087": "Michalis",
    "103088": "Legion",
    "103089": "Clarisse",
    "103090": "Eremiya",
    "103091": "Medeus",
    "103092": "Anna",
    "104001": "Sigurd",
    "104002": "Naoise",
    "104003": "Alec",
    "104004": "Arden",
    "104005": "Midir",
    "104006": "Edain",
    "104007": "Brigid",
    "104008": "Azelle",
    "104009": "Claud",
    "104010": "Tailtiu",
    "104011": "Lex",
    "104012": "Quan",
    "104013": "Ethlyn",
    "104014": "Finn",
    "104015": "Ayra",
    "104016": "Jamke",
    "104017": "Lewyn",
    "104018": "Erinys",
    "104019": "Lachesis",
    "104020": "Seliph",
    "104021": "Oifey",
    "104022": "Shannan",
    "104023": "Ulster",
    "104024": "Larcei",
    "104025": "Lana",
    "104026": "Diarmuid",
    "104027": "Lester",
    "104028": "Leif",
    "104029": "Finn",
    "104030": "Nanna",
    "104031": "Tine",
    "104032": "Patty",
    "104033": "Febail",
    "104034": "Arthur",
    "104035": "Fee",
    "104036": "Ced",
    "104037": "Altena",
    "104038": "Hannibal",
    "104039": "Coirpre",
    "104040": "Julia",
    "104041": "Ares",
    "104042": "Lene",
    "104043": "Dalvin",
    "104044": "Creidne",
    "104045": "Muirne",
    "104046": "Tristan",
    "104047": "Deimne",
    "104048": "Jeanne",
    "104049": "Linda",
    "104050": "Daisy",
    "104051": "Asaello",
    "104052": "Amid",
    "104053": "Hermina",
    "104054": "Hawk",
    "104055": "Charlot",
    "104056": "Laylea",
    "104057": "Eldigan",
    "104058": "Cimbaeth",
    "104059": "Munnir",
    "104060": "Sandima",
    "104062": "Chagall",
    "104063": "Annand",
    "104064": "Byron",
    "104065": "Andrey",
    "104066": "Lombard",
    "104067": "Reptor",
    "104068": "Aida",
    "104069": "Arvis",
    "104070": "Danann",
    "104071": "Kutuzov",
    "104072": "Ishtore",
    "104073": "Bloom",
    "104074": "Travant",
    "104075": "Brian",
    "104076": "Scipio",
    "104077": "Hilda",
    "104078": "Ishtar",
    "104079": "Arion",
    "104080": "Manfroy",
    "104081": "Julius",
    "104082": "Dew",
    "104083": "Deirdre",
    "104084": "Chulainn",
    "104085": "Silvia",
    "104086": "Beowolf",
    "104087": "Iuchar",
    "104088": "Iucharba",
    "105001": "Leif",
    "105002": "Finn",
    "105003": "Eyvel",
    "105004": "Halvan",
    "105005": "Osian",
    "105006": "Dagdar",
    "105007": "Tanya",
    "105008": "Marty",
    "105009": "Ronan",
    "105010": "Lifis",
    "105011": "Safy",
    "105012": "Brighton",
    "105013": "Machyua",
    "105014": "Lara",
    "105015": "Fergus",
    "105016": "Karin",
    "105017": "Dalsin",
    "105018": "Asbel",
    "105019": "Nanna",
    "105020": "Hicks",
    "105021": "Shiva",
    "105022": "Carrion",
    "105023": "Selphina",
    "105024": "Cain",
    "105025": "Alva",
    "105026": "Robert",
    "105027": "Fred",
    "105028": "Olwen",
    "105029": "Mareeta",
    "105030": "Salem",
    "105031": "Perne",
    "105032": "Tina",
    "105033": "Troude",
    "105034": "Glade",
    "105035": "Deen",
    "105036": "Eda",
    "105037": "Homer",
    "105038": "Linoan",
    "105039": "Ralf",
    "105040": "Ilios",
    "105041": "Sleuf",
    "105042": "Sara",
    "105043": "Miranda",
    "105044": "Shannam",
    "105045": "Misha",
    "105046": "Xavier",
    "105047": "Amalda",
    "105048": "Conomor",
    "105049": "Diarmuid",
    "105050": "Saias",
    "105051": "Ced",
    "105052": "Galzus",
    "105053": "Kempf",
    "105054": "Reinhardt",
    "105055": "Raydrik",
    "105056": "Veld",
    "106001": "Roy",
    "106002": "Marcus",
    "106003": "Alen",
    "106004": "Lance",
    "106005": "Wolt",
    "106006": "Bors",
    "106007": "Merlinus",
    "106008": "Elen",
    "106009": "Dieck",
    "106010": "Lot",
    "106011": "Shanna",
    "106012": "Chad",
    "106013": "Lugh",
    "106014": "Clarine",
    "106015": "Rutger",
    "106016": "Saul",
    "106017": "Dorothy",
    "106018": "Sue",
    "106019": "Zelot",
    "106020": "Trec",
    "106021": "Noah",
    "106022": "Astolfo",
    "106023": "Lilina",
    "106024": "Barthe",
    "106025": "Ogier",
    "106026": "Gwendolyn",
    "106027": "Fir",
    "106028": "Sin",
    "106029": "Geese",
    "106030": "Gonzalez",
    "106031": "Klein",
    "106032": "Thea",
    "106033": "Larum",
    "106034": "Elffin",
    "106035": "Echidna",
    "106036": "Bartre",
    "106037": "Raigh",
    "106038": "Cath",
    "106039": "Melady",
    "106040": "Perceval",
    "106041": "Cecilia",
    "106042": "Sophia",
    "106043": "Igrene",
    "106044": "Garret",
    "106045": "Fae",
    "106046": "Hugh",
    "106047": "Zeiss",
    "106048": "Douglas",
    "106049": "Niime",
    "106050": "Juno",
    "106051": "Dayan",
    "106052": "Yoder",
    "106053": "Karel",
    "106054": "Narcian",
    "106055": "Galle",
    "106056": "Hector",
    "106057": "Brunnya",
    "106058": "Murdock",
    "106059": "Eliwood",
    "106060": "Zephiel",
    "106061": "Guinivere",
    "106062": "Jahn",
    "106063": "Idunn",
    "106064": "Wade",
    "107001": "Lyn",
    "107002": "Sain",
    "107003": "Kent",
    "107004": "Florina",
    "107005": "Wil",
    "107006": "Dorcas",
    "107007": "Serra",
    "107008": "Erk",
    "107009": "Rath",
    "107010": "Matthew",
    "107011": "Nils",
    "107012": "Lucius",
    "107013": "Wallace",
    "107014": "Eliwood",
    "107015": "Marcus",
    "107016": "Lowen",
    "107017": "Rebecca",
    "107018": "Bartre",
    "107019": "Hector",
    "107020": "Oswin",
    "107021": "Guy",
    "107022": "Merlinus",
    "107023": "Priscilla",
    "107024": "Raven",
    "107025": "Canas",
    "107026": "Dart",
    "107027": "Fiora",
    "107028": "Legault",
    "107029": "Ninian",
    "107030": "Isadora",
    "107031": "Heath",
    "107032": "Hawkeye",
    "107033": "Geitz",
    "107034": "Pent",
    "107035": "Louise",
    "107036": "Karel",
    "107037": "Harken",
    "107038": "Nino",
    "107039": "Jaffar",
    "107040": "Vaida",
    "107041": "Renault",
    "107042": "Athos",
    "107043": "Farina",
    "107044": "Karla",
    "107045": "Leila",
    "107046": "Guinivere",
    "107047": "Zephiel",
    "107048": "Lloyd",
    "107049": "Linus",
    "107050": "Ursula",
    "107051": "Ephidel",
    "107052": "Sonia",
    "107053": "Limstella",
    "107054": "Nergal",
    "108001": "Eirika",
    "108002": "Seth",
    "108003": "Gilliam",
    "108004": "Franz",
    "108005": "Moulder",
    "108006": "Vanessa",
    "108007": "Ross",
    "108008": "Garcia",
    "108009": "Neimi",
    "108010": "Colm",
    "108011": "Artur",
    "108012": "Lute",
    "108013": "Natasha",
    "108014": "Joshua",
    "108015": "Ephraim",
    "108016": "Forde",
    "108017": "Kyle",
    "108018": "Orson",
    "108019": "Tana",
    "108020": "Amelia",
    "108021": "Innes",
    "108022": "Gerik",
    "108023": "Tethys",
    "108024": "Marisa",
    "108025": "L'Arachel",
    "108026": "Dozla",
    "108027": "Saleh",
    "108028": "Ewan",
    "108029": "Cormag",
    "108030": "Rennac",
    "108031": "Duessel",
    "108032": "Knoll",
    "108033": "Myrrh",
    "108034": "Syrene",
    "108035": "Caellach",
    "108036": "Riev",
    "108037": "Ismaire",
    "108038": "Selena",
    "108039": "Glen",
    "108040": "Hayden",
    "108041": "Valter",
    "108042": "Fado",
    "108043": "Lyon",
    "109001": "Ike",
    "109002": "Titania",
    "109003": "Oscar",
    "109004": "Boyd",
    "109005": "Rhys",
    "109006": "Shinon",
    "109007": "Gatrie",
    "109008": "Soren",
    "109009": "Mist",
    "109010": "Rolf",
    "109011": "Greil",
    "109012": "Mia",
    "109013": "Kieran",
    "109014": "Brom",
    "109015": "Nephenee",
    "109016": "Lucia",
    "109017": "Bastian",
    "109018": "Geoffrey",
    "109019": "Elincia",
    "109020": "Renning",
    "109021": "Lethe",
    "109022": "Mordecai",
    "109023": "Muarim",
    "109024": "Ranulf",
    "109025": "Giffca",
    "109026": "Caineghis",
    "109027": "Ena",
    "109028": "Nasir",
    "109029": "Gareth",
    "109030": "Kurthnaga",
    "109031": "Dheginsea",
    "109032": "Ulki",
    "109033": "Janaff",
    "109034": "Tibarn",
    "109035": "Reyson",
    "109036": "Leanne",
    "109037": "Naesala",
    "109038": "Nealuchi",
    "109039": "Marcia",
    "109040": "Astrid",
    "109041": "Makalov",
    "109042": "Tormod",
    "109043": "Tanith",
    "109044": "Zelgius",
    "109045": "Sigrun",
    "109046": "Sephiran",
    "109047": "Sanaki",
    "109048": "Jill",
    "109049": "Tauroneo",
    "109050": "Haar",
    "109051": "Petrine",
    "109052": "Bertram",
    "109053": "Black Knight",
    "109054": "Ashnard",
    "109055": "Ilyana",
    "109056": "Volke",
    "109057": "Zihark",
    "109058": "Sothe",
    "109059": "Stefan",
    "109060": "Devdan",
    "109061": "Calill",
    "109062": "Largo",
    "109063": "Elena",
    "110001": "Nolan",
    "110002": "Laura",
    "110003": "Sothe",
    "110004": "Edward",
    "110005": "Micaiah",
    "110006": "Ike",
    "110007": "Izuka",
    "110008": "Ena",
    "110009": "Ilyana",
    "110010": "Danved",
    "110011": "Ulki",
    "110012": "Elincia",
    "110013": "Oscar",
    "110014": "Oliver",
    "110015": "Volug",
    "110016": "Caineghis",
    "110017": "Gatrie",
    "110018": "Calill",
    "110019": "Kyza",
    "110020": "Rhys",
    "110021": "Kurthnaga",
    "110022": "Kieran",
    "110023": "Gareth",
    "110024": "Sanaki",
    "110025": "Sigrun",
    "110026": "Black Knight",
    "110027": "Shinon",
    "110028": "Giffca",
    "110029": "Geoffrey",
    "110030": "Jill",
    "110031": "Skrimir",
    "110032": "Astrid",
    "110033": "Soren",
    "110034": "Sephiran",
    "110035": "Zelgius",
    "110036": "Stefan",
    "110037": "Tauroneo",
    "110038": "Tanith",
    "110039": "Brom",
    "110040": "Zihark",
    "110041": "Titania",
    "110042": "Tibarn",
    "110043": "Dheginsea",
    "110044": "Tormod",
    "110045": "Nasir",
    "110046": "Nealuchi",
    "110047": "Nailah",
    "110048": "Naesala",
    "110049": "Nephenee",
    "110050": "Haar",
    "110051": "Vika",
    "110052": "Volke",
    "110053": "Aran",
    "110054": "Fiona",
    "110055": "Heather",
    "110056": "Hetzel",
    "110057": "Pelleas",
    "110058": "Boyd",
    "110059": "Marcia",
    "110060": "Makalov",
    "110061": "Mist",
    "110062": "Muarim",
    "110063": "Meg",
    "110064": "Mordecai",
    "110065": "Janaff",
    "110066": "Bastian",
    "110067": "Rolf",
    "110068": "Ranulf",
    "110069": "Rafiel",
    "110070": "Leanne",
    "110071": "Lyre",
    "110072": "Reyson",
    "110073": "Lucia",
    "110074": "Leonardo",
    "110075": "Lethe",
    "110076": "Renning",
    "110077": "Mia",
    "110078": "Anna",
    "110079": "Muston",
    "110080": "Aimee",
    "110081": "Jorge",
    "110082": "Daniel",
    "110083": "Jarod",
    "110084": "Valtome",
    "110085": "Ashunera",
    "110086": "Ashera",
    "110087": "Yune",
    "110089": "Largo",
    "110090": "Amy",
    "110091": "Almedha",
    "111001": "Robin (male)",
    "111002": "Robin (female)",
    "111003": "Chrom",
    "111004": "Frederick",
    "111005": "Kellam",
    "111006": "Ricken",
    "111007": "Vaike",
    "111008": "Lon'qu",
    "111009": "Virion",
    "111010": "Basilio",
    "111011": "Sumia",
    "111012": "Lissa",
    "111013": "Cherche",
    "111014": "Miriel",
    "111015": "Masked Marth",
    "111016": "Lucina",
    "111017": "Walhart",
    "111018": "Emmeryn",
    "111019": "Validar",
    "111020": "Sully",
    "111021": "Stahl",
    "111022": "Maribelle",
    "111023": "Panne",
    "111024": "Gaius",
    "111025": "Cordelia",
    "111026": "Gregor",
    "111027": "Nowi",
    "111028": "Libra",
    "111029": "Tharja",
    "111030": "Olivia",
    "111031": "Henry",
    "111032": "Say'ri",
    "111033": "Flavia",
    "111034": "Donnel",
    "111035": "Owain",
    "111036": "Inigo",
    "111037": "Brady",
    "111038": "Kjelle",
    "111039": "Cynthia",
    "111040": "Severa",
    "111041": "Gerome",
    "111042": "Morgan (male)",
    "111043": "Morgan (female)",
    "111044": "Yarne",
    "111045": "Laurent",
    "111046": "Noire",
    "111047": "Nah",
    "111048": "Tiki",
    "111049": "Anna",
    "111050": "Aversa",
    "111051": "Priam",
    "111052": "Gangrel",
    "111053": "Yen'fay",
    "111054": "Mustafa",
    "111055": "Cervantes",
    "111056": "Excellus",
    "111057": "Naga",
    "111058": "Grima",
    "112001": "Corrin (male)",
    "112002": "Corrin (female)",
    "112003": "Jakob",
    "112004": "Silas",
    "112005": "Kaze",
    "112006": "Ryoma",
    "112007": "Takumi",
    "112008": "Saizo",
    "112009": "Kaden",
    "112010": "Hinata",
    "112011": "Azama",
    "112012": "Subaki",
    "112013": "Hayato",
    "112014": "Xander",
    "112015": "Leo",
    "112016": "Benny",
    "112017": "Keaton",
    "112018": "Arthur",
    "112019": "Odin",
    "112020": "Laslow",
    "112021": "Niles",
    "112022": "Felicia",
    "112023": "Azura",
    "112024": "Mozu",
    "112025": "Hinoka",
    "112026": "Sakura",
    "112027": "Orochi",
    "112028": "Kagero",
    "112029": "Hana",
    "112030": "Setsuna",
    "112031": "Reina",
    "112032": "Oboro",
    "112033": "Camilla",
    "112034": "Elise",
    "112035": "Charlotte",
    "112036": "Effie",
    "112037": "Peri",
    "112038": "Beruka",
    "112039": "Selena",
    "112040": "Nyx",
    "112041": "Kana (female)",
    "112042": "Kana (male)",
    "112043": "Shigure",
    "112044": "Dwyer",
    "112045": "Sophie",
    "112046": "Midori",
    "112047": "Shiro",
    "112048": "Kiragi",
    "112049": "Asugi",
    "112050": "Selkie",
    "112051": "Hisame",
    "112052": "Mitama",
    "112053": "Caeldori",
    "112054": "Rhajat",
    "112055": "Siegbert",
    "112056": "Ignatius",
    "112057": "Forrest",
    "112058": "Velouria",
    "112059": "Percy",
    "112060": "Ophelia",
    "112061": "Soleil",
    "112062": "Nina",
    "112063": "Shura",
    "112064": "Fuga",
    "112065": "Yukimura",
    "112066": "Izana",
    "112067": "Gunter",
    "112068": "Nichol",
    "112069": "Rinkah",
    "112070": "Anna",
    "112071": "Scarlet",
    "112072": "Candace",
    "112073": "Flora",
    "112074": "Lilith",
    "112075": "Arete",
    "112076": "Garon",
    "112077": "Sumeragi",
    "112078": "Mikoto",
    "112079": "Iago",
    "112080": "Zola",
    "112081": "Hans",
    "112082": "Layla",
    "112083": "Rainbow Sage",
    "112084": "Anankos",
    "113001": "Alfonse",
    "113002": "Sharena",
    "113003": "Anna",
    "113004": "Veronica",
    "113005": "Bruno",
    "113006": "Fjorm",
    "113007": "Gunnthrá",
    "113008": "Surtr",
    "113009": "Laevatein",
    "113010": "Loki",
    "113011": "Helbindi",
    "113012": "Laegjarn",
    "113013": "Ylgr",
    "113014": "Hríd",
    "113015": "Eir",
    "113016": "Líf",
    "113017": "Thrasir",
    "113018": "Hel",
    "113019": "Triandra",
    "113020": "Peony",
    "113021": "Plumeria",
    "113022": "Freyr",
    "114001": "Itsuki & Chrom",
    "114002": "Tsubasa & Caeda",
    "114003": "Touma & Cain",
    "114004": "Kiria & Tharja",
    "114005": "Yashiro & Navarre",
    "114006": "Eleonora & Virion",
    "114007": "Mamori & Draug",
    "114008": "Maiko",
    "114009": "Tiki",
    "114010": "Barry",
    "114011": "Ayaha & Aversa",
    "114012": "Chikaomi & Lon'qu",
    "114013": "Teru & Garrick",
    "114014": "Nobu & Gangrel",
    "114015": "Kuen & Excellus",
    "114016": "Yatsufusa & Gharnef",
    "114017": "Chouten & Pheros",
    "114018": "Riku & Abel",
    "115001": "Byleth (male)",
    "115002": "Byleth (male, Enlightened)",
    "115003": "Byleth (female)",
    "115004": "Byleth (female, Enlightened)",
    "115005": "Edelgard",
    "115006": "Dimitri",
    "115007": "Claude",
    "115008": "Hubert",
    "115009": "Ferdinand",
    "115010": "Linhardt",
    "115011": "Caspar",
    "115012": "Bernadetta",
    "115013": "Dorothea",
    "115014": "Petra",
    "115015": "Dedue",
    "115016": "Felix",
    "115017": "Ashe",
    "115018": "Sylvain",
    "115019": "Mercedes",
    "115020": "Annette",
    "115021": "Ingrid",
    "115022": "Lorenz",
    "115023": "Raphael",
    "115024": "Ignatz",
    "115025": "Lysithea",
    "115026": "Marianne",
    "115027": "Hilda",
    "115028": "Leonie",
    "115029": "Seteth",
    "115030": "Flayn",
    "115031": "Hanneman",
    "115032": "Manuela",
    "115033": "Gilbert",
    "115034": "Alois",
    "115035": "Catherine",
    "115036": "Shamir",
    "115037": "Cyril",
    "115038": "Jeralt",
    "115039": "Rhea",
    "115040": "Sothis",
    "115041": "Kronya",
    "115042": "Solon",
    "115043": "Death Knight",
    "115044": "Kostas",
    "115045": "Lonato",
    "115046": "Miklan",
    "115047": "Flame Emperor",
    "115048": "Anna",
    "115049": "Jeritza",
    "115050": "Rodrigue",
    "115051": "Judith",
    "115052": "Monica",
    "115053": "Lord Arundel",
    "115054": "Tomas",
    "115055": "Emperor Ionius IX",
    "115056": "Metodey",
    "115057": "Ladislava",
    "115058": "Acheron",
    "116001": "Edelgard",
    "116002": "Dimitri",
    "116003": "Claude",
    "116004": "Hubert",
    "116005": "Ferdinand",
    "116006": "Linhardt",
    "116007": "Caspar",
    "116008": "Bernadetta",
    "116009": "Dorothea",
    "116010": "Petra",
    "116011": "Dedue",
    "116012": "Felix",
    "116013": "Ashe",
    "116014": "Sylvain",
    "116015": "Mercedes",
    "116016": "Annette",
    "116017": "Ingrid",
    "116018": "Lorenz",
    "116019": "Raphael",
    "116020": "Ignatz",
    "116021": "Lysithea",
    "116022": "Marianne",
    "116023": "Hilda",
    "116024": "Leonie",
    "116025": "Cyril",
    "116026": "Thales",
    "116027": "Cornelia",
    "116028": "Randolph",
    "116029": "Nader",
    "116030": "Nemesis",
    "116031": "Seiros",
    "116032": "Duke Aegir",
    "116033": "Lambert",
    "116034": "Gwendal",
    "116035": "Pallardó"
  },
  "es-ES": {
    "101001": "Marth",
    "101002": "Shiida",
    "101003": "Jagen",
    "101004": "Cain",
    "101005": "Abel",
    "101006": "Aidraug",
    "101007": "Gordin",
    "101008": "Wrys",
    "101009": "Ogma",
    "101010": "Barst",
    "101011": "Bord",
    "101012": "Cord",
    "101013": "Castor",
    "101014": "Darros",
    "101015": "Julian",
    "101016": "Lena",
    "101017": "Nabarl",
    "101018": "Merric",
    "101019": "Matthis",
    "101020": "Hardin",
    "101021": "Wolf",
    "101022": "Sedgar",
    "101023": "Roshea",
    "101024": "Vyland",
    "101025": "Wendell",
    "101026": "Rickard",
    "101027": "Bantu",
    "101028": "Caesar",
    "101029": "Radd",
    "101030": "Roger",
    "101031": "Jeorge",
    "101032": "Maria",
    "101033": "Minerva",
    "101034": "Linde",
    "101035": "Jake",
    "101036": "Midia",
    "101037": "Dolph",
    "101038": "Macellan",
    "101039": "Tomas",
    "101040": "Boah",
    "101041": "Beck",
    "101042": "Astram",
    "101043": "Palla",
    "101044": "Catria",
    "101045": "Arran",
    "101046": "Samson",
    "101047": "Xane",
    "101048": "Est",
    "101049": "Tiki",
    "101050": "Lorenz",
    "101051": "Elice",
    "101052": "Gotoh",
    "101053": "Frey",
    "101054": "Norne",
    "101055": "Athena",
    "101056": "Horace",
    "101057": "Etzel",
    "101058": "Ymir",
    "101059": "Nagi",
    "101060": "Malledus",
    "101061": "Nyna",
    "101062": "Gharnef",
    "101063": "Camus",
    "101064": "Michalis",
    "101065": "Medeus",
    "101066": "Anna",
    "102001": "Alm",
    "102002": "Lukas",
    "102003": "Gray",
    "102004": "Tobin",
    "102005": "Kliff",
    "102006": "Silque",
    "102007": "Clair",
    "102008": "Clive",
    "102009": "Forsyth",
    "102010": "Python",
    "102011": "Celica",
    "102012": "Mae",
    "102013": "Boey",
    "102014": "Genny",
    "102015": "Saber",
    "102016": "Valbar",
    "102017": "Kamui",
    "102018": "Leon",
    "102019": "Luthier",
    "102020": "Mathilda",
    "102021": "Delthea",
    "102022": "Palla",
    "102023": "Catria",
    "102024": "Atlas",
    "102025": "Jesse",
    "102026": "Deen",
    "102027": "Sonya",
    "102028": "Est",
    "102029": "Nomah",
    "102030": "Tatiana",
    "102031": "Zeke",
    "102032": "Mycen",
    "102033": "Desaix",
    "102034": "Grieth",
    "102035": "Rudolf",
    "102036": "Faye",
    "102037": "Clive",
    "102038": "Conrad",
    "102039": "Berkut",
    "102040": "Rinea",
    "102041": "Fernand",
    "102042": "Jedah",
    "102043": "Slayde",
    "102044": "Massena",
    "102045": "Lawson",
    "102046": "Jerome",
    "102047": "Tatarrah",
    "102048": "Dolth",
    "102049": "Nuibaba",
    "102050": "Hestia",
    "102051": "Marla",
    "102052": "Barth",
    "102053": "Garth",
    "102054": "Blake",
    "102055": "Mila",
    "102056": "Duma",
    "102057": "Jefe",
    "102058": "Halcyon",
    "102059": "Irma",
    "103001": "Marth",
    "103002": "Kris (M)",
    "103003": "Kris (F)",
    "103004": "Abel",
    "103005": "Arran",
    "103006": "Astram",
    "103007": "Bantu",
    "103008": "Barst",
    "103009": "Beck",
    "103010": "Vyland",
    "103011": "Boah",
    "103012": "Xane",
    "103013": "Darros",
    "103014": "Aidraug",
    "103015": "Elice",
    "103016": "Est",
    "103017": "Gotoh",
    "103018": "Gordin",
    "103020": "Jagen",
    "103021": "Jake",
    "103022": "Jeorge",
    "103023": "Julian",
    "103024": "Cain",
    "103025": "Castor",
    "103026": "Catria",
    "103027": "Cord",
    "103028": "Maria",
    "103029": "Merric",
    "103030": "Matthis",
    "103031": "Midia",
    "103032": "Minerva",
    "103033": "Macellan",
    "103034": "Nabarl",
    "103035": "Ogma",
    "103036": "Palla",
    "103037": "Radd",
    "103038": "Lena",
    "103039": "Rickard",
    "103040": "Wrys",
    "103041": "Linde",
    "103042": "Roger",
    "103043": "Lorenz",
    "103044": "Roshea",
    "103045": "Bord",
    "103046": "Samson",
    "103047": "Caesar",
    "103048": "Shiida",
    "103049": "Tomas",
    "103050": "Tiki",
    "103051": "Dolph",
    "103052": "Wendell",
    "103053": "Wolf",
    "103054": "Sedgar",
    "103055": "Frey",
    "103056": "Norne",
    "103057": "Athena",
    "103058": "Horace",
    "103059": "Etzel",
    "103060": "Ymir",
    "103061": "Nagi",
    "103062": "Nyna",
    "103063": "Katarina",
    "103064": "Roderick",
    "103065": "Cecil",
    "103066": "Yuliya",
    "103067": "Jubelo",
    "103068": "Lang",
    "103069": "Hardin",
    "103070": "Luke",
    "103071": "Marisha",
    "103072": "Ryan",
    "103073": "Sirius",
    "103074": "Samuel",
    "103075": "Warren",
    "103076": "Sheena",
    "103077": "Phina",
    "103078": "Arlen",
    "103079": "Frost",
    "103080": "Malice",
    "103081": "Dice",
    "103082": "Reiden",
    "103083": "Belf",
    "103084": "Roberto",
    "103085": "Gharnef",
    "103086": "Camus",
    "103087": "Michalis",
    "103088": "Legion",
    "103089": "Clarisse",
    "103090": "Eremiya",
    "103091": "Medeus",
    "103092": "Anna",
    "104001": "Sigurd",
    "104002": "Naoise",
    "104003": "Alec",
    "104004": "Arden",
    "104005": "Midir",
    "104006": "Edain",
    "104007": "Brigid",
    "104008": "Azelle",
    "104009": "Claud",
    "104010": "Tailtiu",
    "104011": "Lex",
    "104012": "Quan",
    "104013": "Ethlyn",
    "104014": "Finn",
    "104015": "Ayra",
    "104016": "Jamke",
    "104017": "Lewyn",
    "104018": "Erinys",
    "104019": "Lachesis",
    "104020": "Seliph",
    "104021": "Oifey",
    "104022": "Shannan",
    "104023": "Ulster",
    "104024": "Larcei",
    "104025": "Lana",
    "104026": "Diarmuid",
    "104027": "Lester",
    "104028": "Leif",
    "104029": "Finn",
    "104030": "Nanna",
    "104031": "Tine",
    "104032": "Patty",
    "104033": "Febail",
    "104034": "Arthur",
    "104035": "Fee",
    "104036": "Ced",
    "104037": "Altena",
    "104038": "Hannibal",
    "104039": "Coirpre",
    "104040": "Julia",
    "104041": "Ares",
    "104042": "Lene",
    "104043": "Dalvin",
    "104044": "Creidne",
    "104045": "Muirne",
    "104046": "Tristan",
    "104047": "Deimne",
    "104048": "Jeanne",
    "104049": "Linda",
    "104050": "Daisy",
    "104051": "Asaello",
    "104052": "Amid",
    "104053": "Hermina",
    "104054": "Hawk",
    "104055": "Charlot",
    "104056": "Laylea",
    "104057": "Eldigan",
    "104058": "Cimbaeth",
    "104059": "Munnir",
    "104060": "Sandima",
    "104062": "Chagall",
    "104063": "Annand",
    "104064": "Byron",
    "104065": "Andrey",
    "104066": "Lombard",
    "104067": "Reptor",
    "104068": "Aida",
    "104069": "Arvis",
    "104070": "Danann",
    "104071": "Kutuzov",
    "104072": "Ishtore",
    "104073": "Bloom",
    "104074": "Travant",
    "104075": "Brian",
    "104076": "Scipio",
    "104077": "Hilda",
    "104078": "Ishtar",
    "104079": "Arion",
    "104080": "Manfroy",
    "104081": "Julius",
    "104082": "Dew",
    "104083": "Deirdre",
    "104084": "Chulainn",
    "104085": "Silvia",
    "104086": "Beowolf",
    "104087": "Iuchar",
    "104088": "Iucharba",
    "105001": "Leif",
    "105002": "Finn",
    "105003": "Eyvel",
    "105004": "Halvan",
    "105005": "Osian",
    "105006": "Dagdar",
    "105007": "Tanya",
    "105008": "Marty",
    "105009": "Ronan",
    "105010": "Lifis",
    "105011": "Safy",
    "105012": "Brighton",
    "105013": "Machyua",
    "105014": "Lara",
    "105015": "Fergus",
    "105016": "Karin",
    "105017": "Dalsin",
    "105018": "Asbel",
    "105019": "Nanna",
    "105020": "Hicks",
    "105021": "Shiva",
    "105022": "Carrion",
    "105023": "Selphina",
    "105024": "Cain",
    "105025": "Alva",
    "105026": "Robert",
    "105027": "Fred",
    "105028": "Olwen",
    "105029": "Mareeta",
    "105030": "Salem",
    "105031": "Perne",
    "105032": "Tina",
    "105033": "Troude",
    "105034": "Glade",
    "105035": "Deen",
    "105036": "Eda",
    "105037": "Homer",
    "105038": "Linoan",
    "105039": "Ralf",
    "105040": "Ilios",
    "105041": "Sleuf",
    "105042": "Sara",
    "105043": "Miranda",
    "105044": "Shannam",
    "105045": "Misha",
    "105046": "Xavier",
    "105047": "Amalda",
    "105048": "Conomor",
    "105049": "Diarmuid",
    "105050": "Saias",
    "105051": "Ced",
    "105052": "Galzus",
    "105053": "Kempf",
    "105054": "Reinhardt",
    "105055": "Raydrik",
    "105056": "Veld",
    "106001": "Roy",
    "106002": "Marcus",
    "106003": "Alen",
    "106004": "Lance",
    "106005": "Wolt",
    "106006": "Bors",
    "106007": "Merlinus",
    "106008": "Elen",
    "106009": "Dieck",
    "106010": "Lot",
    "106011": "Shanna",
    "106012": "Chad",
    "106013": "Lugh",
    "106014": "Clarine",
    "106015": "Rutger",
    "106016": "Saul",
    "106017": "Dorothy",
    "106018": "Sue",
    "106019": "Zelot",
    "106020": "Trec",
    "106021": "Noah",
    "106022": "Astolfo",
    "106023": "Lilina",
    "106024": "Barthe",
    "106025": "Ogier",
    "106026": "Gwendolyn",
    "106027": "Fir",
    "106028": "Sin",
    "106029": "Geese",
    "106030": "Gonzalez",
    "106031": "Klein",
    "106032": "Thea",
    "106033": "Larum",
    "106034": "Elffin",
    "106035": "Echidna",
    "106036": "Bartre",
    "106037": "Raigh",
    "106038": "Cath",
    "106039": "Melady",
    "106040": "Perceval",
    "106041": "Cecilia",
    "106042": "Sophia",
    "106043": "Igrene",
    "106044": "Garret",
    "106045": "Fae",
    "106046": "Hugh",
    "106047": "Zeiss",
    "106048": "Douglas",
    "106049": "Niime",
    "106050": "Juno",
    "106051": "Dayan",
    "106052": "Yoder",
    "106053": "Karel",
    "106054": "Narcian",
    "106055": "Galle",
    "106056": "Hector",
    "106057": "Brunnya",
    "106058": "Murdock",
    "106059": "Eliwood",
    "106060": "Zephiel",
    "106061": "Guinivere",
    "106062": "Jahn",
    "106063": "Idunn",
    "106064": "Wade",
    "107001": "Lyn",
    "107002": "Sain",
    "107003": "Kent",
    "107004": "Florina",
    "107005": "Wil",
    "107006": "Dorcas",
    "107007": "Serra",
    "107008": "Erk",
    "107009": "Rath",
    "107010": "Matthew",
    "107011": "Nils",
    "107012": "Lucius",
    "107013": "Wallace",
    "107014": "Eliwood",
    "107015": "Marcus",
    "107016": "Lowen",
    "107017": "Rebecca",
    "107018": "Bartre",
    "107019": "Hector",
    "107020": "Oswin",
    "107021": "Guy",
    "107022": "Merlinus",
    "107023": "Priscilla",
    "107024": "Raven",
    "107025": "Canas",
    "107026": "Dart",
    "107027": "Fiora",
    "107028": "Legault",
    "107029": "Ninian",
    "107030": "Isadora",
    "107031": "Heath",
    "107032": "Hawkeye",
    "107033": "Geitz",
    "107034": "Pent",
    "107035": "Louise",
    "107036": "Karel",
    "107037": "Harken",
    "107038": "Nino",
    "107039": "Jaffar",
    "107040": "Vaida",
    "107041": "Renaud",
    "107042": "Athos",
    "107043": "Farina",
    "107044": "Karla",
    "107045": "Leila",
    "107046": "Guinivere",
    "107047": "Zephiel",
    "107048": "Lloyd",
    "107049": "Linus",
    "107050": "Ursula",
    "107051": "Ephidel",
    "107052": "Sonia",
    "107053": "Limstella",
    "107054": "Nergal",
    "108001": "Eirika",
    "108002": "Seth",
    "108003": "Gilliam",
    "108004": "Franz",
    "108005": "Moulder",
    "108006": "Vanessa",
    "108007": "Ross",
    "108008": "Garcia",
    "108009": "Neimi",
    "108010": "Colm",
    "108011": "Artur",
    "108012": "Lute",
    "108013": "Natasha",
    "108014": "Joshua",
    "108015": "Ephraim",
    "108016": "Forde",
    "108017": "Kyle",
    "108018": "Orson",
    "108019": "Tana",
    "108020": "Amelia",
    "108021": "James",
    "108022": "Gerik",
    "108023": "Tethys",
    "108024": "Marisa",
    "108025": "L'Arachel",
    "108026": "Dozla",
    "108027": "Saleh",
    "108028": "Ewan",
    "108029": "Cormag",
    "108030": "Rennac",
    "108031": "Duessel",
    "108032": "Knoll",
    "108033": "Myrrh",
    "108034": "Syrene",
    "108035": "Caellach",
    "108036": "Riev",
    "108037": "Ismaire",
    "108038": "Selena",
    "108039": "Glen",
    "108040": "Hayden",
    "108041": "Valter",
    "108042": "Vari",
    "108043": "Lyon",
    "109001": "Ike",
    "109002": "Titania",
    "109003": "Oscar",
    "109004": "Boyd",
    "109005": "Rhys",
    "109006": "Shinon",
    "109007": "Gatrie",
    "109008": "Soren",
    "109009": "Mist",
    "109010": "Rolf",
    "109011": "Greil",
    "109012": "Mia",
    "109013": "Kieran",
    "109014": "Brom",
    "109015": "Nephenee",
    "109016": "Lucia",
    "109017": "Bastian",
    "109018": "Geoffrey",
    "109019": "Elincia",
    "109020": "Renning",
    "109021": "Lethe",
    "109022": "Mordecai",
    "109023": "Muarim",
    "109024": "Ranulf",
    "109025": "Giffca",
    "109026": "Caineghis",
    "109027": "Ena",
    "109028": "Nasir",
    "109029": "Gareth",
    "109030": "Kurthnaga",
    "109031": "Deghinsea",
    "109032": "Ulki",
    "109033": "Janaff",
    "109034": "Tibarn",
    "109035": "Reyson",
    "109036": "Leanne",
    "109037": "Naesala",
    "109038": "Nealuchi",
    "109039": "Marcia",
    "109040": "Astrid",
    "109041": "Makalov",
    "109042": "Tormod",
    "109043": "Tanith",
    "109044": "Zelgius",
    "109045": "Sigrun",
    "109046": "Sephiran",
    "109047": "Sanaki",
    "109048": "Jill",
    "109049": "Tauroneo",
    "109050": "Haar",
    "109051": "Petrine",
    "109052": "Bertram",
    "109053": "Caballero Negro",
    "109054": "Ashnard",
    "109055": "Ilyana",
    "109056": "Volke",
    "109057": "Zihark",
    "109058": "Sothe",
    "109059": "Stefan",
    "109060": "Devdan",
    "109061": "Calill",
    "109062": "Largo",
    "109063": "Elena",
    "110001": "Nolan",
    "110002": "Laura",
    "110003": "Sothe",
    "110004": "Edward",
    "110005": "Micaiah",
    "110006": "Ike",
    "110007": "Izuka",
    "110008": "Ena",
    "110009": "Ilyana",
    "110010": "Danved",
    "110011": "Ulki",
    "110012": "Elincia",
    "110013": "Oscar",
    "110014": "Oliver",
    "110015": "Volug",
    "110016": "Caineghis",
    "110017": "Gatrie",
    "110018": "Calill",
    "110019": "Kysha",
    "110020": "Rhys",
    "110021": "Kurthnaga",
    "110022": "Kieran",
    "110023": "Gareth",
    "110024": "Sanaki",
    "110025": "Sigrun",
    "110026": "Caballero Negro",
    "110027": "Shinon",
    "110028": "Giffca",
    "110029": "Geoffrey",
    "110030": "Jill",
    "110031": "Skrimir",
    "110032": "Astrid",
    "110033": "Soren",
    "110034": "Sephiran",
    "110035": "Zelgius",
    "110036": "Stefan",
    "110037": "Tauroneo",
    "110038": "Tanith",
    "110039": "Brom",
    "110040": "Zihark",
    "110041": "Titania",
    "110042": "Tibarn",
    "110043": "Dheginsea",
    "110044": "Tormod",
    "110045": "Nasir",
    "110046": "Nealuchi",
    "110047": "Nailah",
    "110048": "Naesala",
    "110049": "Nephenee",
    "110050": "Haar",
    "110051": "Vika",
    "110052": "Volke",
    "110053": "Aran",
    "110054": "Fiona",
    "110055": "Heather",
    "110056": "Hetzel",
    "110057": "Pelleas",
    "110058": "Boyd",
    "110059": "Marcia",
    "110060": "Makalov",
    "110061": "Mist",
    "110062": "Muarim",
    "110063": "Meg",
    "110064": "Mordecai",
    "110065": "Janaff",
    "110066": "Bastian",
    "110067": "Rolf",
    "110068": "Ranulf",
    "110069": "Rafiel",
    "110070": "Leanne",
    "110071": "Lyre",
    "110072": "Reyson",
    "110073": "Lucia",
    "110074": "Leonardo",
    "110075": "Lethe",
    "110076": "Renning",
    "110077": "Mia",
    "110078": "Anna",
    "110079": "Muston",
    "110080": "Aimee",
    "110081": "Jorge",
    "110082": "Daniel",
    "110083": "Jarod",
    "110084": "Valtome",
    "110085": "Ashunera",
    "110086": "Ashera",
    "110087": "Yune",
    "110089": "Largo",
    "110090": "Amy",
    "110091": "Almedha",
    "111001": "Daraen (M)",
    "111002": "Daraen (F)",
    "111003": "Chrom",
    "111004": "Frederick",
    "111005": "Kellam",
    "111006": "Ricken",
    "111007": "Vaike",
    "111008": "Lon'zu",
    "111009": "Virion",
    "111010": "Basilio",
    "111011": "Sumia",
    "111012": "Lissa",
    "111013": "Zelcher",
    "111014": "Miriel",
    "111015": "Marth enmascarado",
    "111016": "Lucina",
    "111017": "Walhart",
    "111018": "Emmeryn",
    "111019": "Valldar",
    "111020": "Sully",
    "111021": "Stahl",
    "111022": "Maribelle",
    "111023": "Palne",
    "111024": "Gaius",
    "111025": "Cordelia",
    "111026": "Gregor",
    "111027": "Nowi",
    "111028": "Libra",
    "111029": "Tharja",
    "111030": "Olivia",
    "111031": "Henry",
    "111032": "Say'ri",
    "111033": "Flavia",
    "111034": "Donnel",
    "111035": "Owain",
    "111036": "Íñigo",
    "111037": "Brady",
    "111038": "Kjelle",
    "111039": "Cynthia",
    "111040": "Severa",
    "111041": "Gerome",
    "111042": "Linfan (M)",
    "111043": "Linfan (F)",
    "111044": "Yarne",
    "111045": "Laurent",
    "111046": "Noire",
    "111047": "Nah",
    "111048": "Tiki",
    "111049": "Anna",
    "111050": "Aversa",
    "111051": "Priam",
    "111052": "Gangrel",
    "111053": "Yen'fay",
    "111054": "Mustafa",
    "111055": "Cervantes",
    "111056": "Excellus",
    "111057": "Naga",
    "111058": "Grima",
    "112001": "Corrin (M)",
    "112002": "Corrin (F)",
    "112003": "Jakob",
    "112004": "Silas",
    "112005": "Kaze",
    "112006": "Ryoma",
    "112007": "Takumi",
    "112008": "Saizo",
    "112009": "Kaden",
    "112010": "Hinata",
    "112011": "Azama",
    "112012": "Subaki",
    "112013": "Hayato",
    "112014": "Xander",
    "112015": "Leo",
    "112016": "Benny",
    "112017": "Keaton",
    "112018": "Arthur",
    "112019": "Odín",
    "112020": "Laslow",
    "112021": "Niles",
    "112022": "Felicia",
    "112023": "Azura",
    "112024": "Mozu",
    "112025": "Hinoka",
    "112026": "Sakura",
    "112027": "Orochi",
    "112028": "Kagero",
    "112029": "Hana",
    "112030": "Setsuna",
    "112031": "Reyna",
    "112032": "Oboro",
    "112033": "Camilla",
    "112034": "Elise",
    "112035": "Charlotte",
    "112036": "Effie",
    "112037": "Peri",
    "112038": "Beruka",
    "112039": "Selena",
    "112040": "Nyx",
    "112041": "Kana (F)",
    "112042": "Kana (M)",
    "112043": "Shigure",
    "112044": "Dwyer",
    "112045": "Sophie",
    "112046": "Midori",
    "112047": "Shiro",
    "112048": "Kiragi",
    "112049": "Asugi",
    "112050": "Selkie",
    "112051": "Hisame",
    "112052": "Mitama",
    "112053": "Caeldori",
    "112054": "Rhajat",
    "112055": "Siegbert",
    "112056": "Ignatius",
    "112057": "Forrest",
    "112058": "Velouria",
    "112059": "Percy",
    "112060": "Ophelia",
    "112061": "Soleil",
    "112062": "Nina",
    "112063": "Shura",
    "112064": "Fuga",
    "112065": "Yukimura",
    "112066": "Izana",
    "112067": "Gunter",
    "112068": "Nichol",
    "112069": "Rinkah",
    "112070": "Anna",
    "112071": "Scarlet",
    "112072": "Candace",
    "112073": "Flora",
    "112074": "Lilith",
    "112075": "Arete",
    "112076": "Garon",
    "112077": "Sumeragi",
    "112078": "Mikoto",
    "112079": "Iago",
    "112080": "Zola",
    "112081": "Hans",
    "112082": "Layla",
    "112083": "Sabio Lumen",
    "112084": "Anankos",
    "113001": "Alfonse",
    "113002": "Sharena",
    "113003": "Anna",
    "113004": "Veronica",
    "113005": "Bruno",
    "113006": "Fjorm",
    "113007": "Gunnthrá",
    "113008": "Surtr",
    "113009": "Laevatein",
    "113010": "Loki",
    "113011": "Helbindi",
    "113012": "Laegjarn",
    "113013": "Ylgr",
    "113014": "Hríd",
    "113015": "Eir",
    "113016": "Líf",
    "113017": "Thrasir",
    "113018": "Hel",
    "113019": "Triandra",
    "113020": "Peony",
    "113021": "Plumeria",
    "113022": "Freyr",
    "114001": "Itsuki y Chrom",
    "114002": "Tsubasa y Shiida",
    "114003": "Touma y Cain",
    "114004": "Kiria y Tharja",
    "114005": "Yashiro y Nabarl",
    "114006": "Eleonora y Virion",
    "114007": "Mamori y Aidraug",
    "114008": "Maiko",
    "114009": "Tiki",
    "114010": "Barry",
    "114011": "Ayaha y Aversa",
    "114012": "Chikaomi y Lon'zu",
    "114013": "Teru y Garrick",
    "114014": "Nobu y Gangrel",
    "114015": "Kuen y Excellus",
    "114016": "Yatsufusa y Gharnef",
    "114017": "Chouten y Pheros",
    "114018": "Riku y Abel",
    "115001": "Byleth (M)",
    "115002": "Byleth (M, profeta)",
    "115003": "Byleth (F)",
    "115004": "Byleth (F, profeta)",
    "115005": "Edelgard",
    "115006": "Dimitri",
    "115007": "Claude",
    "115008": "Hubert",
    "115009": "Ferdinand",
    "115010": "Linhardt",
    "115011": "Caspar",
    "115012": "Bernadetta",
    "115013": "Dorothea",
    "115014": "Petra",
    "115015": "Dedue",
    "115016": "Felix",
    "115017": "Ashe",
    "115018": "Sylvain",
    "115019": "Mercedes",
    "115020": "Annette",
    "115021": "Ingrid",
    "115022": "Lorenz",
    "115023": "Raphael",
    "115024": "Ignatz",
    "115025": "Lysithea",
    "115026": "Marianne",
    "115027": "Hilda",
    "115028": "Leonie",
    "115029": "Seteth",
    "115030": "Flayn",
    "115031": "Hanneman",
    "115032": "Manuela",
    "115033": "Gilbert",
    "115034": "Alois",
    "115035": "Catherine",
    "115036": "Shamir",
    "115037": "Cyril",
    "115038": "Jeralt",
    "115039": "Rhea",
    "115040": "Sothis",
    "115041": "Kronya",
    "115042": "Solon",
    "115043": "Caballero Sanguinario",
    "115044": "Kostas",
    "115045": "Lonato",
    "115046": "Miklan",
    "115047": "Emperador del Fuego",
    "115048": "Anna",
    "115049": "Jeritza",
    "115050": "Rodrigue",
    "115051": "Judith",
    "115052": "Monica",
    "115053": "Lord Arundel",
    "115054": "Tomas",
    "115055": "Emperador Ionius IX",
    "115056": "Metodey",
    "115057": "Ladislava",
    "115058": "Acheron",
    "116001": "Edelgard",
    "116002": "Dimitri",
    "116003": "Claude",
    "116004": "Hubert",
    "116005": "Ferdinand",
    "116006": "Linhardt",
    "116007": "Caspar",
    "116008": "Bernadetta",
    "116009": "Dorothea",
    "116010": "Petra",
    "116011": "Dedue",
    "116012": "Felix",
    "116013": "Ashe",
    "116014": "Sylvain",
    "116015": "Mercedes",
    "116016": "Annette",
    "116017": "Ingrid",
    "116018": "Lorenz",
    "116019": "Raphael",
    "116020": "Ignatz",
    "116021": "Lysithea",
    "116022": "Marianne",
    "116023": "Hilda",
    "116024": "Leonie",
    "116025": "Cyril",
    "116026": "Thales",
    "116027": "Cornelia",
    "116028": "Randolph",
    "116029": "Nader",
    "116030": "Némesis",
    "116031": "Seiros",
    "116032": "Duque de Aegir",
    "116033": "Lambert",
    "116034": "Gwendal",
    "116035": "Pallardó"
  },
  "fr-FR": {
    "101001": "Marth",
    "101002": "Shiida",
    "101003": "Jagen",
    "101004": "Caïn",
    "101005": "Abel",
    "101006": "Edgar",
    "101007": "Gordin",
    "101008": "Wrys",
    "101009": "Ogma",
    "101010": "Barst",
    "101011": "Bord",
    "101012": "Cord",
    "101013": "Castor",
    "101014": "Darros",
    "101015": "Julian",
    "101016": "Lena",
    "101017": "Nabarl",
    "101018": "Merric",
    "101019": "Matthis",
    "101020": "Hardin",
    "101021": "Wolf",
    "101022": "Sagaro",
    "101023": "Roshea",
    "101024": "Vyland",
    "101025": "Wendell",
    "101026": "Rickard",
    "101027": "Bantu",
    "101028": "Caesar",
    "101029": "Radd",
    "101030": "Roger",
    "101031": "Jeorge",
    "101032": "Maria",
    "101033": "Minerva",
    "101034": "Linde",
    "101035": "Jake",
    "101036": "Midia",
    "101037": "Dolph",
    "101038": "Macellan",
    "101039": "Tomas",
    "101040": "Boah",
    "101041": "Beck",
    "101042": "Astram",
    "101043": "Palla",
    "101044": "Catria",
    "101045": "Arran",
    "101046": "Samson",
    "101047": "Xane",
    "101048": "Est",
    "101049": "Tiki",
    "101050": "Lorenz",
    "101051": "Elice",
    "101052": "Gotoh",
    "101053": "Frey",
    "101054": "Norne",
    "101055": "Athenais",
    "101056": "Horace",
    "101057": "Etzel",
    "101058": "Ymir",
    "101059": "Nagi",
    "101060": "Malledus",
    "101061": "Nyna",
    "101062": "Gharnef",
    "101063": "Camus",
    "101064": "Michalis",
    "101065": "Medeus",
    "101066": "Anna",
    "102001": "Alm",
    "102002": "Lukas",
    "102003": "Gray",
    "102004": "Tobin",
    "102005": "Kliff",
    "102006": "Silque",
    "102007": "Clair",
    "102008": "Clive",
    "102009": "Forsyth",
    "102010": "Python",
    "102011": "Celica",
    "102012": "Mae",
    "102013": "Boey",
    "102014": "Genny",
    "102015": "Saber",
    "102016": "Valbar",
    "102017": "Kamui",
    "102018": "Leon",
    "102019": "Luthier",
    "102020": "Mathilda",
    "102021": "Delthea",
    "102022": "Palla",
    "102023": "Catria",
    "102024": "Atlas",
    "102025": "Jesse",
    "102026": "Deen",
    "102027": "Sonya",
    "102028": "Est",
    "102029": "Nomah",
    "102030": "Tatiana",
    "102031": "Zeke",
    "102032": "Mycen",
    "102033": "Desaix",
    "102034": "Grieth",
    "102035": "Rudolf",
    "102036": "Faye",
    "102037": "Clive",
    "102038": "Conrad",
    "102039": "Berkut",
    "102040": "Rinea",
    "102041": "Fernand",
    "102042": "Jedah",
    "102043": "Slayde",
    "102044": "Massena",
    "102045": "Lawson",
    "102046": "Jerome",
    "102047": "Tatarrah",
    "102048": "Dolth",
    "102049": "Nuibaba",
    "102050": "Hestia",
    "102051": "Marla",
    "102052": "Barth",
    "102053": "Garth",
    "102054": "Blake",
    "102055": "Mila",
    "102056": "Duma",
    "102057": "Boss (brigands)",
    "102058": "Halcyon",
    "102059": "Irma",
    "103001": "Marth",
    "103002": "Kris (homme)",
    "103003": "Kris (femme)",
    "103004": "Abel",
    "103005": "Arran",
    "103006": "Astram",
    "103007": "Bantu",
    "103008": "Barst",
    "103009": "Beck",
    "103010": "Vyland",
    "103011": "Boah",
    "103012": "Xane",
    "103013": "Darros",
    "103014": "Edgar",
    "103015": "Elice",
    "103016": "Est",
    "103017": "Gotoh",
    "103018": "Gordin",
    "103020": "Jagen",
    "103021": "Jake",
    "103022": "Jeorge",
    "103023": "Julian",
    "103024": "Caïn",
    "103025": "Castor",
    "103026": "Catria",
    "103027": "Cord",
    "103028": "Maria",
    "103029": "Merric",
    "103030": "Matthis",
    "103031": "Midia",
    "103032": "Minerva",
    "103033": "Macellan",
    "103034": "Nabarl",
    "103035": "Ogma",
    "103036": "Palla",
    "103037": "Radd",
    "103038": "Lena",
    "103039": "Rickard",
    "103040": "Wrys",
    "103041": "Linde",
    "103042": "Roger",
    "103043": "Lorenz",
    "103044": "Roshea",
    "103045": "Bord",
    "103046": "Samson",
    "103047": "Caesar",
    "103048": "Shiida",
    "103049": "Tomas",
    "103050": "Tiki",
    "103051": "Dolph",
    "103052": "Wendell",
    "103053": "Wolf",
    "103054": "Sagaro",
    "103055": "Frey",
    "103056": "Norne",
    "103057": "Athenais",
    "103058": "Horace",
    "103059": "Etzel",
    "103060": "Ymir",
    "103061": "Nagi",
    "103062": "Nyna",
    "103063": "Katarina",
    "103064": "Roderick",
    "103065": "Cecil",
    "103066": "Yuliya",
    "103067": "Jubelo",
    "103068": "Lang",
    "103069": "Hardin",
    "103070": "Luke",
    "103071": "Marisha",
    "103072": "Ryan",
    "103073": "Sirius",
    "103074": "Samuel",
    "103075": "Warren",
    "103076": "Sheena",
    "103077": "Phina",
    "103078": "Arlen",
    "103079": "Frost",
    "103080": "Malice",
    "103081": "Dice",
    "103082": "Reiden",
    "103083": "Belf",
    "103084": "Roberto",
    "103085": "Gharnef",
    "103086": "Camus",
    "103087": "Michalis",
    "103088": "Legion",
    "103089": "Clarisse",
    "103090": "Eremiya",
    "103091": "Medeus",
    "103092": "Anna",
    "104001": "Sigurd",
    "104002": "Naoise",
    "104003": "Alec",
    "104004": "Arden",
    "104005": "Midir",
    "104006": "Edain",
    "104007": "Brigid",
    "104008": "Azelle",
    "104009": "Claud",
    "104010": "Tailtiu",
    "104011": "Lex",
    "104012": "Quan",
    "104013": "Ethlyn",
    "104014": "Finn",
    "104015": "Ayra",
    "104016": "Jamke",
    "104017": "Lewyn",
    "104018": "Erinys",
    "104019": "Lachesis",
    "104020": "Seliph",
    "104021": "Oifey",
    "104022": "Shannan",
    "104023": "Ulster",
    "104024": "Larcei",
    "104025": "Lana",
    "104026": "Diarmuid",
    "104027": "Lester",
    "104028": "Leif",
    "104029": "Finn",
    "104030": "Nanna",
    "104031": "Tine",
    "104032": "Patty",
    "104033": "Febail",
    "104034": "Arthur",
    "104035": "Fee",
    "104036": "Ced",
    "104037": "Altena",
    "104038": "Hannibal",
    "104039": "Coirpre",
    "104040": "Julia",
    "104041": "Ares",
    "104042": "Lene",
    "104043": "Dalvin",
    "104044": "Creidne",
    "104045": "Muirne",
    "104046": "Tristan",
    "104047": "Deimne",
    "104048": "Jeanne",
    "104049": "Linda",
    "104050": "Daisy",
    "104051": "Asaello",
    "104052": "Amid",
    "104053": "Hermina",
    "104054": "Hawk",
    "104055": "Charlot",
    "104056": "Laylea",
    "104057": "Eldigan",
    "104058": "Cimbaeth",
    "104059": "Munnir",
    "104060": "Sandima",
    "104062": "Chagall",
    "104063": "Annand",
    "104064": "Byron",
    "104065": "Andrey",
    "104066": "Lombard",
    "104067": "Reptor",
    "104068": "Aida",
    "104069": "Arvis",
    "104070": "Danann",
    "104071": "Kutuzov",
    "104072": "Ishtore",
    "104073": "Bloom",
    "104074": "Travant",
    "104075": "Brian",
    "104076": "Scipio",
    "104077": "Hilda",
    "104078": "Ishtar",
    "104079": "Arion",
    "104080": "Manfroy",
    "104081": "Julius",
    "104082": "Dew",
    "104083": "Deirdre",
    "104084": "Chulainn",
    "104085": "Silvia",
    "104086": "Beowolf",
    "104087": "Iuchar",
    "104088": "Iucharba",
    "105001": "Leif",
    "105002": "Finn",
    "105003": "Eyvel",
    "105004": "Halvan",
    "105005": "Osian",
    "105006": "Dagdar",
    "105007": "Tanya",
    "105008": "Marty",
    "105009": "Ronan",
    "105010": "Lifis",
    "105011": "Safy",
    "105012": "Brighton",
    "105013": "Machyua",
    "105014": "Lara",
    "105015": "Fergus",
    "105016": "Karin",
    "105017": "Dalsin",
    "105018": "Asbel",
    "105019": "Nanna",
    "105020": "Hicks",
    "105021": "Shiva",
    "105022": "Carrion",
    "105023": "Selphina",
    "105024": "Caïn",
    "105025": "Alva",
    "105026": "Robert",
    "105027": "Fred",
    "105028": "Olwen",
    "105029": "Mareeta",
    "105030": "Salem",
    "105031": "Perne",
    "105032": "Tina",
    "105033": "Troude",
    "105034": "Glade",
    "105035": "Deen",
    "105036": "Eda",
    "105037": "Homer",
    "105038": "Linoan",
    "105039": "Ralf",
    "105040": "Ilios",
    "105041": "Sleuf",
    "105042": "Sara",
    "105043": "Miranda",
    "105044": "Shannam",
    "105045": "Misha",
    "105046": "Xavier",
    "105047": "Amalda",
    "105048": "Conomor",
    "105049": "Diarmuid",
    "105050": "Saias",
    "105051": "Ced",
    "105052": "Galzus",
    "105053": "Kempf",
    "105054": "Reinhardt",
    "105055": "Raydrik",
    "105056": "Veld",
    "106001": "Roy",
    "106002": "Marcus",
    "106003": "Alen",
    "106004": "Lance",
    "106005": "Wolt",
    "106006": "Bors",
    "106007": "Merlinus",
    "106008": "Elen",
    "106009": "Dieck",
    "106010": "Lot",
    "106011": "Shanna",
    "106012": "Chad",
    "106013": "Lugh",
    "106014": "Clarine",
    "106015": "Rutger",
    "106016": "Saul",
    "106017": "Dorothy",
    "106018": "Sue",
    "106019": "Zelot",
    "106020": "Trec",
    "106021": "Noah",
    "106022": "Astolfo",
    "106023": "Lilina",
    "106024": "Barthe",
    "106025": "Ogier",
    "106026": "Gwendolyn",
    "106027": "Fir",
    "106028": "Sin",
    "106029": "Geese",
    "106030": "Gonzalez",
    "106031": "Klein",
    "106032": "Thea",
    "106033": "Larum",
    "106034": "Elffin",
    "106035": "Echidna",
    "106036": "Bartre",
    "106037": "Raigh",
    "106038": "Cath",
    "106039": "Melady",
    "106040": "Perceval",
    "106041": "Cecilia",
    "106042": "Sophia",
    "106043": "Igrene",
    "106044": "Garret",
    "106045": "Fae",
    "106046": "Hugh",
    "106047": "Zeiss",
    "106048": "Douglas",
    "106049": "Niime",
    "106050": "Juno",
    "106051": "Dayan",
    "106052": "Yoder",
    "106053": "Karel",
    "106054": "Narcian",
    "106055": "Galle",
    "106056": "Hector",
    "106057": "Brunnya",
    "106058": "Murdock",
    "106059": "Eliwood",
    "106060": "Zephiel",
    "106061": "Guinivere",
    "106062": "Jahn",
    "106063": "Idunn",
    "106064": "Wade",
    "107001": "Lyn",
    "107002": "Sain",
    "107003": "Kent",
    "107004": "Florina",
    "107005": "Wil",
    "107006": "Dorcas",
    "107007": "Serra",
    "107008": "Erk",
    "107009": "Rath",
    "107010": "Matthew",
    "107011": "Nils",
    "107012": "Lucius",
    "107013": "Wallace",
    "107014": "Eliwood",
    "107015": "Marcus",
    "107016": "Lowen",
    "107017": "Rebecca",
    "107018": "Bartre",
    "107019": "Hector",
    "107020": "Oswin",
    "107021": "Guy",
    "107022": "Merlinus",
    "107023": "Priscilla",
    "107024": "Raven",
    "107025": "Canas",
    "107026": "Dart",
    "107027": "Fiora",
    "107028": "Legault",
    "107029": "Ninian",
    "107030": "Isadora",
    "107031": "Heath",
    "107032": "Hawkeye",
    "107033": "Geitz",
    "107034": "Pent",
    "107035": "Louise",
    "107036": "Karel",
    "107037": "Harken",
    "107038": "Nino",
    "107039": "Jaffar",
    "107040": "Vaida",
    "107041": "Renaud",
    "107042": "Athos",
    "107043": "Farina",
    "107044": "Karla",
    "107045": "Leila",
    "107046": "Guinivere",
    "107047": "Zephiel",
    "107048": "Lloyd",
    "107049": "Linus",
    "107050": "Ursula",
    "107051": "Ephidel",
    "107052": "Sonia",
    "107053": "Limstella",
    "107054": "Nergal",
    "108001": "Eirika",
    "108002": "Seth",
    "108003": "Gilliam",
    "108004": "Franz",
    "108005": "Moulder",
    "108006": "Vanessa",
    "108007": "Ross",
    "108008": "Garcia",
    "108009": "Neimi",
    "108010": "Colm",
    "108011": "Artur",
    "108012": "Lute",
    "108013": "Natasha",
    "108014": "Joshua",
    "108015": "Ephraim",
    "108016": "Forde",
    "108017": "Kyle",
    "108018": "Orson",
    "108019": "Tana",
    "108020": "Amelia",
    "108021": "Innes",
    "108022": "Gerik",
    "108023": "Tethys",
    "108024": "Marisa",
    "108025": "L'Arachel",
    "108026": "Dozla",
    "108027": "Saleh",
    "108028": "Ewan",
    "108029": "Cormag",
    "108030": "Rennac",
    "108031": "Duessel",
    "108032": "Knoll",
    "108033": "Myrrh",
    "108034": "Syrene",
    "108035": "Caellach",
    "108036": "Riev",
    "108037": "Ismaire",
    "108038": "Selena",
    "108039": "Glen",
    "108040": "Hayden",
    "108041": "Valter",
    "108042": "Fado",
    "108043": "Lyon",
    "109001": "Ike",
    "109002": "Titania",
    "109003": "Oscar",
    "109004": "Boyd",
    "109005": "Rhys",
    "109006": "Shinon",
    "109007": "Gatorie",
    "109008": "Soren",
    "109009": "Mist",
    "109010": "Rolf",
    "109011": "Greil",
    "109012": "Mia",
    "109013": "Kieran",
    "109014": "Brom",
    "109015": "Nephenie",
    "109016": "Lucia",
    "109017": "Bastian",
    "109018": "Geoffrey",
    "109019": "Elincia",
    "109020": "Renning",
    "109021": "Lethe",
    "109022": "Mordecai",
    "109023": "Muarim",
    "109024": "Ranulf",
    "109025": "Giffca",
    "109026": "Caineghis",
    "109027": "Ina",
    "109028": "Nasir",
    "109029": "Gareth",
    "109030": "Kurthnaga",
    "109031": "Deghinsea",
    "109032": "Ulki",
    "109033": "Janaff",
    "109034": "Tibarn",
    "109035": "Reyson",
    "109036": "Leanne",
    "109037": "Naesala",
    "109038": "Nealuchi",
    "109039": "Marcia",
    "109040": "Astrid",
    "109041": "Makalov",
    "109042": "Tormod",
    "109043": "Tanith",
    "109044": "Zelgius",
    "109045": "Sigrun",
    "109046": "Sephiran",
    "109047": "Sanaki",
    "109048": "Jill",
    "109049": "Tauroneo",
    "109050": "Haar",
    "109051": "Petrine",
    "109052": "Bertram",
    "109053": "Chevalier Noir",
    "109054": "Ashnard",
    "109055": "Ilyana",
    "109056": "Volke",
    "109057": "Zihark",
    "109058": "Sothe",
    "109059": "Stefan",
    "109060": "Devdan",
    "109061": "Calill",
    "109062": "Largo",
    "109063": "Elena",
    "110001": "Nolan",
    "110002": "Laura",
    "110003": "Sothe",
    "110004": "Edward",
    "110005": "Micaiah",
    "110006": "Ike",
    "110007": "Izuka",
    "110008": "Ina",
    "110009": "Ilyana",
    "110010": "Danved",
    "110011": "Ulki",
    "110012": "Elincia",
    "110013": "Oscar",
    "110014": "Oliver",
    "110015": "Volug",
    "110016": "Caineghis",
    "110017": "Gatorie",
    "110018": "Calill",
    "110019": "Kysha",
    "110020": "Rhys",
    "110021": "Kurthnaga",
    "110022": "Kieran",
    "110023": "Gareth",
    "110024": "Sanaki",
    "110025": "Sigrun",
    "110026": "Chevalier Noir",
    "110027": "Shinon",
    "110028": "Giffca",
    "110029": "Geoffrey",
    "110030": "Jill",
    "110031": "Skrimir",
    "110032": "Astrid",
    "110033": "Soren",
    "110034": "Sephiran",
    "110035": "Zelgius",
    "110036": "Stefan",
    "110037": "Tauroneo",
    "110038": "Tanith",
    "110039": "Brom",
    "110040": "Zihark",
    "110041": "Titania",
    "110042": "Tibarn",
    "110043": "Deghinsea",
    "110044": "Tormod",
    "110045": "Nasir",
    "110046": "Nealuchi",
    "110047": "Nailah",
    "110048": "Naesala",
    "110049": "Nephenie",
    "110050": "Haar",
    "110051": "Vika",
    "110052": "Volke",
    "110053": "Aran",
    "110054": "Fiona",
    "110055": "Heather",
    "110056": "Hetzel",
    "110057": "Pelleas",
    "110058": "Boyd",
    "110059": "Marcia",
    "110060": "Makalov",
    "110061": "Mist",
    "110062": "Muarim",
    "110063": "Meg",
    "110064": "Mordecai",
    "110065": "Janaff",
    "110066": "Bastian",
    "110067": "Rolf",
    "110068": "Ranulf",
    "110069": "Rafiel",
    "110070": "Leanne",
    "110071": "Lyre",
    "110072": "Reyson",
    "110073": "Lucia",
    "110074": "Leonardo",
    "110075": "Lethe",
    "110076": "Renning",
    "110077": "Mia",
    "110078": "Anna",
    "110079": "Muston",
    "110080": "Aimee",
    "110081": "Jorge",
    "110082": "Daniel",
    "110083": "Jarod",
    "110084": "Valtome",
    "110085": "Ashunera",
    "110086": "Ashera",
    "110087": "Yune",
    "110089": "Largo",
    "110090": "Amy",
    "110091": "Almedha",
    "111001": "Daraen (homme)",
    "111002": "Daraen (femme)",
    "111003": "Chrom",
    "111004": "Frederick",
    "111005": "Kellam",
    "111006": "Ricken",
    "111007": "Vaike",
    "111008": "Lon'zu",
    "111009": "Virion",
    "111010": "Basilio",
    "111011": "Sumia",
    "111012": "Lissa",
    "111013": "Zelcher",
    "111014": "Miriel",
    "111015": "Marth (masqué)",
    "111016": "Lucina",
    "111017": "Walhart",
    "111018": "Emmeryn",
    "111019": "Valldar",
    "111020": "Sully",
    "111021": "Stahl",
    "111022": "Maribelle",
    "111023": "Palne",
    "111024": "Gaius",
    "111025": "Cordelia",
    "111026": "Gregor",
    "111027": "Nowi",
    "111028": "Libra",
    "111029": "Tharja",
    "111030": "Olivia",
    "111031": "Henry",
    "111032": "Say'ri",
    "111033": "Flavia",
    "111034": "Donnel",
    "111035": "Owain",
    "111036": "Íñigo",
    "111037": "Brady",
    "111038": "Kjelle",
    "111039": "Cynthia",
    "111040": "Severa",
    "111041": "Gerome",
    "111042": "Linfan (garçon)",
    "111043": "Linfan (fille)",
    "111044": "Yarne",
    "111045": "Laurent",
    "111046": "Noire",
    "111047": "Nah",
    "111048": "Tiki",
    "111049": "Anna",
    "111050": "Aversa",
    "111051": "Priam",
    "111052": "Gangrel",
    "111053": "Yen'fay",
    "111054": "Mustafa",
    "111055": "Cervantes",
    "111056": "Excellus",
    "111057": "Naga",
    "111058": "Grima",
    "112001": "Corrin (homme)",
    "112002": "Corrin (femme)",
    "112003": "Jakob",
    "112004": "Silas",
    "112005": "Kaze",
    "112006": "Ryoma",
    "112007": "Takumi",
    "112008": "Saizo",
    "112009": "Kaden",
    "112010": "Hinata",
    "112011": "Azama",
    "112012": "Subaki",
    "112013": "Hayato",
    "112014": "Xander",
    "112015": "Leo",
    "112016": "Benny",
    "112017": "Keaton",
    "112018": "Arthur",
    "112019": "Odin",
    "112020": "Laslow",
    "112021": "Niles",
    "112022": "Felicia",
    "112023": "Azura",
    "112024": "Mozu",
    "112025": "Hinoka",
    "112026": "Sakura",
    "112027": "Orochi",
    "112028": "Kagero",
    "112029": "Hana",
    "112030": "Setsuna",
    "112031": "Reina",
    "112032": "Oboro",
    "112033": "Camilla",
    "112034": "Elise",
    "112035": "Charlotte",
    "112036": "Effie",
    "112037": "Peri",
    "112038": "Beruka",
    "112039": "Selena",
    "112040": "Nyx",
    "112041": "Kana (fille)",
    "112042": "Kana (garçon)",
    "112043": "Shigure",
    "112044": "Dwyer",
    "112045": "Sophie",
    "112046": "Midori",
    "112047": "Shiro",
    "112048": "Kiragi",
    "112049": "Asugi",
    "112050": "Selkie",
    "112051": "Hisame",
    "112052": "Mitama",
    "112053": "Caeldori",
    "112054": "Rhajat",
    "112055": "Siegbert",
    "112056": "Ignatius",
    "112057": "Forrest",
    "112058": "Velouria",
    "112059": "Percy",
    "112060": "Ophelia",
    "112061": "Soleil",
    "112062": "Nina",
    "112063": "Shura",
    "112064": "Fuga",
    "112065": "Yukimura",
    "112066": "Izana",
    "112067": "Gunter",
    "112068": "Nichol",
    "112069": "Rinkah",
    "112070": "Anna",
    "112071": "Scarlet",
    "112072": "Candace",
    "112073": "Flora",
    "112074": "Lilith",
    "112075": "Arete",
    "112076": "Garon",
    "112077": "Sumeragi",
    "112078": "Mikoto",
    "112079": "Iago",
    "112080": "Zola",
    "112081": "Hans",
    "112082": "Layla",
    "112083": "Sage de l'iris",
    "112084": "Anankos",
    "113001": "Alfonse",
    "113002": "Sharena",
    "113003": "Anna",
    "113004": "Veronica",
    "113005": "Bruno",
    "113006": "Fjorm",
    "113007": "Gunnthrá",
    "113008": "Surtr",
    "113009": "Laevatein",
    "113010": "Loki",
    "113011": "Helbindi",
    "113012": "Laegjarn",
    "113013": "Ylgr",
    "113014": "Hríd",
    "113015": "Eir",
    "113016": "Líf",
    "113017": "Thrasir",
    "113018": "Hel",
    "113019": "Triandra",
    "113020": "Peony",
    "113021": "Plumeria",
    "113022": "Freyr",
    "114001": "Itsuki & Chrom",
    "114002": "Tsubasa & Shiida",
    "114003": "Touma & Caïn",
    "114004": "Kiria & Tharja",
    "114005": "Yashiro & Nabarl",
    "114006": "Eleonora & Virion",
    "114007": "Mamori & Edgar",
    "114008": "Maiko",
    "114009": "Tiki",
    "114010": "Barry",
    "114011": "Ayaha & Aversa",
    "114012": "Chikaomi & Lon'zu",
    "114013": "Teru & Garrick",
    "114014": "Nobu & Gangrel",
    "114015": "Kuen & Excellus",
    "114016": "Yatsufusa & Gharnef",
    "114017": "Chouten & Pheros",
    "114018": "Riku & Abel",
    "115001": "Byleth (homme)",
    "115002": "Byleth (homme, prophète)",
    "115003": "Byleth (femme)",
    "115004": "Byleth (femme, prophète)",
    "115005": "Edelgard",
    "115006": "Dimitri",
    "115007": "Claude",
    "115008": "Hubert",
    "115009": "Ferdinand",
    "115010": "Linhardt",
    "115011": "Caspar",
    "115012": "Bernadetta",
    "115013": "Dorothea",
    "115014": "Petra",
    "115015": "Dedue",
    "115016": "Felix",
    "115017": "Ashe",
    "115018": "Sylvain",
    "115019": "Mercedes",
    "115020": "Annette",
    "115021": "Ingrid",
    "115022": "Lorenz",
    "115023": "Raphael",
    "115024": "Ignatz",
    "115025": "Lysithea",
    "115026": "Marianne",
    "115027": "Hilda",
    "115028": "Leonie",
    "115029": "Seteth",
    "115030": "Flayn",
    "115031": "Hanneman",
    "115032": "Manuela",
    "115033": "Gilbert",
    "115034": "Alois",
    "115035": "Catherine",
    "115036": "Shamir",
    "115037": "Cyril",
    "115038": "Jeralt",
    "115039": "Rhea",
    "115040": "Sothis",
    "115041": "Kronya",
    "115042": "Solon",
    "115043": "Chevalier Macabre",
    "115044": "Kostas",
    "115045": "Lonato",
    "115046": "Miklan",
    "115047": "Empereur des Flammes",
    "115048": "Anna",
    "115049": "Jeritza",
    "115050": "Rodrigue",
    "115051": "Judith",
    "115052": "Monica",
    "115053": "Seigneur Arundel",
    "115054": "Tomas",
    "115055": "Empereur Ionius IX",
    "115056": "Metodey",
    "115057": "Ladislava",
    "115058": "Acheron",
    "116001": "Edelgard",
    "116002": "Dimitri",
    "116003": "Claude",
    "116004": "Hubert",
    "116005": "Ferdinand",
    "116006": "Linhardt",
    "116007": "Caspar",
    "116008": "Bernadetta",
    "116009": "Dorothea",
    "116010": "Petra",
    "116011": "Dedue",
    "116012": "Felix",
    "116013": "Ashe",
    "116014": "Sylvain",
    "116015": "Mercedes",
    "116016": "Annette",
    "116017": "Ingrid",
    "116018": "Lorenz",
    "116019": "Raphael",
    "116020": "Ignatz",
    "116021": "Lysithea",
    "116022": "Marianne",
    "116023": "Hilda",
    "116024": "Leonie",
    "116025": "Cyril",
    "116026": "Thales",
    "116027": "Cornelia",
    "116028": "Randolph",
    "116029": "Nader",
    "116030": "Nemesis",
    "116031": "Seiros",
    "116032": "Duc Aegir",
    "116033": "Lambert",
    "116034": "Gwendal",
    "116035": "Pallardó"
  },
  "it-IT": {
    "101001": "Marth",
    "101002": "Shiida",
    "101003": "Jagen",
    "101004": "Cain",
    "101005": "Abel",
    "101006": "Aidraug",
    "101007": "Gordin",
    "101008": "Wrys",
    "101009": "Ogma",
    "101010": "Barst",
    "101011": "Bord",
    "101012": "Cord",
    "101013": "Castor",
    "101014": "Darros",
    "101015": "Julian",
    "101016": "Lena",
    "101017": "Nabarl",
    "101018": "Merric",
    "101019": "Matthis",
    "101020": "Hardin",
    "101021": "Wolf",
    "101022": "Sedgar",
    "101023": "Roshea",
    "101024": "Vyland",
    "101025": "Wendell",
    "101026": "Rickard",
    "101027": "Bantu",
    "101028": "Caesar",
    "101029": "Radd",
    "101030": "Roger",
    "101031": "Jeorge",
    "101032": "Marian",
    "101033": "Minerva",
    "101034": "Linde",
    "101035": "Jake",
    "101036": "Midia",
    "101037": "Dolph",
    "101038": "Macellan",
    "101039": "Tomas",
    "101040": "Boah",
    "101041": "Beck",
    "101042": "Astram",
    "101043": "Paula",
    "101044": "Catria",
    "101045": "Arran",
    "101046": "Samson",
    "101047": "Xane",
    "101048": "Esther",
    "101049": "Tiki",
    "101050": "Lorenz",
    "101051": "Elice",
    "101052": "Gotoh",
    "101053": "Frey",
    "101054": "Norne",
    "101055": "Athena",
    "101056": "Horace",
    "101057": "Etzel",
    "101058": "Ymir",
    "101059": "Nagi",
    "101060": "Malledus",
    "101061": "Nyna",
    "101062": "Gharnef",
    "101063": "Camus",
    "101064": "Michalis",
    "101065": "Medeus",
    "101066": "Anna",
    "102001": "Alm",
    "102002": "Lukas",
    "102003": "Gray",
    "102004": "Tobin",
    "102005": "Kliff",
    "102006": "Silque",
    "102007": "Clair",
    "102008": "Clive",
    "102009": "Forsyth",
    "102010": "Python",
    "102011": "Celica",
    "102012": "Mae",
    "102013": "Boey",
    "102014": "Genny",
    "102015": "Saber",
    "102016": "Valbar",
    "102017": "Kamui",
    "102018": "Leon",
    "102019": "Luthier",
    "102020": "Mathilda",
    "102021": "Delthea",
    "102022": "Paula",
    "102023": "Catria",
    "102024": "Atlas",
    "102025": "Jesse",
    "102026": "Deen",
    "102027": "Sonya",
    "102028": "Esther",
    "102029": "Nomah",
    "102030": "Tatiana",
    "102031": "Zeke",
    "102032": "Mycen",
    "102033": "Desaix",
    "102034": "Grieth",
    "102035": "Rudolf",
    "102036": "Faye",
    "102037": "Clive",
    "102038": "Conrad",
    "102039": "Berkut",
    "102040": "Rinea",
    "102041": "Fernand",
    "102042": "Jedah",
    "102043": "Slayde",
    "102044": "Massena",
    "102045": "Lawson",
    "102046": "Jerome",
    "102047": "Tatarrah",
    "102048": "Dolth",
    "102049": "Nuibaba",
    "102050": "Hestia",
    "102051": "Marla",
    "102052": "Barth",
    "102053": "Garth",
    "102054": "Blake",
    "102055": "Mila",
    "102056": "Duma",
    "102057": "Boss",
    "102058": "Halcyon",
    "102059": "Irma",
    "103001": "Marth",
    "103002": "Kris (maschio)",
    "103003": "Kris (femmina)",
    "103004": "Abel",
    "103005": "Arran",
    "103006": "Astram",
    "103007": "Bantu",
    "103008": "Barst",
    "103009": "Beck",
    "103010": "Vyland",
    "103011": "Boah",
    "103012": "Xane",
    "103013": "Darros",
    "103014": "Aidraug",
    "103015": "Elice",
    "103016": "Esther",
    "103017": "Gotoh",
    "103018": "Gordin",
    "103020": "Jagen",
    "103021": "Jake",
    "103022": "Jeorge",
    "103023": "Julian",
    "103024": "Cain",
    "103025": "Castor",
    "103026": "Catria",
    "103027": "Cord",
    "103028": "Marian",
    "103029": "Merric",
    "103030": "Matthis",
    "103031": "Midia",
    "103032": "Minerva",
    "103033": "Macellan",
    "103034": "Nabarl",
    "103035": "Ogma",
    "103036": "Paula",
    "103037": "Radd",
    "103038": "Lena",
    "103039": "Rickard",
    "103040": "Wrys",
    "103041": "Linde",
    "103042": "Roger",
    "103043": "Lorenz",
    "103044": "Roshea",
    "103045": "Bord",
    "103046": "Samson",
    "103047": "Caesar",
    "103048": "Shiida",
    "103049": "Tomas",
    "103050": "Tiki",
    "103051": "Dolph",
    "103052": "Wendell",
    "103053": "Wolf",
    "103054": "Sedgar",
    "103055": "Frey",
    "103056": "Norne",
    "103057": "Athena",
    "103058": "Horace",
    "103059": "Etzel",
    "103060": "Ymir",
    "103061": "Nagi",
    "103062": "Nyna",
    "103063": "Katarina",
    "103064": "Roderick",
    "103065": "Cecil",
    "103066": "Yuliya",
    "103067": "Jubelo",
    "103068": "Lang",
    "103069": "Hardin",
    "103070": "Luke",
    "103071": "Marisha",
    "103072": "Ryan",
    "103073": "Sirius",
    "103074": "Samuel",
    "103075": "Warren",
    "103076": "Sheena",
    "103077": "Phina",
    "103078": "Arlen",
    "103079": "Frost",
    "103080": "Malice",
    "103081": "Dice",
    "103082": "Reiden",
    "103083": "Belf",
    "103084": "Roberto",
    "103085": "Gharnef",
    "103086": "Camus",
    "103087": "Michalis",
    "103088": "Legion",
    "103089": "Clarisse",
    "103090": "Eremiya",
    "103091": "Medeus",
    "103092": "Anna",
    "104001": "Sigurd",
    "104002": "Naoise",
    "104003": "Alec",
    "104004": "Arden",
    "104005": "Midir",
    "104006": "Edain",
    "104007": "Brigid",
    "104008": "Azelle",
    "104009": "Claud",
    "104010": "Tailtiu",
    "104011": "Lex",
    "104012": "Quan",
    "104013": "Ethlyn",
    "104014": "Finn",
    "104015": "Ayra",
    "104016": "Jamke",
    "104017": "Lewyn",
    "104018": "Erinys",
    "104019": "Lachesis",
    "104020": "Seliph",
    "104021": "Oifey",
    "104022": "Shannan",
    "104023": "Ulster",
    "104024": "Larcei",
    "104025": "Lana",
    "104026": "Diarmuid",
    "104027": "Lester",
    "104028": "Leif",
    "104029": "Finn",
    "104030": "Nanna",
    "104031": "Tine",
    "104032": "Patty",
    "104033": "Febail",
    "104034": "Arthur",
    "104035": "Fee",
    "104036": "Ced",
    "104037": "Altena",
    "104038": "Hannibal",
    "104039": "Coirpre",
    "104040": "Julia",
    "104041": "Ares",
    "104042": "Lene",
    "104043": "Dalvin",
    "104044": "Creidne",
    "104045": "Muirne",
    "104046": "Tristan",
    "104047": "Deimne",
    "104048": "Jeanne",
    "104049": "Linda",
    "104050": "Daisy",
    "104051": "Asaello",
    "104052": "Amid",
    "104053": "Hermina",
    "104054": "Hawk",
    "104055": "Charlot",
    "104056": "Laylea",
    "104057": "Eldigan",
    "104058": "Cimbaeth",
    "104059": "Munnir",
    "104060": "Sandima",
    "104062": "Chagall",
    "104063": "Annand",
    "104064": "Byron",
    "104065": "Andrey",
    "104066": "Lombard",
    "104067": "Reptor",
    "104068": "Aida",
    "104069": "Arvis",
    "104070": "Danann",
    "104071": "Kutuzov",
    "104072": "Ishtore",
    "104073": "Bloom",
    "104074": "Travant",
    "104075": "Brian",
    "104076": "Scipio",
    "104077": "Hilda",
    "104078": "Ishtar",
    "104079": "Arion",
    "104080": "Manfroy",
    "104081": "Julius",
    "104082": "Dew",
    "104083": "Deirdre",
    "104084": "Chulainn",
    "104085": "Silvia",
    "104086": "Beowolf",
    "104087": "Iuchar",
    "104088": "Iucharba",
    "105001": "Leif",
    "105002": "Finn",
    "105003": "Eyvel",
    "105004": "Halvan",
    "105005": "Osian",
    "105006": "Dagdar",
    "105007": "Tanya",
    "105008": "Marty",
    "105009": "Ronan",
    "105010": "Lifis",
    "105011": "Safy",
    "105012": "Brighton",
    "105013": "Machyua",
    "105014": "Lara",
    "105015": "Fergus",
    "105016": "Karin",
    "105017": "Dalsin",
    "105018": "Asbel",
    "105019": "Nanna",
    "105020": "Hicks",
    "105021": "Shiva",
    "105022": "Carrion",
    "105023": "Selphina",
    "105024": "Cain",
    "105025": "Alva",
    "105026": "Robert",
    "105027": "Fred",
    "105028": "Olwen",
    "105029": "Mareeta",
    "105030": "Salem",
    "105031": "Perne",
    "105032": "Tina",
    "105033": "Troude",
    "105034": "Glade",
    "105035": "Deen",
    "105036": "Eda",
    "105037": "Homer",
    "105038": "Linoan",
    "105039": "Ralf",
    "105040": "Ilios",
    "105041": "Sleuf",
    "105042": "Sara",
    "105043": "Miranda",
    "105044": "Shannam",
    "105045": "Misha",
    "105046": "Xavier",
    "105047": "Amalda",
    "105048": "Conomor",
    "105049": "Diarmuid",
    "105050": "Saias",
    "105051": "Ced",
    "105052": "Galzus",
    "105053": "Kempf",
    "105054": "Reinhardt",
    "105055": "Raydrik",
    "105056": "Veld",
    "106001": "Roy",
    "106002": "Marcus",
    "106003": "Alen",
    "106004": "Lance",
    "106005": "Wolt",
    "106006": "Bors",
    "106007": "Merlinus",
    "106008": "Elen",
    "106009": "Dieck",
    "106010": "Lot",
    "106011": "Shanna",
    "106012": "Chad",
    "106013": "Lugh",
    "106014": "Clarine",
    "106015": "Rutger",
    "106016": "Saul",
    "106017": "Dorothy",
    "106018": "Sue",
    "106019": "Zelot",
    "106020": "Trec",
    "106021": "Noah",
    "106022": "Astolfo",
    "106023": "Lilina",
    "106024": "Barthe",
    "106025": "Ogier",
    "106026": "Gwendolyn",
    "106027": "Fir",
    "106028": "Sin",
    "106029": "Geese",
    "106030": "Gonzalez",
    "106031": "Klein",
    "106032": "Thea",
    "106033": "Larum",
    "106034": "Elffin",
    "106035": "Echidna",
    "106036": "Bartre",
    "106037": "Raigh",
    "106038": "Cath",
    "106039": "Melady",
    "106040": "Perceval",
    "106041": "Cecilia",
    "106042": "Sophia",
    "106043": "Igrene",
    "106044": "Garret",
    "106045": "Fae",
    "106046": "Hugh",
    "106047": "Zeiss",
    "106048": "Douglas",
    "106049": "Niime",
    "106050": "Juno",
    "106051": "Dayan",
    "106052": "Yoder",
    "106053": "Karel",
    "106054": "Narcian",
    "106055": "Galle",
    "106056": "Hector",
    "106057": "Brunnya",
    "106058": "Murdock",
    "106059": "Eliwood",
    "106060": "Zephiel",
    "106061": "Guinivere",
    "106062": "Jahn",
    "106063": "Idunn",
    "106064": "Wade",
    "107001": "Lyn",
    "107002": "Sain",
    "107003": "Kent",
    "107004": "Florina",
    "107005": "Wil",
    "107006": "Dorcas",
    "107007": "Serra",
    "107008": "Erk",
    "107009": "Rath",
    "107010": "Matthew",
    "107011": "Nils",
    "107012": "Lucius",
    "107013": "Wallace",
    "107014": "Eliwood",
    "107015": "Marcus",
    "107016": "Lowen",
    "107017": "Rebecca",
    "107018": "Bartre",
    "107019": "Hector",
    "107020": "Oswin",
    "107021": "Guy",
    "107022": "Merlinus",
    "107023": "Priscilla",
    "107024": "Raven",
    "107025": "Canas",
    "107026": "Dart",
    "107027": "Fiora",
    "107028": "Legault",
    "107029": "Ninian",
    "107030": "Isadora",
    "107031": "Heath",
    "107032": "Tronk",
    "107033": "Geitz",
    "107034": "Pent",
    "107035": "Louise",
    "107036": "Karel",
    "107037": "Harken",
    "107038": "Nina",
    "107039": "Jaffar",
    "107040": "Vaida",
    "107041": "Renaud",
    "107042": "Athos",
    "107043": "Freya",
    "107044": "Karla",
    "107045": "Leila",
    "107046": "Guinivere",
    "107047": "Zephiel",
    "107048": "Lloyd",
    "107049": "Linus",
    "107050": "Ursula",
    "107051": "Ephidel",
    "107052": "Sonia",
    "107053": "Limstella",
    "107054": "Nergal",
    "108001": "Erika",
    "108002": "Seth",
    "108003": "Gilliam",
    "108004": "Franz",
    "108005": "Moulder",
    "108006": "Vanessa",
    "108007": "Ross",
    "108008": "Garcia",
    "108009": "Neimi",
    "108010": "Colm",
    "108011": "Arthur",
    "108012": "Lute",
    "108013": "Natasha",
    "108014": "Joshua",
    "108015": "Ephraim",
    "108016": "Forde",
    "108017": "Kyle",
    "108018": "Orson",
    "108019": "Dana",
    "108020": "Amelia",
    "108021": "Innes",
    "108022": "Gerik",
    "108023": "Tethys",
    "108024": "Marisa",
    "108025": "L'Arachel",
    "108026": "Dozla",
    "108027": "Saleh",
    "108028": "Ewan",
    "108029": "Cormag",
    "108030": "Rennac",
    "108031": "Duessel",
    "108032": "Knoll",
    "108033": "Myrrh",
    "108034": "Syrene",
    "108035": "Caellach",
    "108036": "Riev",
    "108037": "Ismaire",
    "108038": "Selena",
    "108039": "Glen",
    "108040": "Hayden",
    "108041": "Valter",
    "108042": "Fado",
    "108043": "Lyon",
    "109001": "Ike",
    "109002": "Titania",
    "109003": "Oscar",
    "109004": "Boyd",
    "109005": "Rhys",
    "109006": "Shinon",
    "109007": "Gatrie",
    "109008": "Soren",
    "109009": "Mist",
    "109010": "Rolf",
    "109011": "Greil",
    "109012": "Mia",
    "109013": "Kieran",
    "109014": "Brom",
    "109015": "Nephenee",
    "109016": "Lucia",
    "109017": "Bastian",
    "109018": "Geoffrey",
    "109019": "Elincia",
    "109020": "Renning",
    "109021": "Lethe",
    "109022": "Mordecai",
    "109023": "Muarim",
    "109024": "Ranulf",
    "109025": "Giffca",
    "109026": "Caineghis",
    "109027": "Ena",
    "109028": "Nasir",
    "109029": "Gareth",
    "109030": "Kurthnaga",
    "109031": "Deghinsea",
    "109032": "Ulki",
    "109033": "Janaff",
    "109034": "Tibarn",
    "109035": "Reyson",
    "109036": "Leanne",
    "109037": "Naesala",
    "109038": "Nealuchi",
    "109039": "Darcia",
    "109040": "Astrid",
    "109041": "Makalov",
    "109042": "Tormod",
    "109043": "Tanith",
    "109044": "Zelgius",
    "109045": "Sigrun",
    "109046": "Sephiran",
    "109047": "Sanaki",
    "109048": "Jill",
    "109049": "Tauroneo",
    "109050": "Haar",
    "109051": "Petrine",
    "109052": "Bertram",
    "109053": "Cavaliere nero",
    "109054": "Ashnard",
    "109055": "Ilyana",
    "109056": "Volke",
    "109057": "Zihark",
    "109058": "Sothe",
    "109059": "Stefan",
    "109060": "Devdan",
    "109061": "Calill",
    "109062": "Largo",
    "109063": "Elena",
    "110001": "Nolan",
    "110002": "Laura",
    "110003": "Sothe",
    "110004": "Edward",
    "110005": "Micaiah",
    "110006": "Ike",
    "110007": "Izuka",
    "110008": "Ena",
    "110009": "Ilyana",
    "110010": "Danved",
    "110011": "Ulki",
    "110012": "Elincia",
    "110013": "Oscar",
    "110014": "Oliver",
    "110015": "Volug",
    "110016": "Caineghis",
    "110017": "Gatrie",
    "110018": "Calill",
    "110019": "Kysha",
    "110020": "Rhys",
    "110021": "Kurthnaga",
    "110022": "Kieran",
    "110023": "Gareth",
    "110024": "Sanaki",
    "110025": "Sigrun",
    "110026": "Cavaliere nero",
    "110027": "Shinon",
    "110028": "Giffca",
    "110029": "Geoffrey",
    "110030": "Jill",
    "110031": "Skrimir",
    "110032": "Astrid",
    "110033": "Soren",
    "110034": "Sephiran",
    "110035": "Zelgius",
    "110036": "Stefan",
    "110037": "Tauroneo",
    "110038": "Tanith",
    "110039": "Brom",
    "110040": "Zihark",
    "110041": "Titania",
    "110042": "Tibarn",
    "110043": "Deghinsea",
    "110044": "Tormod",
    "110045": "Nasir",
    "110046": "Nealuchi",
    "110047": "Nailah",
    "110048": "Naesala",
    "110049": "Nephenee",
    "110050": "Haar",
    "110051": "Vika",
    "110052": "Volke",
    "110053": "Aran",
    "110054": "Fiona",
    "110055": "Heather",
    "110056": "Hetzel",
    "110057": "Pelleas",
    "110058": "Boyd",
    "110059": "Darcia",
    "110060": "Makalov",
    "110061": "Mist",
    "110062": "Muarim",
    "110063": "Meg",
    "110064": "Mordecai",
    "110065": "Janaff",
    "110066": "Bastian",
    "110067": "Rolf",
    "110068": "Ranulf",
    "110069": "Rafiel",
    "110070": "Leanne",
    "110071": "Lyre",
    "110072": "Reyson",
    "110073": "Lucia",
    "110074": "Leonardo",
    "110075": "Lethe",
    "110076": "Renning",
    "110077": "Mia",
    "110078": "Anna",
    "110079": "Muston",
    "110080": "Aimee",
    "110081": "Jorge",
    "110082": "Daniel",
    "110083": "Jarod",
    "110084": "Valtome",
    "110085": "Ashunera",
    "110086": "Ashera",
    "110087": "Yune",
    "110089": "Largo",
    "110090": "Amy",
    "110091": "Almedha",
    "111001": "Daraen (maschio)",
    "111002": "Daraen (femmina)",
    "111003": "Chrom",
    "111004": "Frederick",
    "111005": "Kellam",
    "111006": "Ricken",
    "111007": "Vaike",
    "111008": "Lon'zu",
    "111009": "Virion",
    "111010": "Basilio",
    "111011": "Sumia",
    "111012": "Lissa",
    "111013": "Zelcher",
    "111014": "Miriel",
    "111015": "Marth mascherato",
    "111016": "Lucina",
    "111017": "Walhart",
    "111018": "Emmeryn",
    "111019": "Valldar",
    "111020": "Sully",
    "111021": "Stahl",
    "111022": "Maribelle",
    "111023": "Palne",
    "111024": "Gaius",
    "111025": "Cordelia",
    "111026": "Gregor",
    "111027": "Nowi",
    "111028": "Libra",
    "111029": "Tharja",
    "111030": "Olivia",
    "111031": "Henry",
    "111032": "Say'ri",
    "111033": "Flavia",
    "111034": "Donnel",
    "111035": "Owain",
    "111036": "Íñigo",
    "111037": "Brady",
    "111038": "Kjelle",
    "111039": "Cynthia",
    "111040": "Severa",
    "111041": "Gerome",
    "111042": "Linfan (maschio)",
    "111043": "Linfan (femmina)",
    "111044": "Yarne",
    "111045": "Laurent",
    "111046": "Noire",
    "111047": "Nah",
    "111048": "Tiki",
    "111049": "Anna",
    "111050": "Aversa",
    "111051": "Priam",
    "111052": "Gangrel",
    "111053": "Yen'fay",
    "111054": "Mustafa",
    "111055": "Cervantes",
    "111056": "Excellus",
    "111057": "Naga",
    "111058": "Grima",
    "112001": "Corrin (maschio)",
    "112002": "Corrin (femmina)",
    "112003": "Jakob",
    "112004": "Silas",
    "112005": "Kaze",
    "112006": "Ryoma",
    "112007": "Takumi",
    "112008": "Saizo",
    "112009": "Kaden",
    "112010": "Hinata",
    "112011": "Azama",
    "112012": "Subaki",
    "112013": "Hayato",
    "112014": "Xander",
    "112015": "Leo",
    "112016": "Benny",
    "112017": "Keaton",
    "112018": "Arthur",
    "112019": "Odin",
    "112020": "Laslow",
    "112021": "Niles",
    "112022": "Felicia",
    "112023": "Azura",
    "112024": "Mozu",
    "112025": "Hinoka",
    "112026": "Sakura",
    "112027": "Orochi",
    "112028": "Kagero",
    "112029": "Hana",
    "112030": "Setsuna",
    "112031": "Reina",
    "112032": "Oboro",
    "112033": "Camilla",
    "112034": "Elise",
    "112035": "Charlotte",
    "112036": "Effie",
    "112037": "Peri",
    "112038": "Beruka",
    "112039": "Selena",
    "112040": "Nyx",
    "112041": "Kana (femmina)",
    "112042": "Kana (maschio)",
    "112043": "Shigure",
    "112044": "Dwyer",
    "112045": "Sophie",
    "112046": "Midori",
    "112047": "Shiro",
    "112048": "Kiragi",
    "112049": "Asugi",
    "112050": "Selkie",
    "112051": "Hisame",
    "112052": "Mitama",
    "112053": "Caeldori",
    "112054": "Rhajat",
    "112055": "Siegbert",
    "112056": "Ignatius",
    "112057": "Forrest",
    "112058": "Velouria",
    "112059": "Percy",
    "112060": "Ophelia",
    "112061": "Soleil",
    "112062": "Nina la Ladra",
    "112063": "Shura",
    "112064": "Fuga",
    "112065": "Yukimura",
    "112066": "Izana",
    "112067": "Gunter",
    "112068": "Nichol",
    "112069": "Rinkah",
    "112070": "Anna",
    "112071": "Scarlet",
    "112072": "Candace",
    "112073": "Flora",
    "112074": "Lilith",
    "112075": "Arete",
    "112076": "Garon",
    "112077": "Sumeragi",
    "112078": "Mikoto",
    "112079": "Iago",
    "112080": "Zola",
    "112081": "Hans",
    "112082": "Layla",
    "112083": "Il savio irideo",
    "112084": "Anankos",
    "113001": "Alfonse",
    "113002": "Sharena",
    "113003": "Anna",
    "113004": "Veronica",
    "113005": "Bruno",
    "113006": "Fjorm",
    "113007": "Gunnthrá",
    "113008": "Surtr",
    "113009": "Laevatein",
    "113010": "Loki",
    "113011": "Helbindi",
    "113012": "Laegjarn",
    "113013": "Ylgr",
    "113014": "Hríd",
    "113015": "Eir",
    "113016": "Líf",
    "113017": "Thrasir",
    "113018": "Hel",
    "113019": "Triandra",
    "113020": "Peony",
    "113021": "Plumeria",
    "113022": "Freyr",
    "114001": "Itsuki e Chrom",
    "114002": "Tsubasa e Shiida",
    "114003": "Touma e Cain",
    "114004": "Kiria e Tharja",
    "114005": "Yashiro e Nabarl",
    "114006": "Eleonora e Virion",
    "114007": "Mamori e Aidraug",
    "114008": "Maiko",
    "114009": "Tiki",
    "114010": "Barry",
    "114011": "Ayaha e Aversa",
    "114012": "Chikaomi e Lon'zu",
    "114013": "Teru e Garrick",
    "114014": "Nobu e Gangrel",
    "114015": "Kuen ed Excellus",
    "114016": "Yatsufusa e Gharnef",
    "114017": "Chouten e Pheros",
    "114018": "Riku e Abel",
    "115001": "Byleth (maschio)",
    "115002": "Byleth (maschio, Sapiente)",
    "115003": "Byleth (femmina)",
    "115004": "Byleth (femmina, Sapiente)",
    "115005": "Edelgard",
    "115006": "Dimitri",
    "115007": "Claude",
    "115008": "Hubert",
    "115009": "Ferdinand",
    "115010": "Linhardt",
    "115011": "Caspar",
    "115012": "Bernadetta",
    "115013": "Dorothea",
    "115014": "Petra",
    "115015": "Dedue",
    "115016": "Felix",
    "115017": "Ashe",
    "115018": "Sylvain",
    "115019": "Mercedes",
    "115020": "Annette",
    "115021": "Ingrid",
    "115022": "Lorenz",
    "115023": "Raphael",
    "115024": "Ignatz",
    "115025": "Lysithea",
    "115026": "Marianne",
    "115027": "Hilda",
    "115028": "Leonie",
    "115029": "Seteth",
    "115030": "Flayn",
    "115031": "Hanneman",
    "115032": "Manuela",
    "115033": "Gilbert",
    "115034": "Alois",
    "115035": "Catherine",
    "115036": "Shamir",
    "115037": "Cyril",
    "115038": "Jeralt",
    "115039": "Rhea",
    "115040": "Sothis",
    "115041": "Kronya",
    "115042": "Solon",
    "115043": "Cavaliere Infernale",
    "115044": "Kostas",
    "115045": "Lonato",
    "115046": "Miklan",
    "115047": "Imperatore della Fiamma",
    "115048": "Anna",
    "115049": "Jeritza",
    "115050": "Rodrigue",
    "115051": "Judith",
    "115052": "Monica",
    "115053": "Lord Arundel",
    "115054": "Tomas",
    "115055": "Imperatore Ionius IX",
    "115056": "Metodey",
    "115057": "Ladislava",
    "115058": "Acheron",
    "116001": "Edelgard",
    "116002": "Dimitri",
    "116003": "Claude",
    "116004": "Hubert",
    "116005": "Ferdinand",
    "116006": "Linhardt",
    "116007": "Caspar",
    "116008": "Bernadetta",
    "116009": "Dorothea",
    "116010": "Petra",
    "116011": "Dedue",
    "116012": "Felix",
    "116013": "Ashe",
    "116014": "Sylvain",
    "116015": "Mercedes",
    "116016": "Annette",
    "116017": "Ingrid",
    "116018": "Lorenz",
    "116019": "Raphael",
    "116020": "Ignatz",
    "116021": "Lysithea",
    "116022": "Marianne",
    "116023": "Hilda",
    "116024": "Leonie",
    "116025": "Cyril",
    "116026": "Thales",
    "116027": "Cornelia",
    "116028": "Randolph",
    "116029": "Nader",
    "116030": "Nemesis",
    "116031": "Seiros",
    "116032": "Duca Aegir",
    "116033": "Lambert",
    "116034": "Gwendal",
    "116035": "Pallardó"
  },
  "ja-JP": {
    "101001": "マルス",
    "101002": "シーダ",
    "101003": "ジェイガン",
    "101004": "カイン",
    "101005": "アベル",
    "101006": "ドーガ",
    "101007": "ゴードン",
    "101008": "リフ",
    "101009": "オグマ",
    "101010": "バーツ",
    "101011": "サジ",
    "101012": "マジ",
    "101013": "カシム",
    "101014": "ダロス",
    "101015": "ジュリアン",
    "101016": "レナ",
    "101017": "ナバール",
    "101018": "マリク",
    "101019": "マチス",
    "101020": "ハーディン",
    "101021": "ウルフ",
    "101022": "ザガロ",
    "101023": "ロシェ",
    "101024": "ビラク",
    "101025": "ウェンデル",
    "101026": "リカード",
    "101027": "バヌトゥ",
    "101028": "シーザ",
    "101029": "ラディ",
    "101030": "ロジャー",
    "101031": "ジョルジュ",
    "101032": "マリア",
    "101033": "ミネルバ",
    "101034": "リンダ",
    "101035": "ジェイク",
    "101036": "ミディア",
    "101037": "トムス",
    "101038": "ミシェラン",
    "101039": "トーマス",
    "101040": "ボア",
    "101041": "ベック",
    "101042": "アストリア",
    "101043": "パオラ",
    "101044": "カチュア",
    "101045": "アラン",
    "101046": "サムソン",
    "101047": "チェイニー",
    "101048": "エスト",
    "101049": "チキ",
    "101050": "ロレンス",
    "101051": "エリス",
    "101052": "ガトー",
    "101053": "フレイ",
    "101054": "ノルン",
    "101055": "アテナ",
    "101056": "ホルス",
    "101057": "エッツェル",
    "101058": "ユミル",
    "101059": "ナギ",
    "101060": "モロドフ",
    "101061": "ニーナ",
    "101062": "ガーネフ",
    "101063": "カミュ",
    "101064": "ミシェイル",
    "101065": "メディウス",
    "101066": "アンナ",
    "102001": "アルム",
    "102002": "ルカ",
    "102003": "グレイ",
    "102004": "ロビン",
    "102005": "クリフ",
    "102006": "シルク",
    "102007": "クレア",
    "102008": "クレーベ",
    "102009": "フォルス",
    "102010": "パイソン",
    "102011": "セリカ",
    "102012": "メイ",
    "102013": "ボーイ",
    "102014": "ジェニー",
    "102015": "セーバー",
    "102016": "バルボ",
    "102017": "カムイ",
    "102018": "レオ",
    "102019": "リュート",
    "102020": "マチルダ",
    "102021": "デューテ",
    "102022": "パオラ",
    "102023": "カチュア",
    "102024": "アトラス",
    "102025": "ジェシー",
    "102026": "ディーン",
    "102027": "ソニア",
    "102028": "エスト",
    "102029": "ノーマ",
    "102030": "ティータ",
    "102031": "ジーク",
    "102032": "マイセン",
    "102033": "ドゼー",
    "102034": "ギース",
    "102035": "ルドルフ",
    "102036": "エフィ",
    "102037": "クレーベ",
    "102038": "コンラート",
    "102039": "ベルクト",
    "102040": "リネア",
    "102041": "フェルナン",
    "102042": "ジュダ",
    "102043": "スレイダー",
    "102044": "マッセナ",
    "102045": "ローソン",
    "102046": "ジェローム",
    "102047": "タタラ",
    "102048": "ドルク",
    "102049": "ヌイババ",
    "102050": "ヘステ",
    "102051": "マーラ",
    "102052": "ダッハ",
    "102053": "ガッハ",
    "102054": "ブライ",
    "102055": "ミラ",
    "102056": "ドーマ",
    "102057": "盗賊頭",
    "102058": "ハルク",
    "102059": "イルマ",
    "103001": "マルス",
    "103002": "クリス男（マイユニット）",
    "103003": "クリス女（マイユニット）",
    "103004": "アベル",
    "103005": "アラン",
    "103006": "アストリア",
    "103007": "バヌトゥ",
    "103008": "バーツ",
    "103009": "ベック",
    "103010": "ビラク",
    "103011": "ボア",
    "103012": "チェイニー",
    "103013": "ダロス",
    "103014": "ドーガ",
    "103015": "エリス",
    "103016": "エスト",
    "103017": "ガトー",
    "103018": "ゴードン",
    "103020": "ジェイガン",
    "103021": "ジェイク",
    "103022": "ジョルジュ",
    "103023": "ジュリアン",
    "103024": "カイン",
    "103025": "カシム",
    "103026": "カチュア",
    "103027": "マジ",
    "103028": "マリア",
    "103029": "マリク",
    "103030": "マチス",
    "103031": "ミディア",
    "103032": "ミネルバ",
    "103033": "ミシェラン",
    "103034": "ナバール",
    "103035": "オグマ",
    "103036": "パオラ",
    "103037": "ラディ",
    "103038": "レナ",
    "103039": "リカード",
    "103040": "リフ",
    "103041": "リンダ",
    "103042": "ロジャー",
    "103043": "ロレンス",
    "103044": "ロシェ",
    "103045": "サジ",
    "103046": "サムソン",
    "103047": "シーザ",
    "103048": "シーダ",
    "103049": "トーマス",
    "103050": "チキ",
    "103051": "トムス",
    "103052": "ウェンデル",
    "103053": "ウルフ",
    "103054": "ザガロ",
    "103055": "フレイ",
    "103056": "ノルン",
    "103057": "アテナ",
    "103058": "ホルス",
    "103059": "エッツェル",
    "103060": "ユミル",
    "103061": "ナギ",
    "103062": "ニーナ",
    "103063": "カタリナ",
    "103064": "ロディ",
    "103065": "セシル",
    "103066": "ユミナ",
    "103067": "ユベロ",
    "103068": "ラング",
    "103069": "ハーディン",
    "103070": "ルーク",
    "103071": "マリーシア",
    "103072": "ライアン",
    "103073": "シリウス",
    "103074": "サムトー",
    "103075": "ウォレン",
    "103076": "シーマ",
    "103077": "フィーナ",
    "103078": "エルレーン",
    "103079": "フロスト",
    "103080": "マリス",
    "103081": "ダイス",
    "103082": "ライデン",
    "103083": "ベルフ",
    "103084": "ロベルト",
    "103085": "ガーネフ",
    "103086": "カミュ",
    "103087": "ミシェイル",
    "103088": "ローロー",
    "103089": "クライネ",
    "103090": "エレミヤ",
    "103091": "メディウス",
    "103092": "アンナ",
    "104001": "シグルド",
    "104002": "ノイッシュ",
    "104003": "アレク",
    "104004": "アーダン",
    "104005": "ミデェール",
    "104006": "エーディン",
    "104007": "ブリギッド",
    "104008": "アゼル",
    "104009": "クロード",
    "104010": "ティルテュ",
    "104011": "レックス",
    "104012": "キュアン",
    "104013": "エスリン",
    "104014": "フィン",
    "104015": "アイラ",
    "104016": "ジャムカ",
    "104017": "レヴィン",
    "104018": "フュリー",
    "104019": "ラケシス",
    "104020": "セリス",
    "104021": "オイフェ",
    "104022": "シャナン",
    "104023": "スカサハ",
    "104024": "ラクチェ",
    "104025": "ラナ",
    "104026": "デルムッド",
    "104027": "レスター",
    "104028": "リーフ",
    "104029": "フィン",
    "104030": "ナンナ",
    "104031": "ティニー",
    "104032": "パティ",
    "104033": "ファバル",
    "104034": "アーサー",
    "104035": "フィー",
    "104036": "セティ",
    "104037": "アルテナ",
    "104038": "ハンニバル",
    "104039": "コープル",
    "104040": "ユリア",
    "104041": "アレス",
    "104042": "リーン",
    "104043": "ロドルバン",
    "104044": "ラドネイ",
    "104045": "マナ",
    "104046": "トリスタン",
    "104047": "ディムナ",
    "104048": "ジャンヌ",
    "104049": "リンダ",
    "104050": "デイジー",
    "104051": "アサエロ",
    "104052": "アミッド",
    "104053": "フェミナ",
    "104054": "ホーク",
    "104055": "シャルロー",
    "104056": "レイリア",
    "104057": "エルトシャン",
    "104058": "キンボイス",
    "104059": "ガンドルフ",
    "104060": "サンディマ",
    "104062": "シャガール",
    "104063": "マーニャ",
    "104064": "バイロン",
    "104065": "アンドレイ",
    "104066": "ランゴバルト",
    "104067": "レプトール",
    "104068": "アイーダ",
    "104069": "アルヴィス",
    "104070": "ダナン",
    "104071": "クトゥーゾフ",
    "104072": "イシュトー",
    "104073": "ブルーム",
    "104074": "トラバント",
    "104075": "ブリアン",
    "104076": "スコピオ",
    "104077": "ヒルダ",
    "104078": "イシュタル",
    "104079": "アリオーン",
    "104080": "マンフロイ",
    "104081": "ユリウス",
    "104082": "デュー",
    "104083": "ディアドラ",
    "104084": "ホリン",
    "104085": "シルヴィア",
    "104086": "ベオウルフ",
    "104087": "ヨハン",
    "104088": "ヨハルヴァ",
    "105001": "リーフ",
    "105002": "フィン",
    "105003": "エーヴェル",
    "105004": "ハルヴァン",
    "105005": "オーシン",
    "105006": "ダグダ",
    "105007": "タニア",
    "105008": "マーティ",
    "105009": "ロナン",
    "105010": "リフィス",
    "105011": "サフィ",
    "105012": "ブライトン",
    "105013": "マチュア",
    "105014": "ラーラ",
    "105015": "フェルグス",
    "105016": "カリン",
    "105017": "ダルシン",
    "105018": "アスベル",
    "105019": "ナンナ",
    "105020": "ヒックス",
    "105021": "シヴァ",
    "105022": "カリオン",
    "105023": "セルフィナ",
    "105024": "ケイン",
    "105025": "アルバ",
    "105026": "ロベルト",
    "105027": "フレッド",
    "105028": "オルエン",
    "105029": "マリータ",
    "105030": "セイラム",
    "105031": "パーン",
    "105032": "ティナ",
    "105033": "トルード",
    "105034": "グレイド",
    "105035": "ディーン",
    "105036": "エダ",
    "105037": "ホメロス",
    "105038": "リノアン",
    "105039": "ラルフ",
    "105040": "イリオス",
    "105041": "スルーフ",
    "105042": "サラ",
    "105043": "ミランダ",
    "105044": "シャナム",
    "105045": "ミーシャ",
    "105046": "ゼーベイア",
    "105047": "アマルダ",
    "105048": "コノモール",
    "105049": "デルムッド",
    "105050": "サイアス",
    "105051": "セティ",
    "105052": "ガルザス",
    "105053": "ケンプフ",
    "105054": "ラインハルト",
    "105055": "レイドリック",
    "105056": "ベルド",
    "106001": "ロイ",
    "106002": "マーカス",
    "106003": "アレン",
    "106004": "ランス",
    "106005": "ウォルト",
    "106006": "ボールス",
    "106007": "マリナス",
    "106008": "エレン",
    "106009": "ディーク",
    "106010": "ロット",
    "106011": "シャニー",
    "106012": "チャド",
    "106013": "ルゥ",
    "106014": "クラリーネ",
    "106015": "ルトガー",
    "106016": "サウル",
    "106017": "ドロシー",
    "106018": "スー",
    "106019": "ゼロット",
    "106020": "トレック",
    "106021": "ノア",
    "106022": "アストール",
    "106023": "リリーナ",
    "106024": "バース",
    "106025": "オージェ",
    "106026": "ウェンディ",
    "106027": "フィル",
    "106028": "シン",
    "106029": "ギース",
    "106030": "ゴンザレス",
    "106031": "クレイン",
    "106032": "ティト",
    "106033": "ララム",
    "106034": "エルフィン",
    "106035": "エキドナ",
    "106036": "バアトル",
    "106037": "レイ",
    "106038": "キャス",
    "106039": "ミレディ",
    "106040": "パーシバル",
    "106041": "セシリア",
    "106042": "ソフィーヤ",
    "106043": "イグレーヌ",
    "106044": "ガレット",
    "106045": "ファ",
    "106046": "ヒュウ",
    "106047": "ツァイス",
    "106048": "ダグラス",
    "106049": "ニイメ",
    "106050": "ユーノ",
    "106051": "ダヤン",
    "106052": "ヨーデル",
    "106053": "カレル",
    "106054": "ナーシェン",
    "106055": "ゲイル",
    "106056": "ヘクトル",
    "106057": "ブルーニャ",
    "106058": "マードック",
    "106059": "エリウッド",
    "106060": "ゼフィール",
    "106061": "ギネヴィア",
    "106062": "ヤアン",
    "106063": "イドゥン",
    "106064": "ワード",
    "107001": "リン",
    "107002": "セイン",
    "107003": "ケント",
    "107004": "フロリーナ",
    "107005": "ウィル",
    "107006": "ドルカス",
    "107007": "セーラ",
    "107008": "エルク",
    "107009": "ラス",
    "107010": "マシュー",
    "107011": "ニルス",
    "107012": "ルセア",
    "107013": "ワレス",
    "107014": "エリウッド",
    "107015": "マーカス",
    "107016": "ロウエン",
    "107017": "レベッカ",
    "107018": "バアトル",
    "107019": "ヘクトル",
    "107020": "オズイン",
    "107021": "ギィ",
    "107022": "マリナス",
    "107023": "プリシラ",
    "107024": "レイヴァン",
    "107025": "カナス",
    "107026": "ダーツ",
    "107027": "フィオーラ",
    "107028": "ラガルト",
    "107029": "ニニアン",
    "107030": "イサドラ",
    "107031": "ヒース",
    "107032": "ホークアイ",
    "107033": "ガイツ",
    "107034": "パント",
    "107035": "ルイーズ",
    "107036": "カレル",
    "107037": "ハーケン",
    "107038": "ニノ",
    "107039": "ジャファル",
    "107040": "ヴァイダ",
    "107041": "レナート",
    "107042": "アトス",
    "107043": "ファリナ",
    "107044": "カアラ",
    "107045": "レイラ",
    "107046": "ギネヴィア",
    "107047": "ゼフィール",
    "107048": "ロイド",
    "107049": "ライナス",
    "107050": "ウルスラ",
    "107051": "エフィデル",
    "107052": "ソーニャ",
    "107053": "リムステラ",
    "107054": "ネルガル",
    "108001": "エイリーク",
    "108002": "ゼト",
    "108003": "ギリアム",
    "108004": "フランツ",
    "108005": "モルダ",
    "108006": "ヴァネッサ",
    "108007": "ロス",
    "108008": "ガルシア",
    "108009": "ネイミー",
    "108010": "コーマ",
    "108011": "アスレイ",
    "108012": "ルーテ",
    "108013": "ナターシャ",
    "108014": "ヨシュア",
    "108015": "エフラム",
    "108016": "フォルデ",
    "108017": "カイル",
    "108018": "オルソン",
    "108019": "ターナ",
    "108020": "アメリア",
    "108021": "ヒーニアス",
    "108022": "ジスト",
    "108023": "テティス",
    "108024": "マリカ",
    "108025": "ラーチェル",
    "108026": "ドズラ",
    "108027": "サレフ",
    "108028": "ユアン",
    "108029": "クーガー",
    "108030": "レナック",
    "108031": "デュッセル",
    "108032": "ノール",
    "108033": "ミルラ",
    "108034": "シレーネ",
    "108035": "ケセルダ",
    "108036": "アーヴ",
    "108037": "イシュメア",
    "108038": "セライナ",
    "108039": "グレン",
    "108040": "ヘイデン",
    "108041": "ヴァルター",
    "108042": "ファード",
    "108043": "リオン",
    "109001": "アイク",
    "109002": "ティアマト",
    "109003": "オスカー",
    "109004": "ボーレ",
    "109005": "キルロイ",
    "109006": "シノン",
    "109007": "ガトリー",
    "109008": "セネリオ",
    "109009": "ミスト",
    "109010": "ヨファ",
    "109011": "グレイル",
    "109012": "ワユ",
    "109013": "ケビン",
    "109014": "チャップ",
    "109015": "ネフェニー",
    "109016": "ルキノ",
    "109017": "ユリシーズ",
    "109018": "ジョフレ",
    "109019": "エリンシア",
    "109020": "レニング",
    "109021": "レテ",
    "109022": "モゥディ",
    "109023": "ムワリム",
    "109024": "ライ",
    "109025": "ジフカ",
    "109026": "カイネギス",
    "109027": "イナ",
    "109028": "ナーシル",
    "109029": "ゴート",
    "109030": "クルトナーガ",
    "109031": "デギンハンザー",
    "109032": "ウルキ",
    "109033": "ヤナフ",
    "109034": "ティバーン",
    "109035": "リュシオン",
    "109036": "リアーネ",
    "109037": "ネサラ",
    "109038": "ニアルチ",
    "109039": "マーシャ",
    "109040": "ステラ",
    "109041": "マカロフ",
    "109042": "トパック",
    "109043": "タニス",
    "109044": "ゼルギウス",
    "109045": "シグルーン",
    "109046": "セフェラン",
    "109047": "サナキ",
    "109048": "ジル",
    "109049": "タウロニオ",
    "109050": "ハール",
    "109051": "プラハ",
    "109052": "ベウフォレス",
    "109053": "漆黒の騎士",
    "109054": "アシュナード",
    "109055": "イレース",
    "109056": "フォルカ",
    "109057": "ツイハーク",
    "109058": "サザ",
    "109059": "ソーンバルケ",
    "109060": "ダラハウ",
    "109061": "カリル",
    "109062": "ラルゴ",
    "109063": "エルナ",
    "110001": "ノイス",
    "110002": "ローラ",
    "110003": "サザ",
    "110004": "エディ",
    "110005": "ミカヤ",
    "110006": "アイク",
    "110007": "イズカ",
    "110008": "イナ",
    "110009": "イレース",
    "110010": "ウハラダ",
    "110011": "ウルキ",
    "110012": "エリンシア",
    "110013": "オスカー",
    "110014": "オリヴァー",
    "110015": "オルグ",
    "110016": "カイネギス",
    "110017": "ガトリー",
    "110018": "カリル",
    "110019": "キサ",
    "110020": "キルロイ",
    "110021": "クルトナーガ",
    "110022": "ケビン",
    "110023": "ゴート",
    "110024": "サナキ",
    "110025": "シグルーン",
    "110026": "漆黒の騎士",
    "110027": "シノン",
    "110028": "ジフカ",
    "110029": "ジョフレ",
    "110030": "ジル",
    "110031": "スクリミル",
    "110032": "ステラ",
    "110033": "セネリオ",
    "110034": "セフェラン",
    "110035": "ゼルギウス",
    "110036": "ソーンバルケ",
    "110037": "タウロニオ",
    "110038": "タニス",
    "110039": "チャップ",
    "110040": "ツイハーク",
    "110041": "ティアマト",
    "110042": "ティバーン",
    "110043": "デギンハンザー",
    "110044": "トパック",
    "110045": "ナーシル",
    "110046": "ニアルチ",
    "110047": "ニケ",
    "110048": "ネサラ",
    "110049": "ネフェニー",
    "110050": "ハール",
    "110051": "ビーゼ",
    "110052": "フォルカ",
    "110053": "ブラッド",
    "110054": "フリーダ",
    "110055": "ヘザー",
    "110056": "ヘッツェル",
    "110057": "ペレアス",
    "110058": "ボーレ",
    "110059": "マーシャ",
    "110060": "マカロフ",
    "110061": "ミスト",
    "110062": "ムワリム",
    "110063": "メグ",
    "110064": "モゥディ",
    "110065": "ヤナフ",
    "110066": "ユリシーズ",
    "110067": "ヨファ",
    "110068": "ライ",
    "110069": "ラフィエル",
    "110070": "リアーネ",
    "110071": "リィレ",
    "110072": "リュシオン",
    "110073": "ルキノ",
    "110074": "レオナルド",
    "110075": "レテ",
    "110076": "レニング",
    "110077": "ワユ",
    "110078": "アンナ",
    "110079": "ムストン",
    "110080": "ララベル",
    "110081": "ジョージ",
    "110082": "ダニエル",
    "110083": "ジェルド",
    "110084": "バルテロメ",
    "110085": "アスタテューヌ",
    "110086": "アスタルテ",
    "110087": "ユンヌ",
    "110089": "ラルゴ",
    "110090": "エイミ",
    "110091": "アムリタ",
    "111001": "ルフレ男（マイユニット）",
    "111002": "ルフレ女（マイユニット）",
    "111003": "クロム",
    "111004": "フレデリク",
    "111005": "カラム",
    "111006": "リヒト",
    "111007": "ヴェイク",
    "111008": "ロンクー",
    "111009": "ヴィオール",
    "111010": "バジーリオ",
    "111011": "スミア",
    "111012": "リズ",
    "111013": "セルジュ",
    "111014": "ミリエル",
    "111015": "仮面マルス",
    "111016": "ルキナ",
    "111017": "ヴァルハルト",
    "111018": "エメリナ",
    "111019": "ファウダー",
    "111020": "ソワレ",
    "111021": "ソール",
    "111022": "マリアベル",
    "111023": "ベルベット",
    "111024": "ガイア",
    "111025": "ティアモ",
    "111026": "グレゴ",
    "111027": "ノノ",
    "111028": "リベラ",
    "111029": "サーリャ",
    "111030": "オリヴィエ",
    "111031": "ヘンリー",
    "111032": "サイリ",
    "111033": "フラヴィア",
    "111034": "ドニ",
    "111035": "ウード",
    "111036": "アズール",
    "111037": "ブレディ",
    "111038": "デジェル",
    "111039": "シンシア",
    "111040": "セレナ",
    "111041": "ジェローム",
    "111042": "マーク男",
    "111043": "マーク女",
    "111044": "シャンブレー",
    "111045": "ロラン",
    "111046": "ノワール",
    "111047": "ンン",
    "111048": "チキ",
    "111049": "アンナ",
    "111050": "インバース",
    "111051": "パリス",
    "111052": "ギャンレル",
    "111053": "レンハ",
    "111054": "ムスタファー",
    "111055": "セルバンテス",
    "111056": "エクセライ",
    "111057": "ナーガ",
    "111058": "ギムレー",
    "112001": "カムイ男（マイユニット）",
    "112002": "カムイ女（マイユニット）",
    "112003": "ジョーカー",
    "112004": "サイラス",
    "112005": "スズカゼ",
    "112006": "リョウマ",
    "112007": "タクミ",
    "112008": "サイゾウ",
    "112009": "ニシキ",
    "112010": "ヒナタ",
    "112011": "アサマ",
    "112012": "ツバキ",
    "112013": "ツクヨミ",
    "112014": "マークス",
    "112015": "レオン",
    "112016": "ブノワ",
    "112017": "フランネル",
    "112018": "ハロルド",
    "112019": "オーディン",
    "112020": "ラズワルド",
    "112021": "ゼロ",
    "112022": "フェリシア",
    "112023": "アクア",
    "112024": "モズメ",
    "112025": "ヒノカ",
    "112026": "サクラ",
    "112027": "オロチ",
    "112028": "カゲロウ",
    "112029": "カザハナ",
    "112030": "セツナ",
    "112031": "ユウギリ",
    "112032": "オボロ",
    "112033": "カミラ",
    "112034": "エリーゼ",
    "112035": "シャーロッテ",
    "112036": "エルフィ",
    "112037": "ピエリ",
    "112038": "ベルカ",
    "112039": "ルーナ",
    "112040": "ニュクス",
    "112041": "カンナ女",
    "112042": "カンナ男",
    "112043": "シグレ",
    "112044": "ディーア",
    "112045": "ゾフィー",
    "112046": "ミドリコ",
    "112047": "シノノメ",
    "112048": "キサラギ",
    "112049": "グレイ",
    "112050": "キヌ",
    "112051": "ヒサメ",
    "112052": "ミタマ",
    "112053": "マトイ",
    "112054": "シャラ",
    "112055": "ジークベルト",
    "112056": "イグニス",
    "112057": "フォレオ",
    "112058": "ベロア",
    "112059": "ルッツ",
    "112060": "オフェリア",
    "112061": "ソレイユ",
    "112062": "エポニーヌ",
    "112063": "アシュラ",
    "112064": "フウガ",
    "112065": "ユキムラ",
    "112066": "イザナ",
    "112067": "ギュンター",
    "112068": "ナハト",
    "112069": "リンカ",
    "112070": "アンナ",
    "112071": "クリムゾン",
    "112072": "ドラジェ",
    "112073": "フローラ",
    "112074": "リリス",
    "112075": "シェンメイ",
    "112076": "ガロン",
    "112077": "スメラギ",
    "112078": "ミコト",
    "112079": "マクベス",
    "112080": "ゾーラ",
    "112081": "ガンズ",
    "112082": "ララ",
    "112083": "虹の賢者",
    "112084": "ハイドラ",
    "113001": "アルフォンス",
    "113002": "シャロン",
    "113003": "アンナ",
    "113004": "ヴェロニカ",
    "113005": "ブルーノ",
    "113006": "フィヨルム",
    "113007": "スリーズ",
    "113008": "スルト",
    "113009": "レーヴァテイン",
    "113010": "ロキ",
    "113011": "ヘルビンディ",
    "113012": "レーギャルン",
    "113013": "ユルグ",
    "113014": "フリーズ",
    "113015": "エイル",
    "113016": "リーヴ",
    "113017": "スラシル",
    "113018": "ヘル",
    "113019": "スカビオサ",
    "113020": "ピアニー",
    "113021": "プルメリア",
    "113022": "フロージ",
    "114001": "蒼井 樹 ＆ クロム",
    "114002": "織部 つばさ & シーダ",
    "114003": "赤城 斗馬 & カイン",
    "114004": "黒乃 霧亜 & サーリャ",
    "114005": "剣 弥代 & ナバール",
    "114006": "弓弦 エレオノーラ & ヴィオール",
    "114007": "源まもり & ドーガ",
    "114008": "志摩崎 舞子",
    "114009": "チキ",
    "114010": "バリィ･グッドマン",
    "114011": "織部 彩羽 & インバース",
    "114012": "剣 親臣 & ロンクー",
    "114013": "五十院 輝 & ゲリバ",
    "114014": "彫ノ澤 允 & ギャンレル",
    "114015": "鱈知乃 九炎 & エクセライ",
    "114016": "旗中 ヤツフサ & ガーネフ",
    "114017": "沢藤 頂天 & フェルス",
    "114018": "鈴本 りく & アベル",
    "115001": "ベレト",
    "115002": "ベレト（変化後）",
    "115003": "ベレス",
    "115004": "ベレス（変化後）",
    "115005": "エーデルガルト",
    "115006": "ディミトリ",
    "115007": "クロード",
    "115008": "ヒューベルト",
    "115009": "フェルディナント",
    "115010": "リンハルト",
    "115011": "カスパル",
    "115012": "ベルナデッタ",
    "115013": "ドロテア",
    "115014": "ペトラ",
    "115015": "ドゥドゥー",
    "115016": "フェリクス",
    "115017": "アッシュ",
    "115018": "シルヴァン",
    "115019": "メルセデス",
    "115020": "アネット",
    "115021": "イングリット",
    "115022": "ローレンツ",
    "115023": "ラファエル",
    "115024": "イグナーツ",
    "115025": "リシテア",
    "115026": "マリアンヌ",
    "115027": "ヒルダ",
    "115028": "レオニー",
    "115029": "セテス",
    "115030": "フレン",
    "115031": "ハンネマン",
    "115032": "マヌエラ",
    "115033": "ギルベルト",
    "115034": "アロイス",
    "115035": "カトリーヌ",
    "115036": "シャミア",
    "115037": "ツィリル",
    "115038": "ジェラルト",
    "115039": "レア",
    "115040": "ソティス",
    "115041": "クロニエ",
    "115042": "ソロン",
    "115043": "死神騎士",
    "115044": "コスタス",
    "115045": "ロナート",
    "115046": "マイクラン",
    "115047": "炎帝",
    "115048": "アンナ",
    "115049": "イエリッツァ",
    "115050": "ロドリグ",
    "115051": "ジュディット",
    "115052": "モニカ",
    "115053": "アランデル公",
    "115054": "トマシュ",
    "115055": "イオニアス9世",
    "115056": "メトジェイ",
    "115057": "ラディスラヴァ",
    "115058": "アケロン",
    "116001": "エーデルガルト",
    "116002": "ディミトリ",
    "116003": "クロード",
    "116004": "ヒューベルト",
    "116005": "フェルディナント",
    "116006": "リンハルト",
    "116007": "カスパル",
    "116008": "ベルナデッタ",
    "116009": "ドロテア",
    "116010": "ペトラ",
    "116011": "ドゥドゥー",
    "116012": "フェリクス",
    "116013": "アッシュ",
    "116014": "シルヴァン",
    "116015": "メルセデス",
    "116016": "アネット",
    "116017": "イングリット",
    "116018": "ローレンツ",
    "116019": "ラファエル",
    "116020": "イグナーツ",
    "116021": "リシテア",
    "116022": "マリアンヌ",
    "116023": "ヒルダ",
    "116024": "レオニー",
    "116025": "ツィリル",
    "116026": "タレス",
    "116027": "コルネリア",
    "116028": "ランドルフ",
    "116029": "ナデル",
    "116030": "ネメシス",
    "116031": "セイロス",
    "116032": "エーギル公",
    "116033": "ランベール",
    "116034": "グェンダル",
    "116035": "バジャルド"
  },
  "zh-TW": {
    "101001": "馬爾斯",
    "101002": "希達",
    "101003": "傑剛",
    "101004": "凱因",
    "101005": "阿貝爾",
    "101006": "多加",
    "101007": "哥頓",
    "101008": "利夫",
    "101009": "奧古馬",
    "101010": "巴茲",
    "101011": "薩吉",
    "101012": "瑪吉",
    "101013": "卡西姆",
    "101014": "達羅斯",
    "101015": "朱利安",
    "101016": "蕾娜",
    "101017": "拿巴爾",
    "101018": "馬利克",
    "101019": "瑪吉斯",
    "101020": "哈汀",
    "101021": "烏爾夫",
    "101022": "札卡羅",
    "101023": "羅榭",
    "101024": "比拉克",
    "101025": "溫迪魯",
    "101026": "理卡德",
    "101027": "巴努托",
    "101028": "凱薩",
    "101029": "拉帝",
    "101030": "羅傑",
    "101031": "喬爾裘",
    "101032": "瑪莉亞",
    "101033": "米奈娃",
    "101034": "琳達",
    "101035": "傑克",
    "101036": "米迪婭",
    "101037": "湯姆斯",
    "101038": "米歇蘭",
    "101039": "湯瑪斯",
    "101040": "鮑爾",
    "101041": "貝克",
    "101042": "阿斯托利亞",
    "101043": "帕奧拉",
    "101044": "卡秋雅",
    "101045": "亞蘭",
    "101046": "薩姆森",
    "101047": "切尼",
    "101048": "愛絲特",
    "101049": "琪姬",
    "101050": "羅連斯",
    "101051": "艾莉絲",
    "101052": "迦圖",
    "101053": "弗雷",
    "101054": "諾倫",
    "101055": "雅典娜",
    "101056": "豪路斯",
    "101057": "埃札爾",
    "101058": "尤彌爾",
    "101059": "娜琪",
    "101060": "莫羅多夫",
    "101061": "妮娜",
    "101062": "加內夫",
    "101063": "卡謬",
    "101064": "米謝爾",
    "101065": "梅迪烏斯",
    "101066": "安娜",
    "102001": "阿雷武",
    "102002": "盧卡",
    "102003": "格萊",
    "102004": "羅賓",
    "102005": "克里夫",
    "102006": "希爾科",
    "102007": "克萊爾",
    "102008": "克雷貝",
    "102009": "弗魯斯",
    "102010": "帕伊宋",
    "102011": "賽莉卡",
    "102012": "梅伊",
    "102013": "波伊",
    "102014": "傑妮",
    "102015": "賽巴",
    "102016": "巴爾博",
    "102017": "卡武伊",
    "102018": "雷歐",
    "102019": "魯特",
    "102020": "瑪蒂爾達",
    "102021": "迪優特",
    "102022": "帕奧拉",
    "102023": "卡秋雅",
    "102024": "阿特拉斯",
    "102025": "傑西",
    "102026": "迪恩",
    "102027": "索尼婭",
    "102028": "愛絲特",
    "102029": "諾瑪",
    "102030": "蒂塔",
    "102031": "吉克",
    "102032": "瑪伊森",
    "102033": "多哲",
    "102034": "吉斯",
    "102035": "魯道夫",
    "102036": "艾菲",
    "102037": "克雷貝",
    "102038": "孔拉特",
    "102039": "貝爾克特",
    "102040": "莉奈雅",
    "102041": "費爾南",
    "102042": "朱達",
    "102043": "斯萊達",
    "102044": "馬塞納",
    "102045": "羅森",
    "102046": "傑羅武",
    "102047": "塔塔拉",
    "102048": "多爾科",
    "102049": "魯伊巴巴",
    "102050": "海斯特",
    "102051": "瑪拉",
    "102052": "達哈",
    "102053": "加哈",
    "102054": "布萊",
    "102055": "美拉",
    "102056": "多瑪",
    "102057": "盜賊頭目",
    "102058": "哈魯克",
    "102059": "伊爾瑪",
    "103001": "馬爾斯",
    "103002": "克里斯（男）",
    "103003": "克里斯（女）",
    "103004": "阿貝爾",
    "103005": "亞蘭",
    "103006": "阿斯托利亞",
    "103007": "巴努托",
    "103008": "巴茲",
    "103009": "貝克",
    "103010": "比拉克",
    "103011": "鮑爾",
    "103012": "切尼",
    "103013": "達羅斯",
    "103014": "多加",
    "103015": "艾莉絲",
    "103016": "愛絲特",
    "103017": "迦圖",
    "103018": "哥頓",
    "103020": "傑剛",
    "103021": "傑克",
    "103022": "喬爾裘",
    "103023": "朱利安",
    "103024": "凱因",
    "103025": "卡西姆",
    "103026": "卡秋雅",
    "103027": "瑪吉",
    "103028": "瑪莉亞",
    "103029": "馬利克",
    "103030": "瑪吉斯",
    "103031": "米迪婭",
    "103032": "米奈娃",
    "103033": "米歇蘭",
    "103034": "拿巴爾",
    "103035": "奧古馬",
    "103036": "帕奧拉",
    "103037": "拉帝",
    "103038": "蕾娜",
    "103039": "理卡德",
    "103040": "利夫",
    "103041": "琳達",
    "103042": "羅傑",
    "103043": "羅連斯",
    "103044": "羅榭",
    "103045": "薩吉",
    "103046": "薩姆森",
    "103047": "凱薩",
    "103048": "希達",
    "103049": "湯瑪斯",
    "103050": "琪姬",
    "103051": "湯姆斯",
    "103052": "溫迪魯",
    "103053": "烏爾夫",
    "103054": "札卡羅",
    "103055": "弗雷",
    "103056": "諾倫",
    "103057": "雅典娜",
    "103058": "豪路斯",
    "103059": "埃札爾",
    "103060": "尤彌爾",
    "103061": "娜琪",
    "103062": "妮娜",
    "103063": "卡達麗娜",
    "103064": "羅迪",
    "103065": "瑟希兒",
    "103066": "尤蜜娜",
    "103067": "尤貝羅",
    "103068": "朗格",
    "103069": "哈汀",
    "103070": "路克",
    "103071": "瑪莉希雅",
    "103072": "萊安",
    "103073": "希利烏斯",
    "103074": "薩姆托",
    "103075": "沃倫",
    "103076": "希瑪",
    "103077": "菲娜",
    "103078": "艾爾連恩",
    "103079": "弗羅斯特",
    "103080": "瑪麗絲",
    "103081": "戴斯",
    "103082": "萊甸",
    "103083": "貝爾夫",
    "103084": "羅貝爾特",
    "103085": "加內夫",
    "103086": "卡謬",
    "103087": "米謝爾",
    "103088": "羅羅",
    "103089": "克萊涅",
    "103090": "艾蕾米雅",
    "103091": "梅迪烏斯",
    "103092": "安娜",
    "104001": "西格爾特",
    "104002": "諾修",
    "104003": "亞雷克",
    "104004": "亞丹",
    "104005": "米迪爾",
    "104006": "愛汀",
    "104007": "布麗姬德",
    "104008": "艾澤爾",
    "104009": "克勞德",
    "104010": "提爾透",
    "104011": "雷克斯",
    "104012": "喬安",
    "104013": "艾絲琳",
    "104014": "芬恩",
    "104015": "艾伊拉",
    "104016": "嘉姆卡",
    "104017": "雷文",
    "104018": "菲莉",
    "104019": "拉克西絲",
    "104020": "賽列斯",
    "104021": "奧伊菲",
    "104022": "夏南",
    "104023": "斯卡薩哈",
    "104024": "拉克榭",
    "104025": "菈娜",
    "104026": "迪爾姆多",
    "104027": "萊斯特",
    "104028": "里弗",
    "104029": "芬恩",
    "104030": "南娜",
    "104031": "媞妮",
    "104032": "帕蒂",
    "104033": "法巴魯",
    "104034": "亞瑟",
    "104035": "霏",
    "104036": "賽提",
    "104037": "阿爾緹娜",
    "104038": "漢尼拔",
    "104039": "克普爾",
    "104040": "尤莉亞",
    "104041": "阿瑞斯",
    "104042": "琳恩",
    "104043": "羅德魯邦",
    "104044": "拉德妮",
    "104045": "瑪娜",
    "104046": "特里斯坦",
    "104047": "迪姆納",
    "104048": "貞德",
    "104049": "莉妲",
    "104050": "黛姬",
    "104051": "阿撒耶羅",
    "104052": "亞米德",
    "104053": "費米娜",
    "104054": "霍克",
    "104055": "夏爾羅",
    "104056": "蕾莉婭",
    "104057": "艾爾多尚",
    "104058": "金鮑斯",
    "104059": "剛德魯夫",
    "104060": "桑帝瑪",
    "104062": "夏卡爾",
    "104063": "瑪妮婭",
    "104064": "拜隆",
    "104065": "安德雷伊",
    "104066": "隆巴爾特",
    "104067": "萊布托爾",
    "104068": "阿依達",
    "104069": "阿爾維斯",
    "104070": "達南",
    "104071": "庫托索夫",
    "104072": "伊修特",
    "104073": "布魯姆",
    "104074": "托拉邦特",
    "104075": "布萊恩",
    "104076": "史克皮歐",
    "104077": "希爾妲",
    "104078": "伊修達爾",
    "104079": "阿利翁",
    "104080": "曼福洛伊",
    "104081": "尤利烏斯",
    "104082": "迪優",
    "104083": "迪雅朵拉",
    "104084": "霍林",
    "104085": "希薇雅",
    "104086": "貝奧武夫",
    "104087": "約翰",
    "104088": "約翰爾瓦",
    "105001": "里弗",
    "105002": "芬恩",
    "105003": "愛薇爾",
    "105004": "哈爾旺",
    "105005": "奧辛",
    "105006": "達古達",
    "105007": "塔妮婭",
    "105008": "馬提",
    "105009": "羅南",
    "105010": "利菲斯",
    "105011": "莎菲",
    "105012": "布萊登",
    "105013": "麥秋雅",
    "105014": "拉菈",
    "105015": "菲爾古斯",
    "105016": "花凜",
    "105017": "達魯辛",
    "105018": "亞斯貝爾",
    "105019": "南娜",
    "105020": "希克斯",
    "105021": "席巴",
    "105022": "嘉里昂",
    "105023": "塞爾菲娜",
    "105024": "凱恩",
    "105025": "阿魯巴",
    "105026": "羅伯特",
    "105027": "弗萊德",
    "105028": "歐爾玟",
    "105029": "瑪麗塔",
    "105030": "塞拉姆",
    "105031": "帕恩",
    "105032": "蒂娜",
    "105033": "托爾多",
    "105034": "葛瑞德",
    "105035": "汀恩",
    "105036": "艾妲",
    "105037": "霍梅羅斯",
    "105038": "莉諾安",
    "105039": "勞夫",
    "105040": "伊里歐斯",
    "105041": "斯爾夫",
    "105042": "莎拉",
    "105043": "米蘭達",
    "105044": "夏那姆",
    "105045": "米夏",
    "105046": "賽比亞",
    "105047": "亞曼爾妲",
    "105048": "克諾摩爾",
    "105049": "迪爾姆多",
    "105050": "賽亞斯",
    "105051": "賽提",
    "105052": "嘉爾札斯",
    "105053": "肯普夫",
    "105054": "萊茵哈特",
    "105055": "雷德利克",
    "105056": "貝魯多",
    "106001": "羅伊",
    "106002": "馬卡斯",
    "106003": "亞連",
    "106004": "蘭斯",
    "106005": "伍爾特",
    "106006": "波爾斯",
    "106007": "馬利納斯",
    "106008": "愛蓮",
    "106009": "迪克",
    "106010": "羅德",
    "106011": "夏妮",
    "106012": "查德",
    "106013": "魯格",
    "106014": "克拉莉涅",
    "106015": "路特加",
    "106016": "薩沃爾",
    "106017": "桃樂絲",
    "106018": "蘇",
    "106019": "塞洛特",
    "106020": "托雷克",
    "106021": "諾亞",
    "106022": "阿斯特爾",
    "106023": "莉莉娜",
    "106024": "巴斯",
    "106025": "奧杰",
    "106026": "溫蒂",
    "106027": "菲爾",
    "106028": "辛",
    "106029": "奇斯",
    "106030": "岡薩雷斯",
    "106031": "克萊因",
    "106032": "蒂特",
    "106033": "拉菈姆",
    "106034": "艾爾芬",
    "106035": "艾基德娜",
    "106036": "巴多爾",
    "106037": "雷伊",
    "106038": "凱絲",
    "106039": "密蕾蒂",
    "106040": "帕西巴爾",
    "106041": "瑟西莉亞",
    "106042": "蘇菲亞",
    "106043": "伊葛雷努",
    "106044": "加雷特",
    "106045": "法",
    "106046": "脩",
    "106047": "宰斯",
    "106048": "道格拉斯",
    "106049": "尼伊玫",
    "106050": "優諾",
    "106051": "大陽",
    "106052": "約德爾",
    "106053": "卡列爾",
    "106054": "拿榭恩",
    "106055": "蓋爾",
    "106056": "海克托爾",
    "106057": "碧爾妮婭",
    "106058": "墨德克",
    "106059": "艾利烏德",
    "106060": "賽菲爾",
    "106061": "姬妮薇雅",
    "106062": "亞安",
    "106063": "伊敦",
    "106064": "瓦德",
    "107001": "琳",
    "107002": "塞因",
    "107003": "肯特",
    "107004": "芙羅利娜",
    "107005": "威爾",
    "107006": "多爾卡斯",
    "107007": "賽拉",
    "107008": "艾爾克",
    "107009": "勒斯",
    "107010": "馬修",
    "107011": "尼爾斯",
    "107012": "魯塞亞",
    "107013": "瓦雷斯",
    "107014": "艾利烏德",
    "107015": "馬卡斯",
    "107016": "羅維恩",
    "107017": "蕾貝卡",
    "107018": "巴多爾",
    "107019": "海克托爾",
    "107020": "奧森",
    "107021": "基",
    "107022": "馬利納斯",
    "107023": "普莉西亞",
    "107024": "瑞文",
    "107025": "卡納斯",
    "107026": "達茲",
    "107027": "菲奧拉",
    "107028": "拉加爾托",
    "107029": "尼尼安",
    "107030": "伊莎多拉",
    "107031": "希斯",
    "107032": "霍克艾",
    "107033": "蓋茲",
    "107034": "龐托",
    "107035": "露依絲",
    "107036": "卡列爾",
    "107037": "哈肯",
    "107038": "妮諾",
    "107039": "賈法爾",
    "107040": "瓦伊妲",
    "107041": "雷納托",
    "107042": "亞托思",
    "107043": "法麗娜",
    "107044": "卡菈",
    "107045": "蕾拉",
    "107046": "姬妮薇雅",
    "107047": "賽菲爾",
    "107048": "洛伊德",
    "107049": "萊納斯",
    "107050": "烏爾斯拉",
    "107051": "艾菲迪魯",
    "107052": "索妮婭",
    "107053": "莉姆思黛拉",
    "107054": "涅爾加魯",
    "108001": "艾莉可",
    "108002": "賽特",
    "108003": "吉利安姆",
    "108004": "弗朗茨",
    "108005": "摩爾達",
    "108006": "凡妮莎",
    "108007": "羅斯",
    "108008": "賈西亞",
    "108009": "奈彌",
    "108010": "寇馬",
    "108011": "阿斯雷",
    "108012": "盧特",
    "108013": "娜塔夏",
    "108014": "約書亞",
    "108015": "艾夫拉姆",
    "108016": "佛魯迪",
    "108017": "凱爾",
    "108018": "歐爾森",
    "108019": "塔娜",
    "108020": "亞美利雅",
    "108021": "西尼亞斯",
    "108022": "吉斯特",
    "108023": "特媞絲",
    "108024": "瑪莉卡",
    "108025": "拉切爾",
    "108026": "多茲拉",
    "108027": "塞勒夫",
    "108028": "尤安",
    "108029": "庫格",
    "108030": "雷納克",
    "108031": "杜賽爾",
    "108032": "諾爾",
    "108033": "梅爾",
    "108034": "席琳妮",
    "108035": "凱瑟爾達",
    "108036": "亞維",
    "108037": "依修梅亞",
    "108038": "瑟萊娜",
    "108039": "格倫",
    "108040": "哈登",
    "108041": "瓦爾達",
    "108042": "琺竇",
    "108043": "利昂",
    "109001": "艾克",
    "109002": "狄亞馬特",
    "109003": "奧斯卡",
    "109004": "博雷",
    "109005": "基爾羅伊",
    "109006": "席諾",
    "109007": "嘉德列",
    "109008": "塞涅里歐",
    "109009": "密絲特",
    "109010": "優法",
    "109011": "格萊爾",
    "109012": "瓦育",
    "109013": "凱賓",
    "109014": "恰普",
    "109015": "涅菲妮",
    "109016": "露琪諾",
    "109017": "尤里西斯",
    "109018": "喬弗雷",
    "109019": "艾琳西亞",
    "109020": "勒寧格",
    "109021": "蕾媞",
    "109022": "摩迪",
    "109023": "穆瓦瑞姆",
    "109024": "萊伊",
    "109025": "基夫卡",
    "109026": "凱內基斯",
    "109027": "伊娜",
    "109028": "那西爾",
    "109029": "哥德",
    "109030": "克魯托納嘉",
    "109031": "德金漢薩",
    "109032": "沃爾基",
    "109033": "牙納夫",
    "109034": "狄邦",
    "109035": "琉希昂",
    "109036": "莉婭妮",
    "109037": "涅沙羅",
    "109038": "尼亞魯契",
    "109039": "瑪夏",
    "109040": "史黛拉",
    "109041": "馬卡洛夫",
    "109042": "多邦克",
    "109043": "塔妮絲",
    "109044": "塞爾吉烏斯",
    "109045": "希葛倫",
    "109046": "瑟菲蘭",
    "109047": "莎娜琪",
    "109048": "吉爾",
    "109049": "塔羅尼歐",
    "109050": "哈魯",
    "109051": "普拉哈",
    "109052": "貝佛雷斯",
    "109053": "漆黑騎士",
    "109054": "亞修納德",
    "109055": "伊蕾思",
    "109056": "弗爾加",
    "109057": "吉哈克",
    "109058": "薩札",
    "109059": "索恩巴魯克",
    "109060": "達拉豪",
    "109061": "卡莉璐",
    "109062": "拉爾戈",
    "109063": "艾璐娜",
    "110001": "諾伊斯",
    "110002": "蘿拉",
    "110003": "薩札",
    "110004": "艾迪",
    "110005": "米卡雅",
    "110006": "艾克",
    "110007": "伊茲卡",
    "110008": "伊娜",
    "110009": "伊蕾思",
    "110010": "吾哈拉達",
    "110011": "沃爾基",
    "110012": "艾琳西亞",
    "110013": "奧斯卡",
    "110014": "奧利瓦",
    "110015": "奧魯古",
    "110016": "凱內基斯",
    "110017": "嘉德列",
    "110018": "卡莉璐",
    "110019": "奇薩",
    "110020": "基爾羅伊",
    "110021": "克魯托納嘉",
    "110022": "凱賓",
    "110023": "哥德",
    "110024": "莎娜琪",
    "110025": "希葛倫",
    "110026": "漆黑騎士",
    "110027": "席諾",
    "110028": "基夫卡",
    "110029": "喬弗雷",
    "110030": "吉爾",
    "110031": "斯克瑞米爾",
    "110032": "史黛拉",
    "110033": "塞涅里歐",
    "110034": "瑟菲蘭",
    "110035": "塞爾吉烏斯",
    "110036": "索恩巴魯克",
    "110037": "塔羅尼歐",
    "110038": "塔妮絲",
    "110039": "恰普",
    "110040": "吉哈克",
    "110041": "狄亞馬特",
    "110042": "狄邦",
    "110043": "德金漢薩",
    "110044": "多邦克",
    "110045": "那西爾",
    "110046": "尼亞魯契",
    "110047": "妮凱",
    "110048": "涅沙羅",
    "110049": "涅菲妮",
    "110050": "哈魯",
    "110051": "碧潔",
    "110052": "弗爾加",
    "110053": "布拉德",
    "110054": "菲莉妲",
    "110055": "海瑟",
    "110056": "赫杰爾",
    "110057": "佩雷亞斯",
    "110058": "博雷",
    "110059": "瑪夏",
    "110060": "馬卡洛夫",
    "110061": "密絲特",
    "110062": "穆瓦瑞姆",
    "110063": "梅格",
    "110064": "摩迪",
    "110065": "牙納夫",
    "110066": "尤里西斯",
    "110067": "優法",
    "110068": "萊伊",
    "110069": "拉斐爾",
    "110070": "莉婭妮",
    "110071": "麗蕾",
    "110072": "琉希昂",
    "110073": "露琪諾",
    "110074": "雷奧納多",
    "110075": "蕾媞",
    "110076": "勒寧格",
    "110077": "瓦育",
    "110078": "安娜",
    "110079": "穆斯頓",
    "110080": "拉拉蓓爾",
    "110081": "喬治",
    "110082": "丹尼爾",
    "110083": "傑爾德",
    "110084": "巴特羅梅",
    "110085": "亞斯塔蒂娜",
    "110086": "亞絲塔爾蒂",
    "110087": "芸娜",
    "110089": "拉爾戈",
    "110090": "艾美",
    "110091": "阿爾米達",
    "111001": "魯弗萊（男）",
    "111002": "魯弗萊（女）",
    "111003": "庫洛武",
    "111004": "弗雷德里克",
    "111005": "卡拉姆",
    "111006": "里希特",
    "111007": "維克",
    "111008": "隆克",
    "111009": "維沃爾",
    "111010": "巴基里奧",
    "111011": "絲米亞",
    "111012": "莉茲",
    "111013": "塞爾裘",
    "111014": "米莉艾爾",
    "111015": "蒙面馬爾斯",
    "111016": "露琪娜",
    "111017": "瓦爾哈爾特",
    "111018": "艾美莉娜",
    "111019": "法烏達",
    "111020": "索瓦蕾",
    "111021": "索爾",
    "111022": "瑪利亞貝爾",
    "111023": "貝爾貝特",
    "111024": "蓋亞",
    "111025": "蒂亞莫",
    "111026": "固雷格",
    "111027": "儂儂",
    "111028": "利貝拉",
    "111029": "撒拉",
    "111030": "奧利薇",
    "111031": "亨利",
    "111032": "彩莉",
    "111033": "芙拉維亞",
    "111034": "多尼",
    "111035": "伍德",
    "111036": "阿茲爾",
    "111037": "布萊迪",
    "111038": "丹裘爾",
    "111039": "欣西亞",
    "111040": "瑟琳娜",
    "111041": "傑洛姆",
    "111042": "馬可（男）",
    "111043": "馬可（女）",
    "111044": "夏布雷",
    "111045": "羅藍",
    "111046": "諾瓦爾",
    "111047": "恩恩",
    "111048": "琪姬",
    "111049": "安娜",
    "111050": "茵巴絲",
    "111051": "巴利斯",
    "111052": "岡雷爾",
    "111053": "濂葉",
    "111054": "穆斯塔法",
    "111055": "塞凡提斯",
    "111056": "艾克賽萊",
    "111057": "那迦",
    "111058": "津利",
    "112001": "神威（男）",
    "112002": "神威（女）",
    "112003": "喬克",
    "112004": "賽萊斯",
    "112005": "涼風",
    "112006": "龍馬",
    "112007": "拓海",
    "112008": "彩造",
    "112009": "錦",
    "112010": "日向",
    "112011": "淺間",
    "112012": "椿",
    "112013": "月讀",
    "112014": "馬克斯",
    "112015": "里昂",
    "112016": "布諾瓦",
    "112017": "弗朗諾",
    "112018": "哈洛德",
    "112019": "奧丁",
    "112020": "拉茲沃德",
    "112021": "零",
    "112022": "菲利西亞",
    "112023": "阿庫婭",
    "112024": "物集",
    "112025": "火乃香",
    "112026": "櫻",
    "112027": "遠呂智",
    "112028": "陽炎",
    "112029": "風花",
    "112030": "剎那",
    "112031": "夕霧",
    "112032": "朧",
    "112033": "卡美拉",
    "112034": "艾麗澤",
    "112035": "夏洛特",
    "112036": "艾爾菲",
    "112037": "皮艾莉",
    "112038": "貝爾卡",
    "112039": "露娜",
    "112040": "妮克絲",
    "112041": "神流（女）",
    "112042": "神流（男）",
    "112043": "詩格萊",
    "112044": "迪亞",
    "112045": "蘇菲",
    "112046": "翠子",
    "112047": "東雲",
    "112048": "如月",
    "112049": "葛雷",
    "112050": "絹",
    "112051": "冰雨",
    "112052": "御靈",
    "112053": "纏",
    "112054": "夏拉",
    "112055": "齊格貝爾特",
    "112056": "伊格尼斯",
    "112057": "法雷歐",
    "112058": "蓓羅亞",
    "112059": "路茲",
    "112060": "歐菲莉亞",
    "112061": "索雷優",
    "112062": "艾波寧",
    "112063": "阿修羅",
    "112064": "楓賀",
    "112065": "幸村",
    "112066": "伊邪那",
    "112067": "君特",
    "112068": "拿赫特",
    "112069": "凜火",
    "112070": "安娜",
    "112071": "克莉森",
    "112072": "朵菈潔",
    "112073": "芙洛拉",
    "112074": "莉莉絲",
    "112075": "萱玫",
    "112076": "加隆",
    "112077": "皇",
    "112078": "水琴",
    "112079": "馬克白",
    "112080": "佐拉",
    "112081": "甘茲",
    "112082": "菈菈",
    "112083": "虹之賢者",
    "112084": "海卓拉",
    "113001": "阿爾馮斯",
    "113002": "夏蓉",
    "113003": "安娜",
    "113004": "維洛妮卡",
    "113005": "布魯諾",
    "113006": "菲約爾姆",
    "113007": "斯利茲",
    "113008": "斯爾特",
    "113009": "瑞瓦提恩",
    "113010": "洛基",
    "113011": "赫爾賓迪",
    "113012": "瑞瓦伽倫",
    "113013": "優爾格",
    "113014": "佛利茲",
    "113015": "埃爾",
    "113016": "利布",
    "113017": "史菈希爾",
    "113018": "赫爾",
    "113019": "史卡畢歐薩",
    "113020": "皮亞尼",
    "113021": "普路梅莉亞",
    "113022": "佛羅金",
    "114001": "蒼井 樹 ＆ 庫洛武",
    "114002": "織部 翼 & 希達",
    "114003": "赤城 斗馬 & 凱因",
    "114004": "黑乃 霧亞 & 撒拉",
    "114005": "劍 彌代 & 拿巴爾",
    "114006": "弓弦 艾莉歐諾拉 & 維沃爾",
    "114007": "源真守 & 多加",
    "114008": "志摩崎 舞子",
    "114009": "琪姬",
    "114010": "巴里‧古德曼",
    "114011": "織部 彩羽 & 茵巴絲",
    "114012": "劍 親臣 & 隆克",
    "114013": "五十院 輝 & 革厲霸",
    "114014": "彫澤 允 & 岡格羅",
    "114015": "鱈知乃 九炎 & 艾克賽萊",
    "114016": "旗中 八房 & 加內夫",
    "114017": "澤藤 頂天 & 菲爾斯",
    "114018": "鈴本 陸 & 阿貝爾",
    "115001": "貝雷特",
    "115002": "貝雷特（變化後）",
    "115003": "貝雷絲",
    "115004": "貝雷絲（變化後）",
    "115005": "艾黛爾賈特",
    "115006": "帝彌托利",
    "115007": "庫羅德",
    "115008": "修伯特",
    "115009": "菲爾迪南特",
    "115010": "林哈爾特",
    "115011": "卡斯帕爾",
    "115012": "貝爾娜提塔",
    "115013": "多洛緹雅",
    "115014": "佩托拉",
    "115015": "杜篤",
    "115016": "菲力克斯",
    "115017": "亞修",
    "115018": "希爾凡",
    "115019": "梅爾賽德司",
    "115020": "雅妮特",
    "115021": "英谷莉特",
    "115022": "洛廉茲",
    "115023": "拉斐爾",
    "115024": "伊古納茲",
    "115025": "莉絲緹亞",
    "115026": "瑪莉安奴",
    "115027": "希爾妲",
    "115028": "雷歐妮",
    "115029": "西提司",
    "115030": "芙蓮",
    "115031": "漢尼曼",
    "115032": "瑪努艾拉",
    "115033": "吉爾伯特",
    "115034": "阿羅伊斯",
    "115035": "卡多莉奴",
    "115036": "薩米亞",
    "115037": "錐里爾",
    "115038": "傑拉爾特",
    "115039": "蕾雅",
    "115040": "蘇諦斯",
    "115041": "科蘿妮艾",
    "115042": "索龍",
    "115043": "死神騎士",
    "115044": "寇斯塔斯",
    "115045": "羅納特",
    "115046": "邁克朗",
    "115047": "炎帝",
    "115048": "安娜",
    "115049": "伊艾里扎",
    "115050": "羅德利古",
    "115051": "朱迪特",
    "115052": "莫妮卡",
    "115053": "亞蘭德爾公",
    "115054": "托馬修",
    "115055": "伊歐尼亞斯9世",
    "115056": "梅特傑",
    "115057": "拉蒂絲拉瓦",
    "115058": "阿肯隆",
    "116001": "艾黛爾賈特",
    "116002": "帝彌托利",
    "116003": "庫羅德",
    "116004": "修伯特",
    "116005": "菲爾迪南特",
    "116006": "林哈爾特",
    "116007": "卡斯帕爾",
    "116008": "貝爾娜提塔",
    "116009": "多洛緹雅",
    "116010": "佩托拉",
    "116011": "杜篤",
    "116012": "菲力克斯",
    "116013": "亞修",
    "116014": "希爾凡",
    "116015": "梅爾賽德司",
    "116016": "雅妮特",
    "116017": "英谷莉特",
    "116018": "洛廉茲",
    "116019": "拉斐爾",
    "116020": "伊古納茲",
    "116021": "莉絲緹亞",
    "116022": "瑪莉安奴",
    "116023": "希爾妲",
    "116024": "雷歐妮",
    "116025": "錐里爾",
    "116026": "塔烈斯",
    "116027": "科爾娜莉亞",
    "116028": "蘭道夫",
    "116029": "納戴爾",
    "116030": "涅梅希斯",
    "116031": "賽羅司",
    "116032": "艾吉爾公爵",
    "116033": "藍貝爾",
    "116034": "關達爾",
    "116035": "巴迦爾德"
  },
  "en-US": {
    "101001": "Marth",
    "101002": "Caeda",
    "101003": "Jagen",
    "101004": "Cain",
    "101005": "Abel",
    "101006": "Draug",
    "101007": "Gordin",
    "101008": "Wrys",
    "101009": "Ogma",
    "101010": "Barst",
    "101011": "Bord",
    "101012": "Cord",
    "101013": "Castor",
    "101014": "Darros",
    "101015": "Julian",
    "101016": "Lena",
    "101017": "Navarre",
    "101018": "Merric",
    "101019": "Matthis",
    "101020": "Hardin",
    "101021": "Wolf",
    "101022": "Sedgar",
    "101023": "Roshea",
    "101024": "Vyland",
    "101025": "Wendell",
    "101026": "Rickard",
    "101027": "Bantu",
    "101028": "Caesar",
    "101029": "Radd",
    "101030": "Roger",
    "101031": "Jeorge",
    "101032": "Maria",
    "101033": "Minerva",
    "101034": "Linde",
    "101035": "Jake",
    "101036": "Midia",
    "101037": "Dolph",
    "101038": "Macellan",
    "101039": "Tomas",
    "101040": "Boah",
    "101041": "Beck",
    "101042": "Astram",
    "101043": "Palla",
    "101044": "Catria",
    "101045": "Arran",
    "101046": "Samson",
    "101047": "Xane",
    "101048": "Est",
    "101049": "Tiki",
    "101050": "Lorenz",
    "101051": "Elice",
    "101052": "Gotoh",
    "101053": "Frey",
    "101054": "Norne",
    "101055": "Athena",
    "101056": "Horace",
    "101057": "Etzel",
    "101058": "Ymir",
    "101059": "Nagi",
    "101060": "Malledus",
    "101061": "Nyna",
    "101062": "Gharnef",
    "101063": "Camus",
    "101064": "Michalis",
    "101065": "Medeus",
    "101066": "Anna",
    "102001": "Alm",
    "102002": "Lukas",
    "102003": "Gray",
    "102004": "Tobin",
    "102005": "Kliff",
    "102006": "Silque",
    "102007": "Clair",
    "102008": "Clive",
    "102009": "Forsyth",
    "102010": "Python",
    "102011": "Celica",
    "102012": "Mae",
    "102013": "Boey",
    "102014": "Genny",
    "102015": "Saber",
    "102016": "Valbar",
    "102017": "Kamui",
    "102018": "Leon",
    "102019": "Luthier",
    "102020": "Mathilda",
    "102021": "Delthea",
    "102022": "Palla",
    "102023": "Catria",
    "102024": "Atlas",
    "102025": "Jesse",
    "102026": "Deen",
    "102027": "Sonya",
    "102028": "Est",
    "102029": "Nomah",
    "102030": "Tatiana",
    "102031": "Zeke",
    "102032": "Mycen",
    "102033": "Desaix",
    "102034": "Grieth",
    "102035": "Rudolf",
    "102036": "Faye",
    "102037": "Clive",
    "102038": "Conrad",
    "102039": "Berkut",
    "102040": "Rinea",
    "102041": "Fernand",
    "102042": "Jedah",
    "102043": "Slayde",
    "102044": "Massena",
    "102045": "Lawson",
    "102046": "Jerome",
    "102047": "Tatarrah",
    "102048": "Dolth",
    "102049": "Nuibaba",
    "102050": "Hestia",
    "102051": "Marla",
    "102052": "Barth",
    "102053": "Garth",
    "102054": "Blake",
    "102055": "Mila",
    "102056": "Duma",
    "102057": "Brigand Boss",
    "102058": "Halcyon",
    "102059": "Irma",
    "103001": "Marth",
    "103002": "Kris (male)",
    "103003": "Kris (female)",
    "103004": "Abel",
    "103005": "Arran",
    "103006": "Astram",
    "103007": "Bantu",
    "103008": "Barst",
    "103009": "Beck",
    "103010": "Vyland",
    "103011": "Boah",
    "103012": "Xane",
    "103013": "Darros",
    "103014": "Draug",
    "103015": "Elice",
    "103016": "Est",
    "103017": "Gotoh",
    "103018": "Gordin",
    "103020": "Jagen",
    "103021": "Jake",
    "103022": "Jeorge",
    "103023": "Julian",
    "103024": "Cain",
    "103025": "Castor",
    "103026": "Catria",
    "103027": "Cord",
    "103028": "Maria",
    "103029": "Merric",
    "103030": "Matthis",
    "103031": "Midia",
    "103032": "Minerva",
    "103033": "Macellan",
    "103034": "Navarre",
    "103035": "Ogma",
    "103036": "Palla",
    "103037": "Radd",
    "103038": "Lena",
    "103039": "Rickard",
    "103040": "Wrys",
    "103041": "Linde",
    "103042": "Roger",
    "103043": "Lorenz",
    "103044": "Roshea",
    "103045": "Bord",
    "103046": "Samson",
    "103047": "Caesar",
    "103048": "Caeda",
    "103049": "Tomas",
    "103050": "Tiki",
    "103051": "Dolph",
    "103052": "Wendell",
    "103053": "Wolf",
    "103054": "Sedgar",
    "103055": "Frey",
    "103056": "Norne",
    "103057": "Athena",
    "103058": "Horace",
    "103059": "Etzel",
    "103060": "Ymir",
    "103061": "Nagi",
    "103062": "Nyna",
    "103063": "Katarina",
    "103064": "Roderick",
    "103065": "Cecil",
    "103066": "Yuliya",
    "103067": "Jubelo",
    "103068": "Lang",
    "103069": "Hardin",
    "103070": "Luke",
    "103071": "Marisha",
    "103072": "Ryan",
    "103073": "Sirius",
    "103074": "Samuel",
    "103075": "Warren",
    "103076": "Sheena",
    "103077": "Phina",
    "103078": "Arlen",
    "103079": "Frost",
    "103080": "Malice",
    "103081": "Dice",
    "103082": "Reiden",
    "103083": "Belf",
    "103084": "Roberto",
    "103085": "Gharnef",
    "103086": "Camus",
    "103087": "Michalis",
    "103088": "Legion",
    "103089": "Clarisse",
    "103090": "Eremiya",
    "103091": "Medeus",
    "103092": "Anna",
    "104001": "Sigurd",
    "104002": "Naoise",
    "104003": "Alec",
    "104004": "Arden",
    "104005": "Midir",
    "104006": "Edain",
    "104007": "Brigid",
    "104008": "Azelle",
    "104009": "Claud",
    "104010": "Tailtiu",
    "104011": "Lex",
    "104012": "Quan",
    "104013": "Ethlyn",
    "104014": "Finn",
    "104015": "Ayra",
    "104016": "Jamke",
    "104017": "Lewyn",
    "104018": "Erinys",
    "104019": "Lachesis",
    "104020": "Seliph",
    "104021": "Oifey",
    "104022": "Shannan",
    "104023": "Ulster",
    "104024": "Larcei",
    "104025": "Lana",
    "104026": "Diarmuid",
    "104027": "Lester",
    "104028": "Leif",
    "104029": "Finn",
    "104030": "Nanna",
    "104031": "Tine",
    "104032": "Patty",
    "104033": "Febail",
    "104034": "Arthur",
    "104035": "Fee",
    "104036": "Ced",
    "104037": "Altena",
    "104038": "Hannibal",
    "104039": "Coirpre",
    "104040": "Julia",
    "104041": "Ares",
    "104042": "Lene",
    "104043": "Dalvin",
    "104044": "Creidne",
    "104045": "Muirne",
    "104046": "Tristan",
    "104047": "Deimne",
    "104048": "Jeanne",
    "104049": "Linda",
    "104050": "Daisy",
    "104051": "Asaello",
    "104052": "Amid",
    "104053": "Hermina",
    "104054": "Hawk",
    "104055": "Charlot",
    "104056": "Laylea",
    "104057": "Eldigan",
    "104058": "Cimbaeth",
    "104059": "Munnir",
    "104060": "Sandima",
    "104062": "Chagall",
    "104063": "Annand",
    "104064": "Byron",
    "104065": "Andrey",
    "104066": "Lombard",
    "104067": "Reptor",
    "104068": "Aida",
    "104069": "Arvis",
    "104070": "Danann",
    "104071": "Kutuzov",
    "104072": "Ishtore",
    "104073": "Bloom",
    "104074": "Travant",
    "104075": "Brian",
    "104076": "Scipio",
    "104077": "Hilda",
    "104078": "Ishtar",
    "104079": "Arion",
    "104080": "Manfroy",
    "104081": "Julius",
    "104082": "Dew",
    "104083": "Deirdre",
    "104084": "Chulainn",
    "104085": "Silvia",
    "104086": "Beowolf",
    "104087": "Iuchar",
    "104088": "Iucharba",
    "105001": "Leif",
    "105002": "Finn",
    "105003": "Eyvel",
    "105004": "Halvan",
    "105005": "Osian",
    "105006": "Dagdar",
    "105007": "Tanya",
    "105008": "Marty",
    "105009": "Ronan",
    "105010": "Lifis",
    "105011": "Safy",
    "105012": "Brighton",
    "105013": "Machyua",
    "105014": "Lara",
    "105015": "Fergus",
    "105016": "Karin",
    "105017": "Dalsin",
    "105018": "Asbel",
    "105019": "Nanna",
    "105020": "Hicks",
    "105021": "Shiva",
    "105022": "Carrion",
    "105023": "Selphina",
    "105024": "Cain",
    "105025": "Alva",
    "105026": "Robert",
    "105027": "Fred",
    "105028": "Olwen",
    "105029": "Mareeta",
    "105030": "Salem",
    "105031": "Perne",
    "105032": "Tina",
    "105033": "Troude",
    "105034": "Glade",
    "105035": "Deen",
    "105036": "Eda",
    "105037": "Homer",
    "105038": "Linoan",
    "105039": "Ralf",
    "105040": "Ilios",
    "105041": "Sleuf",
    "105042": "Sara",
    "105043": "Miranda",
    "105044": "Shannam",
    "105045": "Misha",
    "105046": "Xavier",
    "105047": "Amalda",
    "105048": "Conomor",
    "105049": "Diarmuid",
    "105050": "Saias",
    "105051": "Ced",
    "105052": "Galzus",
    "105053": "Kempf",
    "105054": "Reinhardt",
    "105055": "Raydrik",
    "105056": "Veld",
    "106001": "Roy",
    "106002": "Marcus",
    "106003": "Alen",
    "106004": "Lance",
    "106005": "Wolt",
    "106006": "Bors",
    "106007": "Merlinus",
    "106008": "Elen",
    "106009": "Dieck",
    "106010": "Lot",
    "106011": "Shanna",
    "106012": "Chad",
    "106013": "Lugh",
    "106014": "Clarine",
    "106015": "Rutger",
    "106016": "Saul",
    "106017": "Dorothy",
    "106018": "Sue",
    "106019": "Zelot",
    "106020": "Trec",
    "106021": "Noah",
    "106022": "Astolfo",
    "106023": "Lilina",
    "106024": "Barthe",
    "106025": "Ogier",
    "106026": "Gwendolyn",
    "106027": "Fir",
    "106028": "Sin",
    "106029": "Geese",
    "106030": "Gonzalez",
    "106031": "Klein",
    "106032": "Thea",
    "106033": "Larum",
    "106034": "Elffin",
    "106035": "Echidna",
    "106036": "Bartre",
    "106037": "Raigh",
    "106038": "Cath",
    "106039": "Melady",
    "106040": "Perceval",
    "106041": "Cecilia",
    "106042": "Sophia",
    "106043": "Igrene",
    "106044": "Garret",
    "106045": "Fae",
    "106046": "Hugh",
    "106047": "Zeiss",
    "106048": "Douglas",
    "106049": "Niime",
    "106050": "Juno",
    "106051": "Dayan",
    "106052": "Yoder",
    "106053": "Karel",
    "106054": "Narcian",
    "106055": "Galle",
    "106056": "Hector",
    "106057": "Brunnya",
    "106058": "Murdock",
    "106059": "Eliwood",
    "106060": "Zephiel",
    "106061": "Guinivere",
    "106062": "Jahn",
    "106063": "Idunn",
    "106064": "Wade",
    "107001": "Lyn",
    "107002": "Sain",
    "107003": "Kent",
    "107004": "Florina",
    "107005": "Wil",
    "107006": "Dorcas",
    "107007": "Serra",
    "107008": "Erk",
    "107009": "Rath",
    "107010": "Matthew",
    "107011": "Nils",
    "107012": "Lucius",
    "107013": "Wallace",
    "107014": "Eliwood",
    "107015": "Marcus",
    "107016": "Lowen",
    "107017": "Rebecca",
    "107018": "Bartre",
    "107019": "Hector",
    "107020": "Oswin",
    "107021": "Guy",
    "107022": "Merlinus",
    "107023": "Priscilla",
    "107024": "Raven",
    "107025": "Canas",
    "107026": "Dart",
    "107027": "Fiora",
    "107028": "Legault",
    "107029": "Ninian",
    "107030": "Isadora",
    "107031": "Heath",
    "107032": "Hawkeye",
    "107033": "Geitz",
    "107034": "Pent",
    "107035": "Louise",
    "107036": "Karel",
    "107037": "Harken",
    "107038": "Nino",
    "107039": "Jaffar",
    "107040": "Vaida",
    "107041": "Renault",
    "107042": "Athos",
    "107043": "Farina",
    "107044": "Karla",
    "107045": "Leila",
    "107046": "Guinivere",
    "107047": "Zephiel",
    "107048": "Lloyd",
    "107049": "Linus",
    "107050": "Ursula",
    "107051": "Ephidel",
    "107052": "Sonia",
    "107053": "Limstella",
    "107054": "Nergal",
    "108001": "Eirika",
    "108002": "Seth",
    "108003": "Gilliam",
    "108004": "Franz",
    "108005": "Moulder",
    "108006": "Vanessa",
    "108007": "Ross",
    "108008": "Garcia",
    "108009": "Neimi",
    "108010": "Colm",
    "108011": "Artur",
    "108012": "Lute",
    "108013": "Natasha",
    "108014": "Joshua",
    "108015": "Ephraim",
    "108016": "Forde",
    "108017": "Kyle",
    "108018": "Orson",
    "108019": "Tana",
    "108020": "Amelia",
    "108021": "Innes",
    "108022": "Gerik",
    "108023": "Tethys",
    "108024": "Marisa",
    "108025": "L'Arachel",
    "108026": "Dozla",
    "108027": "Saleh",
    "108028": "Ewan",
    "108029": "Cormag",
    "108030": "Rennac",
    "108031": "Duessel",
    "108032": "Knoll",
    "108033": "Myrrh",
    "108034": "Syrene",
    "108035": "Caellach",
    "108036": "Riev",
    "108037": "Ismaire",
    "108038": "Selena",
    "108039": "Glen",
    "108040": "Hayden",
    "108041": "Valter",
    "108042": "Fado",
    "108043": "Lyon",
    "109001": "Ike",
    "109002": "Titania",
    "109003": "Oscar",
    "109004": "Boyd",
    "109005": "Rhys",
    "109006": "Shinon",
    "109007": "Gatrie",
    "109008": "Soren",
    "109009": "Mist",
    "109010": "Rolf",
    "109011": "Greil",
    "109012": "Mia",
    "109013": "Kieran",
    "109014": "Brom",
    "109015": "Nephenee",
    "109016": "Lucia",
    "109017": "Bastian",
    "109018": "Geoffrey",
    "109019": "Elincia",
    "109020": "Renning",
    "109021": "Lethe",
    "109022": "Mordecai",
    "109023": "Muarim",
    "109024": "Ranulf",
    "109025": "Giffca",
    "109026": "Caineghis",
    "109027": "Ena",
    "109028": "Nasir",
    "109029": "Gareth",
    "109030": "Kurthnaga",
    "109031": "Dheginsea",
    "109032": "Ulki",
    "109033": "Janaff",
    "109034": "Tibarn",
    "109035": "Reyson",
    "109036": "Leanne",
    "109037": "Naesala",
    "109038": "Nealuchi",
    "109039": "Marcia",
    "109040": "Astrid",
    "109041": "Makalov",
    "109042": "Tormod",
    "109043": "Tanith",
    "109044": "Zelgius",
    "109045": "Sigrun",
    "109046": "Sephiran",
    "109047": "Sanaki",
    "109048": "Jill",
    "109049": "Tauroneo",
    "109050": "Haar",
    "109051": "Petrine",
    "109052": "Bertram",
    "109053": "Black Knight",
    "109054": "Ashnard",
    "109055": "Ilyana",
    "109056": "Volke",
    "109057": "Zihark",
    "109058": "Sothe",
    "109059": "Stefan",
    "109060": "Devdan",
    "109061": "Calill",
    "109062": "Largo",
    "109063": "Elena",
    "110001": "Nolan",
    "110002": "Laura",
    "110003": "Sothe",
    "110004": "Edward",
    "110005": "Micaiah",
    "110006": "Ike",
    "110007": "Izuka",
    "110008": "Ena",
    "110009": "Ilyana",
    "110010": "Danved",
    "110011": "Ulki",
    "110012": "Elincia",
    "110013": "Oscar",
    "110014": "Oliver",
    "110015": "Volug",
    "110016": "Caineghis",
    "110017": "Gatrie",
    "110018": "Calill",
    "110019": "Kyza",
    "110020": "Rhys",
    "110021": "Kurthnaga",
    "110022": "Kieran",
    "110023": "Gareth",
    "110024": "Sanaki",
    "110025": "Sigrun",
    "110026": "Black Knight",
    "110027": "Shinon",
    "110028": "Giffca",
    "110029": "Geoffrey",
    "110030": "Jill",
    "110031": "Skrimir",
    "110032": "Astrid",
    "110033": "Soren",
    "110034": "Sephiran",
    "110035": "Zelgius",
    "110036": "Stefan",
    "110037": "Tauroneo",
    "110038": "Tanith",
    "110039": "Brom",
    "110040": "Zihark",
    "110041": "Titania",
    "110042": "Tibarn",
    "110043": "Dheginsea",
    "110044": "Tormod",
    "110045": "Nasir",
    "110046": "Nealuchi",
    "110047": "Nailah",
    "110048": "Naesala",
    "110049": "Nephenee",
    "110050": "Haar",
    "110051": "Vika",
    "110052": "Volke",
    "110053": "Aran",
    "110054": "Fiona",
    "110055": "Heather",
    "110056": "Hetzel",
    "110057": "Pelleas",
    "110058": "Boyd",
    "110059": "Marcia",
    "110060": "Makalov",
    "110061": "Mist",
    "110062": "Muarim",
    "110063": "Meg",
    "110064": "Mordecai",
    "110065": "Janaff",
    "110066": "Bastian",
    "110067": "Rolf",
    "110068": "Ranulf",
    "110069": "Rafiel",
    "110070": "Leanne",
    "110071": "Lyre",
    "110072": "Reyson",
    "110073": "Lucia",
    "110074": "Leonardo",
    "110075": "Lethe",
    "110076": "Renning",
    "110077": "Mia",
    "110078": "Anna",
    "110079": "Muston",
    "110080": "Aimee",
    "110081": "Jorge",
    "110082": "Daniel",
    "110083": "Jarod",
    "110084": "Valtome",
    "110085": "Ashunera",
    "110086": "Ashera",
    "110087": "Yune",
    "110089": "Largo",
    "110090": "Amy",
    "110091": "Almedha",
    "111001": "Robin (male)",
    "111002": "Robin (female)",
    "111003": "Chrom",
    "111004": "Frederick",
    "111005": "Kellam",
    "111006": "Ricken",
    "111007": "Vaike",
    "111008": "Lon'qu",
    "111009": "Virion",
    "111010": "Basilio",
    "111011": "Sumia",
    "111012": "Lissa",
    "111013": "Cherche",
    "111014": "Miriel",
    "111015": "Masked Marth",
    "111016": "Lucina",
    "111017": "Walhart",
    "111018": "Emmeryn",
    "111019": "Validar",
    "111020": "Sully",
    "111021": "Stahl",
    "111022": "Maribelle",
    "111023": "Panne",
    "111024": "Gaius",
    "111025": "Cordelia",
    "111026": "Gregor",
    "111027": "Nowi",
    "111028": "Libra",
    "111029": "Tharja",
    "111030": "Olivia",
    "111031": "Henry",
    "111032": "Say'ri",
    "111033": "Flavia",
    "111034": "Donnel",
    "111035": "Owain",
    "111036": "Inigo",
    "111037": "Brady",
    "111038": "Kjelle",
    "111039": "Cynthia",
    "111040": "Severa",
    "111041": "Gerome",
    "111042": "Morgan (male)",
    "111043": "Morgan (female)",
    "111044": "Yarne",
    "111045": "Laurent",
    "111046": "Noire",
    "111047": "Nah",
    "111048": "Tiki",
    "111049": "Anna",
    "111050": "Aversa",
    "111051": "Priam",
    "111052": "Gangrel",
    "111053": "Yen'fay",
    "111054": "Mustafa",
    "111055": "Cervantes",
    "111056": "Excellus",
    "111057": "Naga",
    "111058": "Grima",
    "112001": "Corrin (male)",
    "112002": "Corrin (female)",
    "112003": "Jakob",
    "112004": "Silas",
    "112005": "Kaze",
    "112006": "Ryoma",
    "112007": "Takumi",
    "112008": "Saizo",
    "112009": "Kaden",
    "112010": "Hinata",
    "112011": "Azama",
    "112012": "Subaki",
    "112013": "Hayato",
    "112014": "Xander",
    "112015": "Leo",
    "112016": "Benny",
    "112017": "Keaton",
    "112018": "Arthur",
    "112019": "Odin",
    "112020": "Laslow",
    "112021": "Niles",
    "112022": "Felicia",
    "112023": "Azura",
    "112024": "Mozu",
    "112025": "Hinoka",
    "112026": "Sakura",
    "112027": "Orochi",
    "112028": "Kagero",
    "112029": "Hana",
    "112030": "Setsuna",
    "112031": "Reina",
    "112032": "Oboro",
    "112033": "Camilla",
    "112034": "Elise",
    "112035": "Charlotte",
    "112036": "Effie",
    "112037": "Peri",
    "112038": "Beruka",
    "112039": "Selena",
    "112040": "Nyx",
    "112041": "Kana (female)",
    "112042": "Kana (male)",
    "112043": "Shigure",
    "112044": "Dwyer",
    "112045": "Sophie",
    "112046": "Midori",
    "112047": "Shiro",
    "112048": "Kiragi",
    "112049": "Asugi",
    "112050": "Selkie",
    "112051": "Hisame",
    "112052": "Mitama",
    "112053": "Caeldori",
    "112054": "Rhajat",
    "112055": "Siegbert",
    "112056": "Ignatius",
    "112057": "Forrest",
    "112058": "Velouria",
    "112059": "Percy",
    "112060": "Ophelia",
    "112061": "Soleil",
    "112062": "Nina",
    "112063": "Shura",
    "112064": "Fuga",
    "112065": "Yukimura",
    "112066": "Izana",
    "112067": "Gunter",
    "112068": "Nichol",
    "112069": "Rinkah",
    "112070": "Anna",
    "112071": "Scarlet",
    "112072": "Candace",
    "112073": "Flora",
    "112074": "Lilith",
    "112075": "Arete",
    "112076": "Garon",
    "112077": "Sumeragi",
    "112078": "Mikoto",
    "112079": "Iago",
    "112080": "Zola",
    "112081": "Hans",
    "112082": "Layla",
    "112083": "Rainbow Sage",
    "112084": "Anankos",
    "113001": "Alfonse",
    "113002": "Sharena",
    "113003": "Anna",
    "113004": "Veronica",
    "113005": "Bruno",
    "113006": "Fjorm",
    "113007": "Gunnthrá",
    "113008": "Surtr",
    "113009": "Laevatein",
    "113010": "Loki",
    "113011": "Helbindi",
    "113012": "Laegjarn",
    "113013": "Ylgr",
    "113014": "Hríd",
    "113015": "Eir",
    "113016": "Líf",
    "113017": "Thrasir",
    "113018": "Hel",
    "113019": "Triandra",
    "113020": "Peony",
    "113021": "Plumeria",
    "113022": "Freyr",
    "114001": "Itsuki & Chrom",
    "114002": "Tsubasa & Caeda",
    "114003": "Touma & Cain",
    "114004": "Kiria & Tharja",
    "114005": "Yashiro & Navarre",
    "114006": "Eleonora & Virion",
    "114007": "Mamori & Draug",
    "114008": "Maiko",
    "114009": "Tiki",
    "114010": "Barry",
    "114011": "Ayaha & Aversa",
    "114012": "Chikaomi & Lon'qu",
    "114013": "Teru & Garrick",
    "114014": "Nobu & Gangrel",
    "114015": "Kuen & Excellus",
    "114016": "Yatsufusa & Gharnef",
    "114017": "Chouten & Pheros",
    "114018": "Riku & Abel",
    "115001": "Byleth (male)",
    "115002": "Byleth (male, Enlightened)",
    "115003": "Byleth (female)",
    "115004": "Byleth (female, Enlightened)",
    "115005": "Edelgard",
    "115006": "Dimitri",
    "115007": "Claude",
    "115008": "Hubert",
    "115009": "Ferdinand",
    "115010": "Linhardt",
    "115011": "Caspar",
    "115012": "Bernadetta",
    "115013": "Dorothea",
    "115014": "Petra",
    "115015": "Dedue",
    "115016": "Felix",
    "115017": "Ashe",
    "115018": "Sylvain",
    "115019": "Mercedes",
    "115020": "Annette",
    "115021": "Ingrid",
    "115022": "Lorenz",
    "115023": "Raphael",
    "115024": "Ignatz",
    "115025": "Lysithea",
    "115026": "Marianne",
    "115027": "Hilda",
    "115028": "Leonie",
    "115029": "Seteth",
    "115030": "Flayn",
    "115031": "Hanneman",
    "115032": "Manuela",
    "115033": "Gilbert",
    "115034": "Alois",
    "115035": "Catherine",
    "115036": "Shamir",
    "115037": "Cyril",
    "115038": "Jeralt",
    "115039": "Rhea",
    "115040": "Sothis",
    "115041": "Kronya",
    "115042": "Solon",
    "115043": "Death Knight",
    "115044": "Kostas",
    "115045": "Lonato",
    "115046": "Miklan",
    "115047": "Flame Emperor",
    "115048": "Anna",
    "115049": "Jeritza",
    "115050": "Rodrigue",
    "115051": "Judith",
    "115052": "Monica",
    "115053": "Lord Arundel",
    "115054": "Tomas",
    "115055": "Emperor Ionius IX",
    "115056": "Metodey",
    "115057": "Ladislava",
    "115058": "Acheron",
    "116001": "Edelgard",
    "116002": "Dimitri",
    "116003": "Claude",
    "116004": "Hubert",
    "116005": "Ferdinand",
    "116006": "Linhardt",
    "116007": "Caspar",
    "116008": "Bernadetta",
    "116009": "Dorothea",
    "116010": "Petra",
    "116011": "Dedue",
    "116012": "Felix",
    "116013": "Ashe",
    "116014": "Sylvain",
    "116015": "Mercedes",
    "116016": "Annette",
    "116017": "Ingrid",
    "116018": "Lorenz",
    "116019": "Raphael",
    "116020": "Ignatz",
    "116021": "Lysithea",
    "116022": "Marianne",
    "116023": "Hilda",
    "116024": "Leonie",
    "116025": "Cyril",
    "116026": "Thales",
    "116027": "Cornelia",
    "116028": "Randolph",
    "116029": "Nader",
    "116030": "Nemesis",
    "116031": "Seiros",
    "116032": "Duke Aegir",
    "116033": "Lambert",
    "116034": "Gwendal",
    "116035": "Pallardó"
  },
  "es-MX": {
    "101001": "Marth",
    "101002": "Shiida",
    "101003": "Jagen",
    "101004": "Cain",
    "101005": "Abel",
    "101006": "Draug",
    "101007": "Gordin",
    "101008": "Wrys",
    "101009": "Ogma",
    "101010": "Barst",
    "101011": "Bord",
    "101012": "Cord",
    "101013": "Castor",
    "101014": "Darros",
    "101015": "Julian",
    "101016": "Lena",
    "101017": "Navarre",
    "101018": "Merric",
    "101019": "Matthis",
    "101020": "Hardin",
    "101021": "Wolf",
    "101022": "Sedgar",
    "101023": "Roshea",
    "101024": "Vyland",
    "101025": "Wendell",
    "101026": "Rickard",
    "101027": "Bantu",
    "101028": "Caesar",
    "101029": "Radd",
    "101030": "Roger",
    "101031": "Jeorge",
    "101032": "María",
    "101033": "Minerva",
    "101034": "Linde",
    "101035": "Jake",
    "101036": "Midia",
    "101037": "Dolph",
    "101038": "Macellan",
    "101039": "Tomas",
    "101040": "Boah",
    "101041": "Beck",
    "101042": "Astram",
    "101043": "Palla",
    "101044": "Catria",
    "101045": "Arran",
    "101046": "Samson",
    "101047": "Xane",
    "101048": "Est",
    "101049": "Tiki",
    "101050": "Lorenz",
    "101051": "Elice",
    "101052": "Gotoh",
    "101053": "Frey",
    "101054": "Norne",
    "101055": "Athena",
    "101056": "Horace",
    "101057": "Etzel",
    "101058": "Ymir",
    "101059": "Nagi",
    "101060": "Malledus",
    "101061": "Nyna",
    "101062": "Gharnef",
    "101063": "Camus",
    "101064": "Michalis",
    "101065": "Medeus",
    "101066": "Anna",
    "102001": "Alm",
    "102002": "Lukas",
    "102003": "Gray",
    "102004": "Tobin",
    "102005": "Kliff",
    "102006": "Silque",
    "102007": "Clair",
    "102008": "Clive",
    "102009": "Forsyth",
    "102010": "Python",
    "102011": "Celica",
    "102012": "Mae",
    "102013": "Boey",
    "102014": "Genny",
    "102015": "Saber",
    "102016": "Valbar",
    "102017": "Kamui",
    "102018": "Leon",
    "102019": "Luthier",
    "102020": "Mathilda",
    "102021": "Delthea",
    "102022": "Palla",
    "102023": "Catria",
    "102024": "Atlas",
    "102025": "Jesse",
    "102026": "Deen",
    "102027": "Sonya",
    "102028": "Est",
    "102029": "Nomah",
    "102030": "Tatiana",
    "102031": "Zeke",
    "102032": "Mycen",
    "102033": "Desaix",
    "102034": "Grieth",
    "102035": "Rudolf",
    "102036": "Faye",
    "102037": "Clive",
    "102038": "Conrad",
    "102039": "Berkut",
    "102040": "Rinea",
    "102041": "Fernand",
    "102042": "Jedah",
    "102043": "Slayde",
    "102044": "Massena",
    "102045": "Lawson",
    "102046": "Jerome",
    "102047": "Tatarrah",
    "102048": "Dolth",
    "102049": "Nuibaba",
    "102050": "Hestia",
    "102051": "Marla",
    "102052": "Barth",
    "102053": "Garth",
    "102054": "Blake",
    "102055": "Mila",
    "102056": "Duma",
    "102057": "Jefe",
    "102058": "Halcyon",
    "102059": "Irma",
    "103001": "Marth",
    "103002": "Kris (chico)",
    "103003": "Kris (chica)",
    "103004": "Abel",
    "103005": "Arran",
    "103006": "Astram",
    "103007": "Bantu",
    "103008": "Barst",
    "103009": "Beck",
    "103010": "Vyland",
    "103011": "Boah",
    "103012": "Xane",
    "103013": "Darros",
    "103014": "Draug",
    "103015": "Elice",
    "103016": "Est",
    "103017": "Gotoh",
    "103018": "Gordin",
    "103020": "Jagen",
    "103021": "Jake",
    "103022": "Jeorge",
    "103023": "Julian",
    "103024": "Cain",
    "103025": "Castor",
    "103026": "Catria",
    "103027": "Cord",
    "103028": "María",
    "103029": "Merric",
    "103030": "Matthis",
    "103031": "Midia",
    "103032": "Minerva",
    "103033": "Macellan",
    "103034": "Navarre",
    "103035": "Ogma",
    "103036": "Palla",
    "103037": "Radd",
    "103038": "Lena",
    "103039": "Rickard",
    "103040": "Wrys",
    "103041": "Linde",
    "103042": "Roger",
    "103043": "Lorenz",
    "103044": "Roshea",
    "103045": "Bord",
    "103046": "Samson",
    "103047": "Caesar",
    "103048": "Shiida",
    "103049": "Tomas",
    "103050": "Tiki",
    "103051": "Dolph",
    "103052": "Wendell",
    "103053": "Wolf",
    "103054": "Sedgar",
    "103055": "Frey",
    "103056": "Norne",
    "103057": "Athena",
    "103058": "Horace",
    "103059": "Etzel",
    "103060": "Ymir",
    "103061": "Nagi",
    "103062": "Nyna",
    "103063": "Katarina",
    "103064": "Roderick",
    "103065": "Cecil",
    "103066": "Yuliya",
    "103067": "Jubelo",
    "103068": "Lang",
    "103069": "Hardin",
    "103070": "Luke",
    "103071": "Marisha",
    "103072": "Ryan",
    "103073": "Sirius",
    "103074": "Samuel",
    "103075": "Warren",
    "103076": "Sheena",
    "103077": "Phina",
    "103078": "Arlen",
    "103079": "Frost",
    "103080": "Malice",
    "103081": "Dice",
    "103082": "Reiden",
    "103083": "Belf",
    "103084": "Roberto",
    "103085": "Gharnef",
    "103086": "Camus",
    "103087": "Michalis",
    "103088": "Legion",
    "103089": "Clarisse",
    "103090": "Eremiya",
    "103091": "Medeus",
    "103092": "Anna",
    "104001": "Sigurd",
    "104002": "Naoise",
    "104003": "Alec",
    "104004": "Arden",
    "104005": "Midir",
    "104006": "Edain",
    "104007": "Brigid",
    "104008": "Azelle",
    "104009": "Claud",
    "104010": "Tailtiu",
    "104011": "Lex",
    "104012": "Quan",
    "104013": "Ethlyn",
    "104014": "Finn",
    "104015": "Ayra",
    "104016": "Jamke",
    "104017": "Lewyn",
    "104018": "Erinys",
    "104019": "Lachesis",
    "104020": "Seliph",
    "104021": "Oifey",
    "104022": "Shannan",
    "104023": "Ulster",
    "104024": "Larcei",
    "104025": "Lana",
    "104026": "Diarmuid",
    "104027": "Lester",
    "104028": "Leif",
    "104029": "Finn",
    "104030": "Nanna",
    "104031": "Tine",
    "104032": "Patty",
    "104033": "Febail",
    "104034": "Arthur",
    "104035": "Fee",
    "104036": "Ced",
    "104037": "Altena",
    "104038": "Hannibal",
    "104039": "Coirpre",
    "104040": "Julia",
    "104041": "Ares",
    "104042": "Lene",
    "104043": "Dalvin",
    "104044": "Creidne",
    "104045": "Muirne",
    "104046": "Tristan",
    "104047": "Deimne",
    "104048": "Jeanne",
    "104049": "Linda",
    "104050": "Daisy",
    "104051": "Asaello",
    "104052": "Amid",
    "104053": "Hermina",
    "104054": "Hawk",
    "104055": "Charlot",
    "104056": "Laylea",
    "104057": "Eldigan",
    "104058": "Cimbaeth",
    "104059": "Munnir",
    "104060": "Sandima",
    "104062": "Chagall",
    "104063": "Annand",
    "104064": "Byron",
    "104065": "Andrey",
    "104066": "Lombard",
    "104067": "Reptor",
    "104068": "Aida",
    "104069": "Arvis",
    "104070": "Danann",
    "104071": "Kutuzov",
    "104072": "Ishtore",
    "104073": "Bloom",
    "104074": "Travant",
    "104075": "Brian",
    "104076": "Scipio",
    "104077": "Hilda",
    "104078": "Ishtar",
    "104079": "Arion",
    "104080": "Manfroy",
    "104081": "Julius",
    "104082": "Dew",
    "104083": "Deirdre",
    "104084": "Chulainn",
    "104085": "Silvia",
    "104086": "Beowolf",
    "104087": "Iuchar",
    "104088": "Iucharba",
    "105001": "Leif",
    "105002": "Finn",
    "105003": "Eyvel",
    "105004": "Halvan",
    "105005": "Osian",
    "105006": "Dagdar",
    "105007": "Tanya",
    "105008": "Marty",
    "105009": "Ronan",
    "105010": "Lifis",
    "105011": "Safy",
    "105012": "Brighton",
    "105013": "Machyua",
    "105014": "Lara",
    "105015": "Fergus",
    "105016": "Karin",
    "105017": "Dalsin",
    "105018": "Asbel",
    "105019": "Nanna",
    "105020": "Hicks",
    "105021": "Shiva",
    "105022": "Carrion",
    "105023": "Selphina",
    "105024": "Cain",
    "105025": "Alva",
    "105026": "Robert",
    "105027": "Fred",
    "105028": "Olwen",
    "105029": "Mareeta",
    "105030": "Salem",
    "105031": "Perne",
    "105032": "Tina",
    "105033": "Troude",
    "105034": "Glade",
    "105035": "Deen",
    "105036": "Eda",
    "105037": "Homer",
    "105038": "Linoan",
    "105039": "Ralf",
    "105040": "Ilios",
    "105041": "Sleuf",
    "105042": "Sara",
    "105043": "Miranda",
    "105044": "Shannam",
    "105045": "Misha",
    "105046": "Xavier",
    "105047": "Amalda",
    "105048": "Conomor",
    "105049": "Diarmuid",
    "105050": "Saias",
    "105051": "Ced",
    "105052": "Galzus",
    "105053": "Kempf",
    "105054": "Reinhardt",
    "105055": "Raydrik",
    "105056": "Veld",
    "106001": "Roy",
    "106002": "Marcus",
    "106003": "Alen",
    "106004": "Lance",
    "106005": "Wolt",
    "106006": "Bors",
    "106007": "Merlinus",
    "106008": "Elen",
    "106009": "Dieck",
    "106010": "Lot",
    "106011": "Shanna",
    "106012": "Chad",
    "106013": "Lugh",
    "106014": "Clarine",
    "106015": "Rutger",
    "106016": "Saul",
    "106017": "Dorothy",
    "106018": "Sue",
    "106019": "Zelot",
    "106020": "Trec",
    "106021": "Noah",
    "106022": "Astolfo",
    "106023": "Lilina",
    "106024": "Barthe",
    "106025": "Ogier",
    "106026": "Gwendolyn",
    "106027": "Fir",
    "106028": "Sin",
    "106029": "Geese",
    "106030": "González",
    "106031": "Klein",
    "106032": "Thea",
    "106033": "Larum",
    "106034": "Elffin",
    "106035": "Echidna",
    "106036": "Bartre",
    "106037": "Raigh",
    "106038": "Cath",
    "106039": "Melady",
    "106040": "Perceval",
    "106041": "Cecilia",
    "106042": "Sophia",
    "106043": "Igrene",
    "106044": "Garret",
    "106045": "Fae",
    "106046": "Hugh",
    "106047": "Zeiss",
    "106048": "Douglas",
    "106049": "Niime",
    "106050": "Juno",
    "106051": "Dayan",
    "106052": "Yoder",
    "106053": "Karel",
    "106054": "Narcian",
    "106055": "Galle",
    "106056": "Héctor",
    "106057": "Brunnya",
    "106058": "Murdock",
    "106059": "Eliwood",
    "106060": "Zephiel",
    "106061": "Guinivere",
    "106062": "Jahn",
    "106063": "Idunn",
    "106064": "Wade",
    "107001": "Lyn",
    "107002": "Sain",
    "107003": "Kent",
    "107004": "Florina",
    "107005": "Wil",
    "107006": "Dorcas",
    "107007": "Serra",
    "107008": "Erk",
    "107009": "Rath",
    "107010": "Matthew",
    "107011": "Nils",
    "107012": "Lucius",
    "107013": "Wallace",
    "107014": "Eliwood",
    "107015": "Marcus",
    "107016": "Lowen",
    "107017": "Rebecca",
    "107018": "Bartre",
    "107019": "Héctor",
    "107020": "Oswin",
    "107021": "Guy",
    "107022": "Merlinus",
    "107023": "Priscilla",
    "107024": "Raven",
    "107025": "Canas",
    "107026": "Dart",
    "107027": "Fiora",
    "107028": "Legault",
    "107029": "Ninian",
    "107030": "Isadora",
    "107031": "Heath",
    "107032": "Hawkeye",
    "107033": "Geitz",
    "107034": "Pent",
    "107035": "Louise",
    "107036": "Karel",
    "107037": "Harken",
    "107038": "Nino",
    "107039": "Jaffar",
    "107040": "Vaida",
    "107041": "Renaud",
    "107042": "Athos",
    "107043": "Farina",
    "107044": "Karla",
    "107045": "Leila",
    "107046": "Guinivere",
    "107047": "Zephiel",
    "107048": "Lloyd",
    "107049": "Linus",
    "107050": "Ursula",
    "107051": "Ephidel",
    "107052": "Sonia",
    "107053": "Limstella",
    "107054": "Nergal",
    "108001": "Eirika",
    "108002": "Seth",
    "108003": "Gilliam",
    "108004": "Franz",
    "108005": "Moulder",
    "108006": "Vanessa",
    "108007": "Ross",
    "108008": "García",
    "108009": "Neimi",
    "108010": "Colm",
    "108011": "Artur",
    "108012": "Lute",
    "108013": "Natasha",
    "108014": "Joshua",
    "108015": "Ephraim",
    "108016": "Forde",
    "108017": "Kyle",
    "108018": "Orson",
    "108019": "Tana",
    "108020": "Amelia",
    "108021": "James",
    "108022": "Gerik",
    "108023": "Tethys",
    "108024": "Marisa",
    "108025": "L'Arachel",
    "108026": "Dozla",
    "108027": "Saleh",
    "108028": "Ewan",
    "108029": "Cormag",
    "108030": "Rennac",
    "108031": "Duessel",
    "108032": "Knoll",
    "108033": "Myrrh",
    "108034": "Syrene",
    "108035": "Caellach",
    "108036": "Riev",
    "108037": "Ismaire",
    "108038": "Selena",
    "108039": "Glen",
    "108040": "Hayden",
    "108041": "Valter",
    "108042": "Vari",
    "108043": "Lyon",
    "109001": "Ike",
    "109002": "Titania",
    "109003": "Oscar",
    "109004": "Boyd",
    "109005": "Rhys",
    "109006": "Shinon",
    "109007": "Gatrie",
    "109008": "Soren",
    "109009": "Mist",
    "109010": "Rolf",
    "109011": "Greil",
    "109012": "Mia",
    "109013": "Kieran",
    "109014": "Brom",
    "109015": "Nephenee",
    "109016": "Lucia",
    "109017": "Bastian",
    "109018": "Geoffrey",
    "109019": "Elincia",
    "109020": "Renning",
    "109021": "Lethe",
    "109022": "Mordecai",
    "109023": "Muarim",
    "109024": "Ranulf",
    "109025": "Giffca",
    "109026": "Caineghis",
    "109027": "Ena",
    "109028": "Nasir",
    "109029": "Gareth",
    "109030": "Kurthnaga",
    "109031": "Dheginsea",
    "109032": "Ulki",
    "109033": "Janaff",
    "109034": "Tibarn",
    "109035": "Reyson",
    "109036": "Leanne",
    "109037": "Naesala",
    "109038": "Nealuchi",
    "109039": "Marcia",
    "109040": "Astrid",
    "109041": "Makalov",
    "109042": "Tormod",
    "109043": "Tanith",
    "109044": "Zelgius",
    "109045": "Sigrun",
    "109046": "Sephiran",
    "109047": "Sanaki",
    "109048": "Jill",
    "109049": "Tauroneo",
    "109050": "Haar",
    "109051": "Petrine",
    "109052": "Bertram",
    "109053": "Caballero Negro",
    "109054": "Ashnard",
    "109055": "Ilyana",
    "109056": "Volke",
    "109057": "Zihark",
    "109058": "Sothe",
    "109059": "Stefan",
    "109060": "Devdan",
    "109061": "Calill",
    "109062": "Largo",
    "109063": "Elena",
    "110001": "Nolan",
    "110002": "Laura",
    "110003": "Sothe",
    "110004": "Edward",
    "110005": "Micaiah",
    "110006": "Ike",
    "110007": "Izuka",
    "110008": "Ena",
    "110009": "Ilyana",
    "110010": "Danved",
    "110011": "Ulki",
    "110012": "Elincia",
    "110013": "Oscar",
    "110014": "Oliver",
    "110015": "Volug",
    "110016": "Caineghis",
    "110017": "Gatrie",
    "110018": "Calill",
    "110019": "Kyza",
    "110020": "Rhys",
    "110021": "Kurthnaga",
    "110022": "Kieran",
    "110023": "Gareth",
    "110024": "Sanaki",
    "110025": "Sigrun",
    "110026": "Caballero Negro",
    "110027": "Shinon",
    "110028": "Giffca",
    "110029": "Geoffrey",
    "110030": "Jill",
    "110031": "Skrimir",
    "110032": "Astrid",
    "110033": "Soren",
    "110034": "Sephiran",
    "110035": "Zelgius",
    "110036": "Stefan",
    "110037": "Tauroneo",
    "110038": "Tanith",
    "110039": "Brom",
    "110040": "Zihark",
    "110041": "Titania",
    "110042": "Tibarn",
    "110043": "Dheginsea",
    "110044": "Tormod",
    "110045": "Nasir",
    "110046": "Nealuchi",
    "110047": "Nailah",
    "110048": "Naesala",
    "110049": "Nephenee",
    "110050": "Haar",
    "110051": "Vika",
    "110052": "Volke",
    "110053": "Aran",
    "110054": "Fiona",
    "110055": "Heather",
    "110056": "Hetzel",
    "110057": "Pelleas",
    "110058": "Boyd",
    "110059": "Marcia",
    "110060": "Makalov",
    "110061": "Mist",
    "110062": "Muarim",
    "110063": "Meg",
    "110064": "Mordecai",
    "110065": "Janaff",
    "110066": "Bastian",
    "110067": "Rolf",
    "110068": "Ranulf",
    "110069": "Rafiel",
    "110070": "Leanne",
    "110071": "Lyre",
    "110072": "Reyson",
    "110073": "Lucia",
    "110074": "Leonardo",
    "110075": "Lethe",
    "110076": "Renning",
    "110077": "Mia",
    "110078": "Anna",
    "110079": "Muston",
    "110080": "Aimee",
    "110081": "Jorge",
    "110082": "Daniel",
    "110083": "Jarod",
    "110084": "Valtome",
    "110085": "Ashunera",
    "110086": "Ashera",
    "110087": "Yune",
    "110089": "Largo",
    "110090": "Amy",
    "110091": "Almedha",
    "111001": "Robin (chico)",
    "111002": "Robin (chica)",
    "111003": "Chrom",
    "111004": "Frederick",
    "111005": "Kellam",
    "111006": "Ricken",
    "111007": "Vaike",
    "111008": "Lon'qu",
    "111009": "Virion",
    "111010": "Basilio",
    "111011": "Sumia",
    "111012": "Lissa",
    "111013": "Cherche",
    "111014": "Miriel",
    "111015": "Marth enmascarado",
    "111016": "Lucina",
    "111017": "Walhart",
    "111018": "Emmeryn",
    "111019": "Valldar",
    "111020": "Sully",
    "111021": "Stahl",
    "111022": "Maribelle",
    "111023": "Panne",
    "111024": "Gaius",
    "111025": "Cordelia",
    "111026": "Gregor",
    "111027": "Nowi",
    "111028": "Libra",
    "111029": "Tharja",
    "111030": "Olivia",
    "111031": "Henry",
    "111032": "Say'ri",
    "111033": "Flavia",
    "111034": "Donnel",
    "111035": "Owain",
    "111036": "Íñigo",
    "111037": "Brady",
    "111038": "Kjelle",
    "111039": "Cynthia",
    "111040": "Severa",
    "111041": "Gerome",
    "111042": "Morgan (chico)",
    "111043": "Morgan (chica)",
    "111044": "Yarne",
    "111045": "Laurent",
    "111046": "Noire",
    "111047": "Nah",
    "111048": "Tiki",
    "111049": "Anna",
    "111050": "Aversa",
    "111051": "Priam",
    "111052": "Gangrel",
    "111053": "Yen'fay",
    "111054": "Mustafa",
    "111055": "Cervantes",
    "111056": "Excellus",
    "111057": "Naga",
    "111058": "Grima",
    "112001": "Corrin (chico)",
    "112002": "Corrin (chica)",
    "112003": "Jakob",
    "112004": "Silas",
    "112005": "Kaze",
    "112006": "Ryoma",
    "112007": "Takumi",
    "112008": "Saizo",
    "112009": "Kaden",
    "112010": "Hinata",
    "112011": "Azama",
    "112012": "Subaki",
    "112013": "Hayato",
    "112014": "Xander",
    "112015": "Leo",
    "112016": "Benny",
    "112017": "Keaton",
    "112018": "Arthur",
    "112019": "Odín",
    "112020": "Laslow",
    "112021": "Niles",
    "112022": "Felicia",
    "112023": "Azura",
    "112024": "Mozu",
    "112025": "Hinoka",
    "112026": "Sakura",
    "112027": "Orochi",
    "112028": "Kagero",
    "112029": "Hana",
    "112030": "Setsuna",
    "112031": "Reyna",
    "112032": "Oboro",
    "112033": "Camilla",
    "112034": "Elise",
    "112035": "Charlotte",
    "112036": "Effie",
    "112037": "Peri",
    "112038": "Beruka",
    "112039": "Selena",
    "112040": "Nyx",
    "112041": "Kana (chica)",
    "112042": "Kana (chico)",
    "112043": "Shigure",
    "112044": "Dwyer",
    "112045": "Sophie",
    "112046": "Midori",
    "112047": "Shiro",
    "112048": "Kiragi",
    "112049": "Asugi",
    "112050": "Selkie",
    "112051": "Hisame",
    "112052": "Mitama",
    "112053": "Caeldori",
    "112054": "Rhajat",
    "112055": "Siegbert",
    "112056": "Ignatius",
    "112057": "Forrest",
    "112058": "Velouria",
    "112059": "Percy",
    "112060": "Ophelia",
    "112061": "Soleil",
    "112062": "Nina",
    "112063": "Shura",
    "112064": "Fuga",
    "112065": "Yukimura",
    "112066": "Izana",
    "112067": "Gunter",
    "112068": "Nichol",
    "112069": "Rinkah",
    "112070": "Anna",
    "112071": "Scarlet",
    "112072": "Candace",
    "112073": "Flora",
    "112074": "Lilith",
    "112075": "Arete",
    "112076": "Garon",
    "112077": "Sumeragi",
    "112078": "Mikoto",
    "112079": "Iago",
    "112080": "Zola",
    "112081": "Hans",
    "112082": "Layla",
    "112083": "Sabio Lumen",
    "112084": "Anankos",
    "113001": "Alfonse",
    "113002": "Sharena",
    "113003": "Anna",
    "113004": "Verónica",
    "113005": "Bruno",
    "113006": "Fjorm",
    "113007": "Gunnthrá",
    "113008": "Surtr",
    "113009": "Laevatein",
    "113010": "Loki",
    "113011": "Helbindi",
    "113012": "Laegjarn",
    "113013": "Ylgr",
    "113014": "Hríd",
    "113015": "Eir",
    "113016": "Líf",
    "113017": "Thrasir",
    "113018": "Hel",
    "113019": "Triandra",
    "113020": "Peony",
    "113021": "Plumeria",
    "113022": "Freyr",
    "114001": "Itsuki y Chrom",
    "114002": "Tsubasa y Shiida",
    "114003": "Touma y Cain",
    "114004": "Kiria y Tharja",
    "114005": "Yashiro y Navarre",
    "114006": "Eleonora y Virion",
    "114007": "Mamori y Draug",
    "114008": "Maiko",
    "114009": "Tiki",
    "114010": "Barry",
    "114011": "Ayaha y Aversa",
    "114012": "Chikaomi y Lon'qu",
    "114013": "Teru y Garrick",
    "114014": "Nobu y Gangrel",
    "114015": "Kuen y Excellus",
    "114016": "Yatsufusa y Gharnef",
    "114017": "Chouten y Pheros",
    "114018": "Riku y Abel",
    "115001": "Byleth (chico)",
    "115002": "Byleth (chico, profeta)",
    "115003": "Byleth (chica)",
    "115004": "Byleth (chica, profeta)",
    "115005": "Edelgard",
    "115006": "Dimitri",
    "115007": "Claude",
    "115008": "Hubert",
    "115009": "Ferdinand",
    "115010": "Linhardt",
    "115011": "Caspar",
    "115012": "Bernadetta",
    "115013": "Dorothea",
    "115014": "Petra",
    "115015": "Dedue",
    "115016": "Felix",
    "115017": "Ashe",
    "115018": "Sylvain",
    "115019": "Mercedes",
    "115020": "Annette",
    "115021": "Ingrid",
    "115022": "Lorenz",
    "115023": "Raphael",
    "115024": "Ignatz",
    "115025": "Lysithea",
    "115026": "Marianne",
    "115027": "Hilda",
    "115028": "Leonie",
    "115029": "Seteth",
    "115030": "Flayn",
    "115031": "Hanneman",
    "115032": "Miguela",
    "115033": "Gilbert",
    "115034": "Alois",
    "115035": "Catherine",
    "115036": "Shamir",
    "115037": "Cyril",
    "115038": "Jeralt",
    "115039": "Rhea",
    "115040": "Sothis",
    "115041": "Kronya",
    "115042": "Solon",
    "115043": "Caballero Sanguinario",
    "115044": "Kostas",
    "115045": "Lonato",
    "115046": "Miklan",
    "115047": "Emperador del Fuego",
    "115048": "Anna",
    "115049": "Jeritza",
    "115050": "Rodrigue",
    "115051": "Judith",
    "115052": "Monica",
    "115053": "Lord Arundel",
    "115054": "Tomas",
    "115055": "Emperador Ionius IX",
    "115056": "Metodey",
    "115057": "Ladislava",
    "115058": "Acheron",
    "116001": "Edelgard",
    "116002": "Dimitri",
    "116003": "Claude",
    "116004": "Hubert",
    "116005": "Ferdinand",
    "116006": "Linhardt",
    "116007": "Caspar",
    "116008": "Bernadetta",
    "116009": "Dorothea",
    "116010": "Petra",
    "116011": "Dedue",
    "116012": "Felix",
    "116013": "Ashe",
    "116014": "Sylvain",
    "116015": "Mercedes",
    "116016": "Annette",
    "116017": "Ingrid",
    "116018": "Lorenz",
    "116019": "Raphael",
    "116020": "Ignatz",
    "116021": "Lysithea",
    "116022": "Marianne",
    "116023": "Hilda",
    "116024": "Leonie",
    "116025": "Cyril",
    "116026": "Thales",
    "116027": "Cornelia",
    "116028": "Randolph",
    "116029": "Nader",
    "116030": "Némesis",
    "116031": "Seiros",
    "116032": "Duque de Aegir",
    "116033": "Lambert",
    "116034": "Gwendal",
    "116035": "Pallardó"
  },
  "fr-CA": {
    "101001": "Marth",
    "101002": "Caeda",
    "101003": "Jagen",
    "101004": "Cain",
    "101005": "Abel",
    "101006": "Draug",
    "101007": "Gordin",
    "101008": "Wrys",
    "101009": "Ogma",
    "101010": "Barst",
    "101011": "Bord",
    "101012": "Cord",
    "101013": "Castor",
    "101014": "Darros",
    "101015": "Julian",
    "101016": "Lena",
    "101017": "Navarre",
    "101018": "Merric",
    "101019": "Matthis",
    "101020": "Hardin",
    "101021": "Wolf",
    "101022": "Sedgar",
    "101023": "Roshea",
    "101024": "Vyland",
    "101025": "Wendell",
    "101026": "Rickard",
    "101027": "Bantu",
    "101028": "Caesar",
    "101029": "Radd",
    "101030": "Roger",
    "101031": "Jeorge",
    "101032": "Maria",
    "101033": "Minerva",
    "101034": "Linde",
    "101035": "Jake",
    "101036": "Midia",
    "101037": "Dolph",
    "101038": "Macellan",
    "101039": "Tomas",
    "101040": "Boah",
    "101041": "Beck",
    "101042": "Astram",
    "101043": "Palla",
    "101044": "Catria",
    "101045": "Arran",
    "101046": "Samson",
    "101047": "Xane",
    "101048": "Est",
    "101049": "Tiki",
    "101050": "Lorenz",
    "101051": "Elice",
    "101052": "Gotoh",
    "101053": "Frey",
    "101054": "Norne",
    "101055": "Athena",
    "101056": "Horace",
    "101057": "Etzel",
    "101058": "Ymir",
    "101059": "Nagi",
    "101060": "Malledus",
    "101061": "Nyna",
    "101062": "Gharnef",
    "101063": "Camus",
    "101064": "Michalis",
    "101065": "Medeus",
    "101066": "Anna",
    "102001": "Alm",
    "102002": "Lukas",
    "102003": "Gray",
    "102004": "Tobin",
    "102005": "Kliff",
    "102006": "Silque",
    "102007": "Clair",
    "102008": "Clive",
    "102009": "Forsyth",
    "102010": "Python",
    "102011": "Celica",
    "102012": "Mae",
    "102013": "Boey",
    "102014": "Genny",
    "102015": "Saber",
    "102016": "Valbar",
    "102017": "Kamui",
    "102018": "Leon",
    "102019": "Luthier",
    "102020": "Mathilda",
    "102021": "Delthea",
    "102022": "Palla",
    "102023": "Catria",
    "102024": "Atlas",
    "102025": "Jesse",
    "102026": "Deen",
    "102027": "Sonya",
    "102028": "Est",
    "102029": "Nomah",
    "102030": "Tatiana",
    "102031": "Zeke",
    "102032": "Mycen",
    "102033": "Desaix",
    "102034": "Grieth",
    "102035": "Rudolf",
    "102036": "Faye",
    "102037": "Clive",
    "102038": "Conrad",
    "102039": "Berkut",
    "102040": "Rinea",
    "102041": "Fernand",
    "102042": "Jedah",
    "102043": "Slayde",
    "102044": "Massena",
    "102045": "Lawson",
    "102046": "Jerome",
    "102047": "Tatarrah",
    "102048": "Dolth",
    "102049": "Nuibaba",
    "102050": "Hestia",
    "102051": "Marla",
    "102052": "Barth",
    "102053": "Garth",
    "102054": "Blake",
    "102055": "Mila",
    "102056": "Duma",
    "102057": "Boss (brigands)",
    "102058": "Halcyon",
    "102059": "Irma",
    "103001": "Marth",
    "103002": "Kris (homme)",
    "103003": "Kris (femme)",
    "103004": "Abel",
    "103005": "Arran",
    "103006": "Astram",
    "103007": "Bantu",
    "103008": "Barst",
    "103009": "Beck",
    "103010": "Vyland",
    "103011": "Boah",
    "103012": "Xane",
    "103013": "Darros",
    "103014": "Draug",
    "103015": "Elice",
    "103016": "Est",
    "103017": "Gotoh",
    "103018": "Gordin",
    "103020": "Jagen",
    "103021": "Jake",
    "103022": "Jeorge",
    "103023": "Julian",
    "103024": "Cain",
    "103025": "Castor",
    "103026": "Catria",
    "103027": "Cord",
    "103028": "Maria",
    "103029": "Merric",
    "103030": "Matthis",
    "103031": "Midia",
    "103032": "Minerva",
    "103033": "Macellan",
    "103034": "Navarre",
    "103035": "Ogma",
    "103036": "Palla",
    "103037": "Radd",
    "103038": "Lena",
    "103039": "Rickard",
    "103040": "Wrys",
    "103041": "Linde",
    "103042": "Roger",
    "103043": "Lorenz",
    "103044": "Roshea",
    "103045": "Bord",
    "103046": "Samson",
    "103047": "Caesar",
    "103048": "Caeda",
    "103049": "Tomas",
    "103050": "Tiki",
    "103051": "Dolph",
    "103052": "Wendell",
    "103053": "Wolf",
    "103054": "Sedgar",
    "103055": "Frey",
    "103056": "Norne",
    "103057": "Athena",
    "103058": "Horace",
    "103059": "Etzel",
    "103060": "Ymir",
    "103061": "Nagi",
    "103062": "Nyna",
    "103063": "Katarina",
    "103064": "Roderick",
    "103065": "Cecil",
    "103066": "Yuliya",
    "103067": "Jubelo",
    "103068": "Lang",
    "103069": "Hardin",
    "103070": "Luke",
    "103071": "Marisha",
    "103072": "Ryan",
    "103073": "Sirius",
    "103074": "Samuel",
    "103075": "Warren",
    "103076": "Sheena",
    "103077": "Phina",
    "103078": "Arlen",
    "103079": "Frost",
    "103080": "Malice",
    "103081": "Dice",
    "103082": "Reiden",
    "103083": "Belf",
    "103084": "Roberto",
    "103085": "Gharnef",
    "103086": "Camus",
    "103087": "Michalis",
    "103088": "Legion",
    "103089": "Clarisse",
    "103090": "Eremiya",
    "103091": "Medeus",
    "103092": "Anna",
    "104001": "Sigurd",
    "104002": "Naoise",
    "104003": "Alec",
    "104004": "Arden",
    "104005": "Midir",
    "104006": "Edain",
    "104007": "Brigid",
    "104008": "Azelle",
    "104009": "Claud",
    "104010": "Tailtiu",
    "104011": "Lex",
    "104012": "Quan",
    "104013": "Ethlyn",
    "104014": "Finn",
    "104015": "Ayra",
    "104016": "Jamke",
    "104017": "Lewyn",
    "104018": "Erinys",
    "104019": "Lachesis",
    "104020": "Seliph",
    "104021": "Oifey",
    "104022": "Shannan",
    "104023": "Ulster",
    "104024": "Larcei",
    "104025": "Lana",
    "104026": "Diarmuid",
    "104027": "Lester",
    "104028": "Leif",
    "104029": "Finn",
    "104030": "Nanna",
    "104031": "Tine",
    "104032": "Patty",
    "104033": "Febail",
    "104034": "Arthur",
    "104035": "Fee",
    "104036": "Ced",
    "104037": "Altena",
    "104038": "Hannibal",
    "104039": "Coirpre",
    "104040": "Julia",
    "104041": "Ares",
    "104042": "Lene",
    "104043": "Dalvin",
    "104044": "Creidne",
    "104045": "Muirne",
    "104046": "Tristan",
    "104047": "Deimne",
    "104048": "Jeanne",
    "104049": "Linda",
    "104050": "Daisy",
    "104051": "Asaello",
    "104052": "Amid",
    "104053": "Hermina",
    "104054": "Hawk",
    "104055": "Charlot",
    "104056": "Laylea",
    "104057": "Eldigan",
    "104058": "Cimbaeth",
    "104059": "Munnir",
    "104060": "Sandima",
    "104062": "Chagall",
    "104063": "Annand",
    "104064": "Byron",
    "104065": "Andrey",
    "104066": "Lombard",
    "104067": "Reptor",
    "104068": "Aida",
    "104069": "Arvis",
    "104070": "Danann",
    "104071": "Kutuzov",
    "104072": "Ishtore",
    "104073": "Bloom",
    "104074": "Travant",
    "104075": "Brian",
    "104076": "Scipio",
    "104077": "Hilda",
    "104078": "Ishtar",
    "104079": "Arion",
    "104080": "Manfroy",
    "104081": "Julius",
    "104082": "Dew",
    "104083": "Deirdre",
    "104084": "Chulainn",
    "104085": "Silvia",
    "104086": "Beowolf",
    "104087": "Iuchar",
    "104088": "Iucharba",
    "105001": "Leif",
    "105002": "Finn",
    "105003": "Eyvel",
    "105004": "Halvan",
    "105005": "Osian",
    "105006": "Dagdar",
    "105007": "Tanya",
    "105008": "Marty",
    "105009": "Ronan",
    "105010": "Lifis",
    "105011": "Safy",
    "105012": "Brighton",
    "105013": "Machyua",
    "105014": "Lara",
    "105015": "Fergus",
    "105016": "Karin",
    "105017": "Dalsin",
    "105018": "Asbel",
    "105019": "Nanna",
    "105020": "Hicks",
    "105021": "Shiva",
    "105022": "Carrion",
    "105023": "Selphina",
    "105024": "Cain",
    "105025": "Alva",
    "105026": "Robert",
    "105027": "Fred",
    "105028": "Olwen",
    "105029": "Mareeta",
    "105030": "Salem",
    "105031": "Perne",
    "105032": "Tina",
    "105033": "Troude",
    "105034": "Glade",
    "105035": "Deen",
    "105036": "Eda",
    "105037": "Homer",
    "105038": "Linoan",
    "105039": "Ralf",
    "105040": "Ilios",
    "105041": "Sleuf",
    "105042": "Sara",
    "105043": "Miranda",
    "105044": "Shannam",
    "105045": "Misha",
    "105046": "Xavier",
    "105047": "Amalda",
    "105048": "Conomor",
    "105049": "Diarmuid",
    "105050": "Saias",
    "105051": "Ced",
    "105052": "Galzus",
    "105053": "Kempf",
    "105054": "Reinhardt",
    "105055": "Raydrik",
    "105056": "Veld",
    "106001": "Roy",
    "106002": "Marcus",
    "106003": "Alen",
    "106004": "Lance",
    "106005": "Wolt",
    "106006": "Bors",
    "106007": "Merlinus",
    "106008": "Elen",
    "106009": "Dieck",
    "106010": "Lot",
    "106011": "Shanna",
    "106012": "Chad",
    "106013": "Lugh",
    "106014": "Clarine",
    "106015": "Rutger",
    "106016": "Saul",
    "106017": "Dorothy",
    "106018": "Sue",
    "106019": "Zelot",
    "106020": "Trec",
    "106021": "Noah",
    "106022": "Astolfo",
    "106023": "Lilina",
    "106024": "Barthe",
    "106025": "Ogier",
    "106026": "Gwendolyn",
    "106027": "Fir",
    "106028": "Sin",
    "106029": "Geese",
    "106030": "Gonzalez",
    "106031": "Klein",
    "106032": "Thea",
    "106033": "Larum",
    "106034": "Elffin",
    "106035": "Echidna",
    "106036": "Bartre",
    "106037": "Raigh",
    "106038": "Cath",
    "106039": "Melady",
    "106040": "Perceval",
    "106041": "Cecilia",
    "106042": "Sophia",
    "106043": "Igrene",
    "106044": "Garret",
    "106045": "Fae",
    "106046": "Hugh",
    "106047": "Zeiss",
    "106048": "Douglas",
    "106049": "Niime",
    "106050": "Juno",
    "106051": "Dayan",
    "106052": "Yoder",
    "106053": "Karel",
    "106054": "Narcian",
    "106055": "Galle",
    "106056": "Hector",
    "106057": "Brunnya",
    "106058": "Murdock",
    "106059": "Eliwood",
    "106060": "Zephiel",
    "106061": "Guinivere",
    "106062": "Jahn",
    "106063": "Idunn",
    "106064": "Wade",
    "107001": "Lyn",
    "107002": "Sain",
    "107003": "Kent",
    "107004": "Florina",
    "107005": "Wil",
    "107006": "Dorcas",
    "107007": "Serra",
    "107008": "Erk",
    "107009": "Rath",
    "107010": "Matthew",
    "107011": "Nils",
    "107012": "Lucius",
    "107013": "Wallace",
    "107014": "Eliwood",
    "107015": "Marcus",
    "107016": "Lowen",
    "107017": "Rebecca",
    "107018": "Bartre",
    "107019": "Hector",
    "107020": "Oswin",
    "107021": "Guy",
    "107022": "Merlinus",
    "107023": "Priscilla",
    "107024": "Raven",
    "107025": "Canas",
    "107026": "Dart",
    "107027": "Fiora",
    "107028": "Legault",
    "107029": "Ninian",
    "107030": "Isadora",
    "107031": "Heath",
    "107032": "Hawkeye",
    "107033": "Geitz",
    "107034": "Pent",
    "107035": "Louise",
    "107036": "Karel",
    "107037": "Harken",
    "107038": "Nino",
    "107039": "Jaffar",
    "107040": "Vaida",
    "107041": "Renault",
    "107042": "Athos",
    "107043": "Farina",
    "107044": "Karla",
    "107045": "Leila",
    "107046": "Guinivere",
    "107047": "Zephiel",
    "107048": "Lloyd",
    "107049": "Linus",
    "107050": "Ursula",
    "107051": "Ephidel",
    "107052": "Sonia",
    "107053": "Limstella",
    "107054": "Nergal",
    "108001": "Eirika",
    "108002": "Seth",
    "108003": "Gilliam",
    "108004": "Franz",
    "108005": "Moulder",
    "108006": "Vanessa",
    "108007": "Ross",
    "108008": "Garcia",
    "108009": "Neimi",
    "108010": "Colm",
    "108011": "Artur",
    "108012": "Lute",
    "108013": "Natasha",
    "108014": "Joshua",
    "108015": "Ephraim",
    "108016": "Forde",
    "108017": "Kyle",
    "108018": "Orson",
    "108019": "Tana",
    "108020": "Amelia",
    "108021": "Innes",
    "108022": "Gerik",
    "108023": "Tethys",
    "108024": "Marisa",
    "108025": "L'Arachel",
    "108026": "Dozla",
    "108027": "Saleh",
    "108028": "Ewan",
    "108029": "Cormag",
    "108030": "Rennac",
    "108031": "Duessel",
    "108032": "Knoll",
    "108033": "Myrrh",
    "108034": "Syrene",
    "108035": "Caellach",
    "108036": "Riev",
    "108037": "Ismaire",
    "108038": "Selena",
    "108039": "Glen",
    "108040": "Hayden",
    "108041": "Valter",
    "108042": "Fado",
    "108043": "Lyon",
    "109001": "Ike",
    "109002": "Titania",
    "109003": "Oscar",
    "109004": "Boyd",
    "109005": "Rhys",
    "109006": "Shinon",
    "109007": "Gatrie",
    "109008": "Soren",
    "109009": "Mist",
    "109010": "Rolf",
    "109011": "Greil",
    "109012": "Mia",
    "109013": "Kieran",
    "109014": "Brom",
    "109015": "Nephenee",
    "109016": "Lucia",
    "109017": "Bastian",
    "109018": "Geoffrey",
    "109019": "Elincia",
    "109020": "Renning",
    "109021": "Lethe",
    "109022": "Mordecai",
    "109023": "Muarim",
    "109024": "Ranulf",
    "109025": "Giffca",
    "109026": "Caineghis",
    "109027": "Ena",
    "109028": "Nasir",
    "109029": "Gareth",
    "109030": "Kurthnaga",
    "109031": "Dheginsea",
    "109032": "Ulki",
    "109033": "Janaff",
    "109034": "Tibarn",
    "109035": "Reyson",
    "109036": "Leanne",
    "109037": "Naesala",
    "109038": "Nealuchi",
    "109039": "Marcia",
    "109040": "Astrid",
    "109041": "Makalov",
    "109042": "Tormod",
    "109043": "Tanith",
    "109044": "Zelgius",
    "109045": "Sigrun",
    "109046": "Sephiran",
    "109047": "Sanaki",
    "109048": "Jill",
    "109049": "Tauroneo",
    "109050": "Haar",
    "109051": "Petrine",
    "109052": "Bertram",
    "109053": "Chevalier Noir",
    "109054": "Ashnard",
    "109055": "Ilyana",
    "109056": "Volke",
    "109057": "Zihark",
    "109058": "Sothe",
    "109059": "Stefan",
    "109060": "Devdan",
    "109061": "Calill",
    "109062": "Largo",
    "109063": "Elena",
    "110001": "Nolan",
    "110002": "Laura",
    "110003": "Sothe",
    "110004": "Edward",
    "110005": "Micaiah",
    "110006": "Ike",
    "110007": "Izuka",
    "110008": "Ena",
    "110009": "Ilyana",
    "110010": "Danved",
    "110011": "Ulki",
    "110012": "Elincia",
    "110013": "Oscar",
    "110014": "Oliver",
    "110015": "Volug",
    "110016": "Caineghis",
    "110017": "Gatrie",
    "110018": "Calill",
    "110019": "Kyza",
    "110020": "Rhys",
    "110021": "Kurthnaga",
    "110022": "Kieran",
    "110023": "Gareth",
    "110024": "Sanaki",
    "110025": "Sigrun",
    "110026": "Chevalier Noir",
    "110027": "Shinon",
    "110028": "Giffca",
    "110029": "Geoffrey",
    "110030": "Jill",
    "110031": "Skrimir",
    "110032": "Astrid",
    "110033": "Soren",
    "110034": "Sephiran",
    "110035": "Zelgius",
    "110036": "Stefan",
    "110037": "Tauroneo",
    "110038": "Tanith",
    "110039": "Brom",
    "110040": "Zihark",
    "110041": "Titania",
    "110042": "Tibarn",
    "110043": "Dheginsea",
    "110044": "Tormod",
    "110045": "Nasir",
    "110046": "Nealuchi",
    "110047": "Nailah",
    "110048": "Naesala",
    "110049": "Nephenee",
    "110050": "Haar",
    "110051": "Vika",
    "110052": "Volke",
    "110053": "Aran",
    "110054": "Fiona",
    "110055": "Heather",
    "110056": "Hetzel",
    "110057": "Pelleas",
    "110058": "Boyd",
    "110059": "Marcia",
    "110060": "Makalov",
    "110061": "Mist",
    "110062": "Muarim",
    "110063": "Meg",
    "110064": "Mordecai",
    "110065": "Janaff",
    "110066": "Bastian",
    "110067": "Rolf",
    "110068": "Ranulf",
    "110069": "Rafiel",
    "110070": "Leanne",
    "110071": "Lyre",
    "110072": "Reyson",
    "110073": "Lucia",
    "110074": "Leonardo",
    "110075": "Lethe",
    "110076": "Renning",
    "110077": "Mia",
    "110078": "Anna",
    "110079": "Muston",
    "110080": "Aimee",
    "110081": "Jorge",
    "110082": "Daniel",
    "110083": "Jarod",
    "110084": "Valtome",
    "110085": "Ashunera",
    "110086": "Ashera",
    "110087": "Yune",
    "110089": "Largo",
    "110090": "Amy",
    "110091": "Almedha",
    "111001": "Robin (homme)",
    "111002": "Robin (femme)",
    "111003": "Chrom",
    "111004": "Frederick",
    "111005": "Kellam",
    "111006": "Ricken",
    "111007": "Vaike",
    "111008": "Lon'qu",
    "111009": "Virion",
    "111010": "Basilio",
    "111011": "Sumia",
    "111012": "Lissa",
    "111013": "Cherche",
    "111014": "Miriel",
    "111015": "Marth (masqué)",
    "111016": "Lucina",
    "111017": "Walhart",
    "111018": "Emmeryn",
    "111019": "Validar",
    "111020": "Sully",
    "111021": "Stahl",
    "111022": "Maribelle",
    "111023": "Panne",
    "111024": "Gaius",
    "111025": "Cordelia",
    "111026": "Gregor",
    "111027": "Nowi",
    "111028": "Libra",
    "111029": "Tharja",
    "111030": "Olivia",
    "111031": "Henry",
    "111032": "Say'ri",
    "111033": "Flavia",
    "111034": "Donnel",
    "111035": "Owain",
    "111036": "Inigo",
    "111037": "Brady",
    "111038": "Kjelle",
    "111039": "Cynthia",
    "111040": "Severa",
    "111041": "Gerome",
    "111042": "Morgan (garçon)",
    "111043": "Morgan (fille)",
    "111044": "Yarne",
    "111045": "Laurent",
    "111046": "Noire",
    "111047": "Nah",
    "111048": "Tiki",
    "111049": "Anna",
    "111050": "Aversa",
    "111051": "Priam",
    "111052": "Gangrel",
    "111053": "Yen'fay",
    "111054": "Mustafa",
    "111055": "Cervantes",
    "111056": "Excellus",
    "111057": "Naga",
    "111058": "Grima",
    "112001": "Corrin (homme)",
    "112002": "Corrin (femme)",
    "112003": "Jakob",
    "112004": "Silas",
    "112005": "Kaze",
    "112006": "Ryoma",
    "112007": "Takumi",
    "112008": "Saizo",
    "112009": "Kaden",
    "112010": "Hinata",
    "112011": "Azama",
    "112012": "Subaki",
    "112013": "Hayato",
    "112014": "Xander",
    "112015": "Leo",
    "112016": "Benny",
    "112017": "Keaton",
    "112018": "Arthur",
    "112019": "Odin",
    "112020": "Laslow",
    "112021": "Niles",
    "112022": "Felicia",
    "112023": "Azura",
    "112024": "Mozu",
    "112025": "Hinoka",
    "112026": "Sakura",
    "112027": "Orochi",
    "112028": "Kagero",
    "112029": "Hana",
    "112030": "Setsuna",
    "112031": "Reina",
    "112032": "Oboro",
    "112033": "Camilla",
    "112034": "Elise",
    "112035": "Charlotte",
    "112036": "Effie",
    "112037": "Peri",
    "112038": "Beruka",
    "112039": "Selena",
    "112040": "Nyx",
    "112041": "Kana (fille)",
    "112042": "Kana (garçon)",
    "112043": "Shigure",
    "112044": "Dwyer",
    "112045": "Sophie",
    "112046": "Midori",
    "112047": "Shiro",
    "112048": "Kiragi",
    "112049": "Asugi",
    "112050": "Selkie",
    "112051": "Hisame",
    "112052": "Mitama",
    "112053": "Caeldori",
    "112054": "Rhajat",
    "112055": "Siegbert",
    "112056": "Ignatius",
    "112057": "Forrest",
    "112058": "Velouria",
    "112059": "Percy",
    "112060": "Ophelia",
    "112061": "Soleil",
    "112062": "Nina",
    "112063": "Shura",
    "112064": "Fuga",
    "112065": "Yukimura",
    "112066": "Izana",
    "112067": "Gunter",
    "112068": "Nichol",
    "112069": "Rinkah",
    "112070": "Anna",
    "112071": "Scarlet",
    "112072": "Candace",
    "112073": "Flora",
    "112074": "Lilith",
    "112075": "Arete",
    "112076": "Garon",
    "112077": "Sumeragi",
    "112078": "Mikoto",
    "112079": "Iago",
    "112080": "Zola",
    "112081": "Hans",
    "112082": "Layla",
    "112083": "Sage de l'iris",
    "112084": "Anankos",
    "113001": "Alfonse",
    "113002": "Sharena",
    "113003": "Anna",
    "113004": "Veronica",
    "113005": "Bruno",
    "113006": "Fjorm",
    "113007": "Gunnthrá",
    "113008": "Surtr",
    "113009": "Laevatein",
    "113010": "Loki",
    "113011": "Helbindi",
    "113012": "Laegjarn",
    "113013": "Ylgr",
    "113014": "Hríd",
    "113015": "Eir",
    "113016": "Líf",
    "113017": "Thrasir",
    "113018": "Hel",
    "113019": "Triandra",
    "113020": "Peony",
    "113021": "Plumeria",
    "113022": "Freyr",
    "114001": "Itsuki & Chrom",
    "114002": "Tsubasa & Caeda",
    "114003": "Touma & Cain",
    "114004": "Kiria & Tharja",
    "114005": "Yashiro & Navarre",
    "114006": "Eleonora & Virion",
    "114007": "Mamori & Draug",
    "114008": "Maiko",
    "114009": "Tiki",
    "114010": "Barry",
    "114011": "Ayaha & Aversa",
    "114012": "Chikaomi & Lon'qu",
    "114013": "Teru & Garrick",
    "114014": "Nobu & Gangrel",
    "114015": "Kuen & Excellus",
    "114016": "Yatsufusa & Gharnef",
    "114017": "Chouten & Pheros",
    "114018": "Riku & Abel",
    "115001": "Byleth (homme)",
    "115002": "Byleth (homme, prophète)",
    "115003": "Byleth (femme)",
    "115004": "Byleth (femme, prophète)",
    "115005": "Edelgard",
    "115006": "Dimitri",
    "115007": "Claude",
    "115008": "Hubert",
    "115009": "Ferdinand",
    "115010": "Linhardt",
    "115011": "Caspar",
    "115012": "Bernadetta",
    "115013": "Dorothea",
    "115014": "Petra",
    "115015": "Dedue",
    "115016": "Felix",
    "115017": "Ashe",
    "115018": "Sylvain",
    "115019": "Mercedes",
    "115020": "Annette",
    "115021": "Ingrid",
    "115022": "Lorenz",
    "115023": "Raphael",
    "115024": "Ignatz",
    "115025": "Lysithea",
    "115026": "Marianne",
    "115027": "Hilda",
    "115028": "Leonie",
    "115029": "Seteth",
    "115030": "Flayn",
    "115031": "Hanneman",
    "115032": "Manuela",
    "115033": "Gilbert",
    "115034": "Alois",
    "115035": "Catherine",
    "115036": "Shamir",
    "115037": "Cyril",
    "115038": "Jeralt",
    "115039": "Rhea",
    "115040": "Sothis",
    "115041": "Kronya",
    "115042": "Solon",
    "115043": "Chevalier Macabre",
    "115044": "Kostas",
    "115045": "Lonato",
    "115046": "Miklan",
    "115047": "Empereur des Flammes",
    "115048": "Anna",
    "115049": "Jeritza",
    "115050": "Rodrigue",
    "115051": "Judith",
    "115052": "Monica",
    "115053": "Seigneur Arundel",
    "115054": "Tomas",
    "115055": "Empereur Ionius IX",
    "115056": "Metodey",
    "115057": "Ladislava",
    "115058": "Acheron",
    "116001": "Edelgard",
    "116002": "Dimitri",
    "116003": "Claude",
    "116004": "Hubert",
    "116005": "Ferdinand",
    "116006": "Linhardt",
    "116007": "Caspar",
    "116008": "Bernadetta",
    "116009": "Dorothea",
    "116010": "Petra",
    "116011": "Dedue",
    "116012": "Felix",
    "116013": "Ashe",
    "116014": "Sylvain",
    "116015": "Mercedes",
    "116016": "Annette",
    "116017": "Ingrid",
    "116018": "Lorenz",
    "116019": "Raphael",
    "116020": "Ignatz",
    "116021": "Lysithea",
    "116022": "Marianne",
    "116023": "Hilda",
    "116024": "Leonie",
    "116025": "Cyril",
    "116026": "Thales",
    "116027": "Cornelia",
    "116028": "Randolph",
    "116029": "Nader",
    "116030": "Nemesis",
    "116031": "Seiros",
    "116032": "Duc Aegir",
    "116033": "Lambert",
    "116034": "Gwendal",
    "116035": "Pallardó"
  },
  "pt-BR": {
    "101001": "Marth",
    "101002": "Caeda",
    "101003": "Jagen",
    "101004": "Cain",
    "101005": "Abel",
    "101006": "Draug",
    "101007": "Gordin",
    "101008": "Wrys",
    "101009": "Ogma",
    "101010": "Barst",
    "101011": "Bord",
    "101012": "Cord",
    "101013": "Castor",
    "101014": "Darros",
    "101015": "Julian",
    "101016": "Lena",
    "101017": "Navarre",
    "101018": "Merric",
    "101019": "Matthis",
    "101020": "Hardin",
    "101021": "Wolf",
    "101022": "Sedgar",
    "101023": "Roshea",
    "101024": "Vyland",
    "101025": "Wendell",
    "101026": "Rickard",
    "101027": "Bantu",
    "101028": "Caesar",
    "101029": "Radd",
    "101030": "Roger",
    "101031": "Jeorge",
    "101032": "Maria",
    "101033": "Minerva",
    "101034": "Linde",
    "101035": "Jake",
    "101036": "Midia",
    "101037": "Dolph",
    "101038": "Macellan",
    "101039": "Tomas",
    "101040": "Boah",
    "101041": "Beck",
    "101042": "Astram",
    "101043": "Palla",
    "101044": "Catria",
    "101045": "Arran",
    "101046": "Samson",
    "101047": "Xane",
    "101048": "Est",
    "101049": "Tiki",
    "101050": "Lorenz",
    "101051": "Elice",
    "101052": "Gotoh",
    "101053": "Frey",
    "101054": "Norne",
    "101055": "Athena",
    "101056": "Horace",
    "101057": "Etzel",
    "101058": "Ymir",
    "101059": "Nagi",
    "101060": "Malledus",
    "101061": "Nyna",
    "101062": "Gharnef",
    "101063": "Camus",
    "101064": "Michalis",
    "101065": "Medeus",
    "101066": "Anna",
    "102001": "Alm",
    "102002": "Lukas",
    "102003": "Gray",
    "102004": "Tobin",
    "102005": "Kliff",
    "102006": "Silque",
    "102007": "Clair",
    "102008": "Clive",
    "102009": "Forsyth",
    "102010": "Python",
    "102011": "Celica",
    "102012": "Mae",
    "102013": "Boey",
    "102014": "Genny",
    "102015": "Saber",
    "102016": "Valbar",
    "102017": "Kamui",
    "102018": "Leon",
    "102019": "Luthier",
    "102020": "Mathilda",
    "102021": "Delthea",
    "102022": "Palla",
    "102023": "Catria",
    "102024": "Atlas",
    "102025": "Jesse",
    "102026": "Deen",
    "102027": "Sonya",
    "102028": "Est",
    "102029": "Nomah",
    "102030": "Tatiana",
    "102031": "Zeke",
    "102032": "Mycen",
    "102033": "Desaix",
    "102034": "Grieth",
    "102035": "Rudolf",
    "102036": "Faye",
    "102037": "Clive",
    "102038": "Conrad",
    "102039": "Berkut",
    "102040": "Rinea",
    "102041": "Fernand",
    "102042": "Jedah",
    "102043": "Slayde",
    "102044": "Massena",
    "102045": "Lawson",
    "102046": "Jerome",
    "102047": "Tatarrah",
    "102048": "Dolth",
    "102049": "Nuibaba",
    "102050": "Hestia",
    "102051": "Marla",
    "102052": "Barth",
    "102053": "Garth",
    "102054": "Blake",
    "102055": "Mila",
    "102056": "Duma",
    "102057": "Chefão",
    "102058": "Halcyon",
    "102059": "Irma",
    "103001": "Marth",
    "103002": "Kris (masculino)",
    "103003": "Kris (feminino)",
    "103004": "Abel",
    "103005": "Arran",
    "103006": "Astram",
    "103007": "Bantu",
    "103008": "Barst",
    "103009": "Beck",
    "103010": "Vyland",
    "103011": "Boah",
    "103012": "Xane",
    "103013": "Darros",
    "103014": "Draug",
    "103015": "Elice",
    "103016": "Est",
    "103017": "Gotoh",
    "103018": "Gordin",
    "103020": "Jagen",
    "103021": "Jake",
    "103022": "Jeorge",
    "103023": "Julian",
    "103024": "Cain",
    "103025": "Castor",
    "103026": "Catria",
    "103027": "Cord",
    "103028": "Maria",
    "103029": "Merric",
    "103030": "Matthis",
    "103031": "Midia",
    "103032": "Minerva",
    "103033": "Macellan",
    "103034": "Navarre",
    "103035": "Ogma",
    "103036": "Palla",
    "103037": "Radd",
    "103038": "Lena",
    "103039": "Rickard",
    "103040": "Wrys",
    "103041": "Linde",
    "103042": "Roger",
    "103043": "Lorenz",
    "103044": "Roshea",
    "103045": "Bord",
    "103046": "Samson",
    "103047": "Caesar",
    "103048": "Caeda",
    "103049": "Tomas",
    "103050": "Tiki",
    "103051": "Dolph",
    "103052": "Wendell",
    "103053": "Wolf",
    "103054": "Sedgar",
    "103055": "Frey",
    "103056": "Norne",
    "103057": "Athena",
    "103058": "Horace",
    "103059": "Etzel",
    "103060": "Ymir",
    "103061": "Nagi",
    "103062": "Nyna",
    "103063": "Katarina",
    "103064": "Roderick",
    "103065": "Cecil",
    "103066": "Yuliya",
    "103067": "Jubelo",
    "103068": "Lang",
    "103069": "Hardin",
    "103070": "Luke",
    "103071": "Marisha",
    "103072": "Ryan",
    "103073": "Sirius",
    "103074": "Samuel",
    "103075": "Warren",
    "103076": "Sheena",
    "103077": "Phina",
    "103078": "Arlen",
    "103079": "Frost",
    "103080": "Malice",
    "103081": "Dice",
    "103082": "Reiden",
    "103083": "Belf",
    "103084": "Roberto",
    "103085": "Gharnef",
    "103086": "Camus",
    "103087": "Michalis",
    "103088": "Legion",
    "103089": "Clarisse",
    "103090": "Eremiya",
    "103091": "Medeus",
    "103092": "Anna",
    "104001": "Sigurd",
    "104002": "Naoise",
    "104003": "Alec",
    "104004": "Arden",
    "104005": "Midir",
    "104006": "Edain",
    "104007": "Brigid",
    "104008": "Azelle",
    "104009": "Claud",
    "104010": "Tailtiu",
    "104011": "Lex",
    "104012": "Quan",
    "104013": "Ethlyn",
    "104014": "Finn",
    "104015": "Ayra",
    "104016": "Jamke",
    "104017": "Lewyn",
    "104018": "Erinys",
    "104019": "Lachesis",
    "104020": "Seliph",
    "104021": "Oifey",
    "104022": "Shannan",
    "104023": "Ulster",
    "104024": "Larcei",
    "104025": "Lana",
    "104026": "Diarmuid",
    "104027": "Lester",
    "104028": "Leif",
    "104029": "Finn",
    "104030": "Nanna",
    "104031": "Tine",
    "104032": "Patty",
    "104033": "Febail",
    "104034": "Arthur",
    "104035": "Fee",
    "104036": "Ced",
    "104037": "Altena",
    "104038": "Hannibal",
    "104039": "Coirpre",
    "104040": "Julia",
    "104041": "Ares",
    "104042": "Lene",
    "104043": "Dalvin",
    "104044": "Creidne",
    "104045": "Muirne",
    "104046": "Tristan",
    "104047": "Deimne",
    "104048": "Jeanne",
    "104049": "Linda",
    "104050": "Daisy",
    "104051": "Asaello",
    "104052": "Amid",
    "104053": "Hermina",
    "104054": "Hawk",
    "104055": "Charlot",
    "104056": "Laylea",
    "104057": "Eldigan",
    "104058": "Cimbaeth",
    "104059": "Munnir",
    "104060": "Sandima",
    "104062": "Chagall",
    "104063": "Annand",
    "104064": "Byron",
    "104065": "Andrey",
    "104066": "Lombard",
    "104067": "Reptor",
    "104068": "Aida",
    "104069": "Arvis",
    "104070": "Danann",
    "104071": "Kutuzov",
    "104072": "Ishtore",
    "104073": "Bloom",
    "104074": "Travant",
    "104075": "Brian",
    "104076": "Scipio",
    "104077": "Hilda",
    "104078": "Ishtar",
    "104079": "Arion",
    "104080": "Manfroy",
    "104081": "Julius",
    "104082": "Dew",
    "104083": "Deirdre",
    "104084": "Chulainn",
    "104085": "Silvia",
    "104086": "Beowolf",
    "104087": "Iuchar",
    "104088": "Iucharba",
    "105001": "Leif",
    "105002": "Finn",
    "105003": "Eyvel",
    "105004": "Halvan",
    "105005": "Osian",
    "105006": "Dagdar",
    "105007": "Tanya",
    "105008": "Marty",
    "105009": "Ronan",
    "105010": "Lifis",
    "105011": "Safy",
    "105012": "Brighton",
    "105013": "Machyua",
    "105014": "Lara",
    "105015": "Fergus",
    "105016": "Karin",
    "105017": "Dalsin",
    "105018": "Asbel",
    "105019": "Nanna",
    "105020": "Hicks",
    "105021": "Shiva",
    "105022": "Carrion",
    "105023": "Selphina",
    "105024": "Cain",
    "105025": "Alva",
    "105026": "Robert",
    "105027": "Fred",
    "105028": "Olwen",
    "105029": "Mareeta",
    "105030": "Salem",
    "105031": "Perne",
    "105032": "Tina",
    "105033": "Troude",
    "105034": "Glade",
    "105035": "Deen",
    "105036": "Eda",
    "105037": "Homer",
    "105038": "Linoan",
    "105039": "Ralf",
    "105040": "Ilios",
    "105041": "Sleuf",
    "105042": "Sara",
    "105043": "Miranda",
    "105044": "Shannam",
    "105045": "Misha",
    "105046": "Xavier",
    "105047": "Amalda",
    "105048": "Conomor",
    "105049": "Diarmuid",
    "105050": "Saias",
    "105051": "Ced",
    "105052": "Galzus",
    "105053": "Kempf",
    "105054": "Reinhardt",
    "105055": "Raydrik",
    "105056": "Veld",
    "106001": "Roy",
    "106002": "Marcus",
    "106003": "Alen",
    "106004": "Lance",
    "106005": "Wolt",
    "106006": "Bors",
    "106007": "Merlinus",
    "106008": "Elen",
    "106009": "Dieck",
    "106010": "Lot",
    "106011": "Shannia",
    "106012": "Chad",
    "106013": "Lugh",
    "106014": "Clarine",
    "106015": "Rutger",
    "106016": "Saul",
    "106017": "Dorothy",
    "106018": "Sue",
    "106019": "Zelot",
    "106020": "Trec",
    "106021": "Noah",
    "106022": "Astolfo",
    "106023": "Lilina",
    "106024": "Barthe",
    "106025": "Ogier",
    "106026": "Gwendolyn",
    "106027": "Fir",
    "106028": "Sin",
    "106029": "Geese",
    "106030": "Gonzalez",
    "106031": "Klein",
    "106032": "Thea",
    "106033": "Larum",
    "106034": "Elffin",
    "106035": "Echidna",
    "106036": "Bartre",
    "106037": "Raigh",
    "106038": "Cath",
    "106039": "Melady",
    "106040": "Perceval",
    "106041": "Cecilia",
    "106042": "Sophia",
    "106043": "Igrene",
    "106044": "Garret",
    "106045": "Fae",
    "106046": "Hugh",
    "106047": "Zeiss",
    "106048": "Douglas",
    "106049": "Niime",
    "106050": "Juno",
    "106051": "Dayan",
    "106052": "Yoder",
    "106053": "Karel",
    "106054": "Narcian",
    "106055": "Galle",
    "106056": "Hector",
    "106057": "Brunnya",
    "106058": "Murdock",
    "106059": "Eliwood",
    "106060": "Zephiel",
    "106061": "Guinivere",
    "106062": "Jahn",
    "106063": "Idunn",
    "106064": "Wade",
    "107001": "Lyn",
    "107002": "Sain",
    "107003": "Kent",
    "107004": "Florina",
    "107005": "Wil",
    "107006": "Dorcas",
    "107007": "Serra",
    "107008": "Erk",
    "107009": "Rath",
    "107010": "Matthew",
    "107011": "Nils",
    "107012": "Lucius",
    "107013": "Wallace",
    "107014": "Eliwood",
    "107015": "Marcus",
    "107016": "Lowen",
    "107017": "Rebecca",
    "107018": "Bartre",
    "107019": "Hector",
    "107020": "Oswin",
    "107021": "Guy",
    "107022": "Merlinus",
    "107023": "Priscilla",
    "107024": "Raven",
    "107025": "Canas",
    "107026": "Dart",
    "107027": "Fiora",
    "107028": "Legault",
    "107029": "Ninian",
    "107030": "Isadora",
    "107031": "Heath",
    "107032": "Hawkeye",
    "107033": "Geitz",
    "107034": "Pent",
    "107035": "Louise",
    "107036": "Karel",
    "107037": "Harken",
    "107038": "Nino",
    "107039": "Jaffar",
    "107040": "Vaida",
    "107041": "Renault",
    "107042": "Athos",
    "107043": "Farina",
    "107044": "Karla",
    "107045": "Leila",
    "107046": "Guinivere",
    "107047": "Zephiel",
    "107048": "Lloyd",
    "107049": "Linus",
    "107050": "Ursula",
    "107051": "Ephidel",
    "107052": "Sonia",
    "107053": "Limstella",
    "107054": "Nergal",
    "108001": "Eirika",
    "108002": "Seth",
    "108003": "Gilliam",
    "108004": "Franz",
    "108005": "Moulder",
    "108006": "Vanessa",
    "108007": "Ross",
    "108008": "Garcia",
    "108009": "Neimi",
    "108010": "Colm",
    "108011": "Artur",
    "108012": "Lute",
    "108013": "Natasha",
    "108014": "Joshua",
    "108015": "Ephraim",
    "108016": "Forde",
    "108017": "Kyle",
    "108018": "Orson",
    "108019": "Tana",
    "108020": "Amelia",
    "108021": "Innes",
    "108022": "Gerik",
    "108023": "Tethys",
    "108024": "Marisa",
    "108025": "L'Arachel",
    "108026": "Dozla",
    "108027": "Saleh",
    "108028": "Ewan",
    "108029": "Cormag",
    "108030": "Rennac",
    "108031": "Duessel",
    "108032": "Knoll",
    "108033": "Myrrh",
    "108034": "Syrene",
    "108035": "Caellach",
    "108036": "Riev",
    "108037": "Ismaire",
    "108038": "Selena",
    "108039": "Glen",
    "108040": "Hayden",
    "108041": "Valter",
    "108042": "Fado",
    "108043": "Lyon",
    "109001": "Ike",
    "109002": "Titania",
    "109003": "Oscar",
    "109004": "Boyd",
    "109005": "Rhys",
    "109006": "Shinon",
    "109007": "Gatrie",
    "109008": "Soren",
    "109009": "Mist",
    "109010": "Rolf",
    "109011": "Greil",
    "109012": "Mia",
    "109013": "Kieran",
    "109014": "Brom",
    "109015": "Nephenee",
    "109016": "Lucia",
    "109017": "Bastian",
    "109018": "Geoffrey",
    "109019": "Elincia",
    "109020": "Renning",
    "109021": "Lethe",
    "109022": "Mordecai",
    "109023": "Muarim",
    "109024": "Ranulf",
    "109025": "Giffca",
    "109026": "Caineghis",
    "109027": "Ena",
    "109028": "Nasir",
    "109029": "Gareth",
    "109030": "Kurthnaga",
    "109031": "Dheginsea",
    "109032": "Ulki",
    "109033": "Janaff",
    "109034": "Tibarn",
    "109035": "Reyson",
    "109036": "Leanne",
    "109037": "Naesala",
    "109038": "Nealuchi",
    "109039": "Marcia",
    "109040": "Astrid",
    "109041": "Makalov",
    "109042": "Tormod",
    "109043": "Tanith",
    "109044": "Zelgius",
    "109045": "Sigrun",
    "109046": "Sephiran",
    "109047": "Sanaki",
    "109048": "Jill",
    "109049": "Tauroneo",
    "109050": "Haar",
    "109051": "Petrine",
    "109052": "Bertram",
    "109053": "Cavaleiro Negro",
    "109054": "Ashnard",
    "109055": "Ilyana",
    "109056": "Volke",
    "109057": "Zihark",
    "109058": "Sothe",
    "109059": "Stefan",
    "109060": "Devdan",
    "109061": "Calill",
    "109062": "Largo",
    "109063": "Elena",
    "110001": "Nolan",
    "110002": "Laura",
    "110003": "Sothe",
    "110004": "Edward",
    "110005": "Micaiah",
    "110006": "Ike",
    "110007": "Izuka",
    "110008": "Ena",
    "110009": "Ilyana",
    "110010": "Danved",
    "110011": "Ulki",
    "110012": "Elincia",
    "110013": "Oscar",
    "110014": "Oliver",
    "110015": "Volug",
    "110016": "Caineghis",
    "110017": "Gatrie",
    "110018": "Calill",
    "110019": "Kyza",
    "110020": "Rhys",
    "110021": "Kurthnaga",
    "110022": "Kieran",
    "110023": "Gareth",
    "110024": "Sanaki",
    "110025": "Sigrun",
    "110026": "Cavaleiro Negro",
    "110027": "Shinon",
    "110028": "Giffca",
    "110029": "Geoffrey",
    "110030": "Jill",
    "110031": "Skrimir",
    "110032": "Astrid",
    "110033": "Soren",
    "110034": "Sephiran",
    "110035": "Zelgius",
    "110036": "Stefan",
    "110037": "Tauroneo",
    "110038": "Tanith",
    "110039": "Brom",
    "110040": "Zihark",
    "110041": "Titania",
    "110042": "Tibarn",
    "110043": "Dheginsea",
    "110044": "Tormod",
    "110045": "Nasir",
    "110046": "Nealuchi",
    "110047": "Nailah",
    "110048": "Naesala",
    "110049": "Nephenee",
    "110050": "Haar",
    "110051": "Vika",
    "110052": "Volke",
    "110053": "Aran",
    "110054": "Fiona",
    "110055": "Heather",
    "110056": "Hetzel",
    "110057": "Pelleas",
    "110058": "Boyd",
    "110059": "Marcia",
    "110060": "Makalov",
    "110061": "Mist",
    "110062": "Muarim",
    "110063": "Meg",
    "110064": "Mordecai",
    "110065": "Janaff",
    "110066": "Bastian",
    "110067": "Rolf",
    "110068": "Ranulf",
    "110069": "Rafiel",
    "110070": "Leanne",
    "110071": "Lyre",
    "110072": "Reyson",
    "110073": "Lucia",
    "110074": "Leonardo",
    "110075": "Lethe",
    "110076": "Renning",
    "110077": "Mia",
    "110078": "Anna",
    "110079": "Muston",
    "110080": "Aimee",
    "110081": "Jorge",
    "110082": "Daniel",
    "110083": "Jarod",
    "110084": "Valtome",
    "110085": "Ashunera",
    "110086": "Ashera",
    "110087": "Yune",
    "110089": "Largo",
    "110090": "Amy",
    "110091": "Almedha",
    "111001": "Robin (masculino)",
    "111002": "Robin (feminino)",
    "111003": "Chrom",
    "111004": "Frederick",
    "111005": "Kellam",
    "111006": "Ricken",
    "111007": "Vaike",
    "111008": "Lon'qu",
    "111009": "Virion",
    "111010": "Basilio",
    "111011": "Sumia",
    "111012": "Lissa",
    "111013": "Cherche",
    "111014": "Miriel",
    "111015": "Marth mascarado",
    "111016": "Lucina",
    "111017": "Walhart",
    "111018": "Emmeryn",
    "111019": "Validar",
    "111020": "Sully",
    "111021": "Stahl",
    "111022": "Maribelle",
    "111023": "Panne",
    "111024": "Gaius",
    "111025": "Cordelia",
    "111026": "Gregor",
    "111027": "Nowi",
    "111028": "Libra",
    "111029": "Tharja",
    "111030": "Olivia",
    "111031": "Henry",
    "111032": "Say'ri",
    "111033": "Flavia",
    "111034": "Donnel",
    "111035": "Owain",
    "111036": "Inigo",
    "111037": "Brady",
    "111038": "Kjelle",
    "111039": "Cynthia",
    "111040": "Severa",
    "111041": "Gerome",
    "111042": "Morgan (masculino)",
    "111043": "Morgan (feminino)",
    "111044": "Yarne",
    "111045": "Laurent",
    "111046": "Noire",
    "111047": "Nah",
    "111048": "Tiki",
    "111049": "Anna",
    "111050": "Aversa",
    "111051": "Priam",
    "111052": "Gangrel",
    "111053": "Yen'fay",
    "111054": "Mustafa",
    "111055": "Cervantes",
    "111056": "Excellus",
    "111057": "Naga",
    "111058": "Grima",
    "112001": "Corrin (masculino)",
    "112002": "Corrin (feminino)",
    "112003": "Jakob",
    "112004": "Silas",
    "112005": "Kaze",
    "112006": "Ryoma",
    "112007": "Takumi",
    "112008": "Saizo",
    "112009": "Kaden",
    "112010": "Hinata",
    "112011": "Azama",
    "112012": "Subaki",
    "112013": "Hayato",
    "112014": "Xander",
    "112015": "Leo",
    "112016": "Benny",
    "112017": "Keaton",
    "112018": "Arthur",
    "112019": "Odin",
    "112020": "Laslow",
    "112021": "Niles",
    "112022": "Felicia",
    "112023": "Azura",
    "112024": "Mozu",
    "112025": "Hinoka",
    "112026": "Sakura",
    "112027": "Orochi",
    "112028": "Kagero",
    "112029": "Hana",
    "112030": "Setsuna",
    "112031": "Reina",
    "112032": "Oboro",
    "112033": "Camilla",
    "112034": "Elise",
    "112035": "Charlotte",
    "112036": "Effie",
    "112037": "Peri",
    "112038": "Beruka",
    "112039": "Selena",
    "112040": "Nyx",
    "112041": "Kana (feminino)",
    "112042": "Kana (masculino)",
    "112043": "Shigure",
    "112044": "Dwyer",
    "112045": "Sophie",
    "112046": "Midori",
    "112047": "Shiro",
    "112048": "Kiragi",
    "112049": "Asugi",
    "112050": "Selkie",
    "112051": "Hisame",
    "112052": "Mitama",
    "112053": "Caeldori",
    "112054": "Rhajat",
    "112055": "Siegbert",
    "112056": "Ignatius",
    "112057": "Forrest",
    "112058": "Velouria",
    "112059": "Percy",
    "112060": "Ophelia",
    "112061": "Soleil",
    "112062": "Nina",
    "112063": "Shura",
    "112064": "Fuga",
    "112065": "Yukimura",
    "112066": "Izana",
    "112067": "Gunter",
    "112068": "Nichol",
    "112069": "Rinkah",
    "112070": "Anna",
    "112071": "Scarlet",
    "112072": "Candace",
    "112073": "Flora",
    "112074": "Lilith",
    "112075": "Arete",
    "112076": "Garon",
    "112077": "Sumeragi",
    "112078": "Mikoto",
    "112079": "Iago",
    "112080": "Zola",
    "112081": "Hans",
    "112082": "Layla",
    "112083": "Sábio Lúmen",
    "112084": "Anankos",
    "113001": "Alfonse",
    "113002": "Sharena",
    "113003": "Anna",
    "113004": "Veronica",
    "113005": "Bruno",
    "113006": "Fjorm",
    "113007": "Gunnthrá",
    "113008": "Surtr",
    "113009": "Laevatein",
    "113010": "Loki",
    "113011": "Helbindi",
    "113012": "Laegjarn",
    "113013": "Ylgr",
    "113014": "Hríd",
    "113015": "Eir",
    "113016": "Líf",
    "113017": "Thrasir",
    "113018": "Hel",
    "113019": "Triandra",
    "113020": "Peony",
    "113021": "Plumeria",
    "113022": "Freyr",
    "114001": "Itsuki e Chrom",
    "114002": "Tsubasa e Caeda",
    "114003": "Touma e Cain",
    "114004": "Kiria e Tharja",
    "114005": "Yashiro e Navarre",
    "114006": "Eleonora e Virion",
    "114007": "Mamori e Draug",
    "114008": "Maiko",
    "114009": "Tiki",
    "114010": "Barry",
    "114011": "Ayaha e Aversa",
    "114012": "Chikaomi e Lon'qu",
    "114013": "Teru e Garrick",
    "114014": "Nobu e Gangrel",
    "114015": "Kuen e Excellus",
    "114016": "Yatsufusa e Gharnef",
    "114017": "Chouten e Pheros",
    "114018": "Riku e Abel",
    "115001": "Byleth (masculino)",
    "115002": "Byleth (masculino, iluminado)",
    "115003": "Byleth (feminino)",
    "115004": "Byleth (feminino, iluminado)",
    "115005": "Edelgard",
    "115006": "Dimitri",
    "115007": "Claude",
    "115008": "Hubert",
    "115009": "Ferdinand",
    "115010": "Linhardt",
    "115011": "Caspar",
    "115012": "Bernadetta",
    "115013": "Dorothea",
    "115014": "Petra",
    "115015": "Dedue",
    "115016": "Felix",
    "115017": "Ashe",
    "115018": "Sylvain",
    "115019": "Mercedes",
    "115020": "Annette",
    "115021": "Ingrid",
    "115022": "Lorenz",
    "115023": "Raphael",
    "115024": "Ignatz",
    "115025": "Lysithea",
    "115026": "Marianne",
    "115027": "Hilda",
    "115028": "Leonie",
    "115029": "Seteth",
    "115030": "Flayn",
    "115031": "Hanneman",
    "115032": "Manuela",
    "115033": "Gilbert",
    "115034": "Alois",
    "115035": "Catherine",
    "115036": "Shamir",
    "115037": "Cyril",
    "115038": "Jeralt",
    "115039": "Rhea",
    "115040": "Sothis",
    "115041": "Kronya",
    "115042": "Solon",
    "115043": "Arauto da morte",
    "115044": "Kostas",
    "115045": "Lonato",
    "115046": "Miklan",
    "115047": "Imperador do fogo",
    "115048": "Anna",
    "115049": "Jeritza",
    "115050": "Rodrigue",
    "115051": "Judith",
    "115052": "Monica",
    "115053": "Lorde Arundel",
    "115054": "Tomas",
    "115055": "Imperador Ionius IX",
    "115056": "Metodey",
    "115057": "Ladislava",
    "115058": "Acheron",
    "116001": "Edelgard",
    "116002": "Dimitri",
    "116003": "Claude",
    "116004": "Hubert",
    "116005": "Ferdinand",
    "116006": "Linhardt",
    "116007": "Caspar",
    "116008": "Bernadetta",
    "116009": "Dorothea",
    "116010": "Petra",
    "116011": "Dedue",
    "116012": "Felix",
    "116013": "Ashe",
    "116014": "Sylvain",
    "116015": "Mercedes",
    "116016": "Annette",
    "116017": "Ingrid",
    "116018": "Lorenz",
    "116019": "Raphael",
    "116020": "Ignatz",
    "116021": "Lysithea",
    "116022": "Marianne",
    "116023": "Hilda",
    "116024": "Leonie",
    "116025": "Cyril",
    "116026": "Thales",
    "116027": "Cornelia",
    "116028": "Randolph",
    "116029": "Nader",
    "116030": "Nemesis",
    "116031": "Seiros",
    "116032": "Duque Aegir",
    "116033": "Lambert",
    "116034": "Gwendal",
    "116035": "Pallardó"
  }
}